/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountMappingRouteImport } from './routes/_app/account-mapping'
import { Route as AppAccountsRouteImport } from './routes/_app/accounts'
import { Route as AppApprovalsRouteRouteImport } from './routes/_app/approvals/route'
import { Route as AppAuditLogRouteImport } from './routes/_app/audit-log'
import { Route as AppBalanceSheetRouteImport } from './routes/_app/balance-sheet'
import { Route as AppBankStatementsRouteRouteImport } from './routes/_app/bank-statements/route'
import { Route as AppBooksHealthRouteImport } from './routes/_app/books-health'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppCashBankRouteImport } from './routes/_app/cash-bank'
import { Route as AppCashFlowRouteImport } from './routes/_app/cash-flow'
import { Route as AppChangePasswordRouteImport } from './routes/_app/change-password'
import { Route as AppChequesRouteRouteImport } from './routes/_app/cheques/route'
import { Route as AppCommissionsRouteRouteImport } from './routes/_app/commissions/route'
import { Route as AppCreditNotesRouteRouteImport } from './routes/_app/credit-notes/route'
import { Route as AppCustomerGroupsRouteImport } from './routes/_app/customer-groups'
import { Route as AppCustomersRouteRouteImport } from './routes/_app/customers/route'
import { Route as AppExpenseCategoriesRouteImport } from './routes/_app/expense-categories'
import { Route as AppExpensesRouteRouteImport } from './routes/_app/expenses/route'
import { Route as AppFiscalYearsRouteImport } from './routes/_app/fiscal-years'
import { Route as AppGeneralLedgerRouteImport } from './routes/_app/general-ledger'
import { Route as AppHrRouteRouteImport } from './routes/_app/hr/route'
import { Route as AppInvoicesRouteRouteImport } from './routes/_app/invoices/route'
import { Route as AppJournalEntriesRouteRouteImport } from './routes/_app/journal-entries/route'
import { Route as AppLowStockRouteImport } from './routes/_app/low-stock'
import { Route as AppLoyaltyRouteRouteImport } from './routes/_app/loyalty/route'
import { Route as AppMyWorkRouteImport } from './routes/_app/my-work'
import { Route as AppPayablesAgingRouteImport } from './routes/_app/payables-aging'
import { Route as AppPayrollRouteRouteImport } from './routes/_app/payroll/route'
import { Route as AppPosSummaryRouteImport } from './routes/_app/pos-summary'
import { Route as AppPrivacyRequestsRouteRouteImport } from './routes/_app/privacy-requests/route'
import { Route as AppProductAttributesRouteImport } from './routes/_app/product-attributes'
import { Route as AppProductCategoriesRouteImport } from './routes/_app/product-categories'
import { Route as AppProductsRouteRouteImport } from './routes/_app/products/route'
import { Route as AppProfitAndLossRouteImport } from './routes/_app/profit-and-loss'
import { Route as AppProjectBudgetVsActualRouteImport } from './routes/_app/project-budget-vs-actual'
import { Route as AppProjectProfitabilityRouteImport } from './routes/_app/project-profitability'
import { Route as AppProjectUnbilledWorkRouteImport } from './routes/_app/project-unbilled-work'
import { Route as AppProjectUtilisationRouteImport } from './routes/_app/project-utilisation'
import { Route as AppProjectsRouteRouteImport } from './routes/_app/projects/route'
import { Route as AppPurchasesRouteRouteImport } from './routes/_app/purchases/route'
import { Route as AppPurchasesByProductRouteImport } from './routes/_app/purchases-by-product'
import { Route as AppPurchasesBySupplierRouteImport } from './routes/_app/purchases-by-supplier'
import { Route as AppQuotationsRouteRouteImport } from './routes/_app/quotations/route'
import { Route as AppReceiptsRouteRouteImport } from './routes/_app/receipts/route'
import { Route as AppReceivablesAgingRouteImport } from './routes/_app/receivables-aging'
import { Route as AppRefundsRouteRouteImport } from './routes/_app/refunds/route'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppRolesRouteRouteImport } from './routes/_app/roles/route'
import { Route as AppSalesByCustomerRouteImport } from './routes/_app/sales-by-customer'
import { Route as AppSalesByPeriodRouteImport } from './routes/_app/sales-by-period'
import { Route as AppSalesByProductRouteImport } from './routes/_app/sales-by-product'
import { Route as AppSalesBySalespersonRouteImport } from './routes/_app/sales-by-salesperson'
import { Route as AppSalesByUserRouteImport } from './routes/_app/sales-by-user'
import { Route as AppSerialsRouteRouteImport } from './routes/_app/serials/route'
import { Route as AppServiceRouteRouteImport } from './routes/_app/service/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppStockRouteImport } from './routes/_app/stock'
import { Route as AppStockAdjustmentsRouteRouteImport } from './routes/_app/stock-adjustments/route'
import { Route as AppStockMovementsRouteImport } from './routes/_app/stock-movements'
import { Route as AppStockTransfersRouteRouteImport } from './routes/_app/stock-transfers/route'
import { Route as AppStockValuationRouteImport } from './routes/_app/stock-valuation'
import { Route as AppSupplierGroupsRouteImport } from './routes/_app/supplier-groups'
import { Route as AppSupplierPaymentsRouteRouteImport } from './routes/_app/supplier-payments/route'
import { Route as AppSupplierRefundsRouteRouteImport } from './routes/_app/supplier-refunds/route'
import { Route as AppSupplierReturnsRouteRouteImport } from './routes/_app/supplier-returns/route'
import { Route as AppSuppliersRouteRouteImport } from './routes/_app/suppliers/route'
import { Route as AppTaskReportRouteImport } from './routes/_app/task-report'
import { Route as AppTasksRouteRouteImport } from './routes/_app/tasks/route'
import { Route as AppTaxRatesRouteImport } from './routes/_app/tax-rates'
import { Route as AppTeamsRouteRouteImport } from './routes/_app/teams/route'
import { Route as AppTransfersRouteImport } from './routes/_app/transfers'
import { Route as AppTrialBalanceRouteImport } from './routes/_app/trial-balance'
import { Route as AppUnitsRouteImport } from './routes/_app/units'
import { Route as AppUsersRouteRouteImport } from './routes/_app/users/route'
import { Route as AppVatReturnRouteImport } from './routes/_app/vat-return'
import { Route as AppWarehousesRouteImport } from './routes/_app/warehouses'
import { Route as AppWorkflowsRouteRouteImport } from './routes/_app/workflows/route'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as PlatformConsoleRouteImport } from './routes/platform/_console'
import { Route as PlatformLoginRouteImport } from './routes/platform/login'
import { Route as SetPasswordTokenRouteImport } from './routes/set-password.$token'
import { Route as AppApprovalsIndexRouteImport } from './routes/_app/approvals/index'
import { Route as AppApprovalsRunIdRouteImport } from './routes/_app/approvals/$runId'
import { Route as AppBankStatementsIndexRouteImport } from './routes/_app/bank-statements/index'
import { Route as AppBankStatementsStatementIdRouteImport } from './routes/_app/bank-statements/$statementId'
import { Route as AppBankStatementsNewRouteImport } from './routes/_app/bank-statements/new'
import { Route as AppChequesIndexRouteImport } from './routes/_app/cheques/index'
import { Route as AppChequesChequeIdRouteRouteImport } from './routes/_app/cheques/$chequeId/route'
import { Route as AppCommissionsIndexRouteImport } from './routes/_app/commissions/index'
import { Route as AppCommissionsMineRouteRouteImport } from './routes/_app/commissions/mine/route'
import { Route as AppCommissionsPlansRouteRouteImport } from './routes/_app/commissions/plans/route'
import { Route as AppCommissionsRunsRouteRouteImport } from './routes/_app/commissions/runs/route'
import { Route as AppCommissionsStatementsRouteRouteImport } from './routes/_app/commissions/statements/route'
import { Route as AppCreditNotesIndexRouteImport } from './routes/_app/credit-notes/index'
import { Route as AppCreditNotesCreditNoteIdRouteRouteImport } from './routes/_app/credit-notes/$creditNoteId/route'
import { Route as AppCreditNotesNewRouteImport } from './routes/_app/credit-notes/new'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersCustomerIdRouteRouteImport } from './routes/_app/customers/$customerId/route'
import { Route as AppCustomersNewRouteImport } from './routes/_app/customers/new'
import { Route as AppExpensesIndexRouteImport } from './routes/_app/expenses/index'
import { Route as AppExpensesExpenseIdRouteRouteImport } from './routes/_app/expenses/$expenseId/route'
import { Route as AppExpensesNewRouteImport } from './routes/_app/expenses/new'
import { Route as AppExpensesRecurringRouteRouteImport } from './routes/_app/expenses/recurring/route'
import { Route as AppHrIndexRouteImport } from './routes/_app/hr/index'
import { Route as AppHrDocumentsRouteImport } from './routes/_app/hr/documents'
import { Route as AppHrEmployeesRouteRouteImport } from './routes/_app/hr/employees/route'
import { Route as AppHrPayComponentsRouteImport } from './routes/_app/hr/pay-components'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppInvoicesInvoiceIdRouteRouteImport } from './routes/_app/invoices/$invoiceId/route'
import { Route as AppInvoicesNewRouteImport } from './routes/_app/invoices/new'
import { Route as AppJournalEntriesIndexRouteImport } from './routes/_app/journal-entries/index'
import { Route as AppJournalEntriesEntryIdRouteImport } from './routes/_app/journal-entries/$entryId'
import { Route as AppJournalEntriesNewRouteImport } from './routes/_app/journal-entries/new'
import { Route as AppLoyaltyIndexRouteImport } from './routes/_app/loyalty/index'
import { Route as AppLoyaltyMembersRouteRouteImport } from './routes/_app/loyalty/members/route'
import { Route as AppLoyaltyProgramRouteImport } from './routes/_app/loyalty/program'
import { Route as AppLoyaltyTransactionsRouteImport } from './routes/_app/loyalty/transactions'
import { Route as AppPayrollIndexRouteImport } from './routes/_app/payroll/index'
import { Route as AppPayrollContributionsRouteImport } from './routes/_app/payroll/contributions'
import { Route as AppPayrollRunsRouteRouteImport } from './routes/_app/payroll/runs/route'
import { Route as AppPayrollSettingsRouteImport } from './routes/_app/payroll/settings'
import { Route as AppPosIndexRouteImport } from './routes/_app/pos/index'
import { Route as AppPosShiftsRouteRouteImport } from './routes/_app/pos/shifts/route'
import { Route as AppPosTillsRouteImport } from './routes/_app/pos/tills'
import { Route as AppPrivacyRequestsIndexRouteImport } from './routes/_app/privacy-requests/index'
import { Route as AppPrivacyRequestsRequestIdRouteImport } from './routes/_app/privacy-requests/$requestId'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppProductsProductIdRouteRouteImport } from './routes/_app/products/$productId/route'
import { Route as AppProductsNewRouteImport } from './routes/_app/products/new'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteRouteImport } from './routes/_app/projects/$projectId/route'
import { Route as AppProjectsCostEntriesRouteRouteImport } from './routes/_app/projects/cost-entries/route'
import { Route as AppProjectsGuaranteesRouteImport } from './routes/_app/projects/guarantees'
import { Route as AppProjectsMaterialIssuesRouteRouteImport } from './routes/_app/projects/material-issues/route'
import { Route as AppProjectsRatesRouteImport } from './routes/_app/projects/rates'
import { Route as AppProjectsReconciliationRouteImport } from './routes/_app/projects/reconciliation'
import { Route as AppProjectsStatusReportsRouteImport } from './routes/_app/projects/status-reports'
import { Route as AppPurchasesIndexRouteImport } from './routes/_app/purchases/index'
import { Route as AppPurchasesPurchaseIdRouteRouteImport } from './routes/_app/purchases/$purchaseId/route'
import { Route as AppPurchasesNewRouteImport } from './routes/_app/purchases/new'
import { Route as AppQuotationsIndexRouteImport } from './routes/_app/quotations/index'
import { Route as AppQuotationsQuotationIdRouteRouteImport } from './routes/_app/quotations/$quotationId/route'
import { Route as AppQuotationsNewRouteImport } from './routes/_app/quotations/new'
import { Route as AppReceiptsIndexRouteImport } from './routes/_app/receipts/index'
import { Route as AppReceiptsReceiptIdRouteRouteImport } from './routes/_app/receipts/$receiptId/route'
import { Route as AppReceiptsNewRouteImport } from './routes/_app/receipts/new'
import { Route as AppRefundsIndexRouteImport } from './routes/_app/refunds/index'
import { Route as AppRefundsRefundIdRouteRouteImport } from './routes/_app/refunds/$refundId/route'
import { Route as AppRefundsNewRouteImport } from './routes/_app/refunds/new'
import { Route as AppRolesIndexRouteImport } from './routes/_app/roles/index'
import { Route as AppRolesRoleIdRouteImport } from './routes/_app/roles/$roleId'
import { Route as AppRolesNewRouteImport } from './routes/_app/roles/new'
import { Route as AppSerialsIndexRouteImport } from './routes/_app/serials/index'
import { Route as AppSerialsSerialIdRouteImport } from './routes/_app/serials/$serialId'
import { Route as AppServiceIndexRouteImport } from './routes/_app/service/index'
import { Route as AppServiceAssetsRouteRouteImport } from './routes/_app/service/assets/route'
import { Route as AppServiceCollectionsRouteImport } from './routes/_app/service/collections'
import { Route as AppServiceContractsRouteRouteImport } from './routes/_app/service/contracts/route'
import { Route as AppServiceFollowUpsRouteImport } from './routes/_app/service/follow-ups'
import { Route as AppServiceJobsRouteRouteImport } from './routes/_app/service/jobs/route'
import { Route as AppServiceMyVisitsRouteImport } from './routes/_app/service/my-visits'
import { Route as AppServiceScheduleRouteImport } from './routes/_app/service/schedule'
import { Route as AppServiceSitesRouteRouteImport } from './routes/_app/service/sites/route'
import { Route as AppServiceVisitsRouteRouteImport } from './routes/_app/service/visits/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAccountMappingRouteImport } from './routes/_app/settings/account-mapping'
import { Route as AppSettingsAccountingChecksRouteImport } from './routes/_app/settings/accounting-checks'
import { Route as AppSettingsAppearanceRouteImport } from './routes/_app/settings/appearance'
import { Route as AppSettingsCalendarRouteImport } from './routes/_app/settings/calendar'
import { Route as AppSettingsCommissionsRouteImport } from './routes/_app/settings/commissions'
import { Route as AppSettingsCompanyRouteImport } from './routes/_app/settings/company'
import { Route as AppSettingsContractsRouteImport } from './routes/_app/settings/contracts'
import { Route as AppSettingsDefaultsRouteImport } from './routes/_app/settings/defaults'
import { Route as AppSettingsLegalHoldsRouteImport } from './routes/_app/settings/legal-holds'
import { Route as AppSettingsLockDateRouteImport } from './routes/_app/settings/lock-date'
import { Route as AppSettingsMessageOutboxRouteImport } from './routes/_app/settings/message-outbox'
import { Route as AppSettingsMessageTemplatesRouteImport } from './routes/_app/settings/message-templates'
import { Route as AppSettingsModulesRouteImport } from './routes/_app/settings/modules'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsNumberingRouteImport } from './routes/_app/settings/numbering'
import { Route as AppSettingsOrganizationRouteImport } from './routes/_app/settings/organization'
import { Route as AppSettingsPaymentMethodsRouteImport } from './routes/_app/settings/payment-methods'
import { Route as AppSettingsPrintingRouteImport } from './routes/_app/settings/printing'
import { Route as AppSettingsPrivacyRouteImport } from './routes/_app/settings/privacy'
import { Route as AppSettingsProjectContractingRouteImport } from './routes/_app/settings/project-contracting'
import { Route as AppSettingsProjectCostCategoriesRouteImport } from './routes/_app/settings/project-cost-categories'
import { Route as AppSettingsProjectInsightsRouteImport } from './routes/_app/settings/project-insights'
import { Route as AppSettingsProjectRateRolesRouteImport } from './routes/_app/settings/project-rate-roles'
import { Route as AppSettingsProjectTypesRouteImport } from './routes/_app/settings/project-types'
import { Route as AppSettingsProjectsRouteImport } from './routes/_app/settings/projects'
import { Route as AppSettingsRegionalRouteImport } from './routes/_app/settings/regional'
import { Route as AppSettingsServiceRouteImport } from './routes/_app/settings/service'
import { Route as AppSettingsServiceAssetTypesRouteImport } from './routes/_app/settings/service-asset-types'
import { Route as AppSettingsServiceSiteTemplatesRouteImport } from './routes/_app/settings/service-site-templates'
import { Route as AppSettingsStockPolicyRouteImport } from './routes/_app/settings/stock-policy'
import { Route as AppSettingsSystemRouteImport } from './routes/_app/settings/system'
import { Route as AppSettingsTasksRouteImport } from './routes/_app/settings/tasks'
import { Route as AppSettingsTaxRatesRouteImport } from './routes/_app/settings/tax-rates'
import { Route as AppSettingsTeamsRouteImport } from './routes/_app/settings/teams'
import { Route as AppSettingsTypographyRouteImport } from './routes/_app/settings/typography'
import { Route as AppSettingsWorkLocationsRouteImport } from './routes/_app/settings/work-locations'
import { Route as AppStockAdjustmentsIndexRouteImport } from './routes/_app/stock-adjustments/index'
import { Route as AppStockAdjustmentsAdjustmentIdRouteImport } from './routes/_app/stock-adjustments/$adjustmentId'
import { Route as AppStockAdjustmentsNewRouteImport } from './routes/_app/stock-adjustments/new'
import { Route as AppStockTransfersIndexRouteImport } from './routes/_app/stock-transfers/index'
import { Route as AppStockTransfersTransferIdRouteRouteImport } from './routes/_app/stock-transfers/$transferId/route'
import { Route as AppStockTransfersNewRouteImport } from './routes/_app/stock-transfers/new'
import { Route as AppSupplierPaymentsIndexRouteImport } from './routes/_app/supplier-payments/index'
import { Route as AppSupplierPaymentsPaymentIdRouteRouteImport } from './routes/_app/supplier-payments/$paymentId/route'
import { Route as AppSupplierPaymentsNewRouteImport } from './routes/_app/supplier-payments/new'
import { Route as AppSupplierRefundsIndexRouteImport } from './routes/_app/supplier-refunds/index'
import { Route as AppSupplierRefundsRefundIdRouteRouteImport } from './routes/_app/supplier-refunds/$refundId/route'
import { Route as AppSupplierRefundsNewRouteImport } from './routes/_app/supplier-refunds/new'
import { Route as AppSupplierReturnsIndexRouteImport } from './routes/_app/supplier-returns/index'
import { Route as AppSupplierReturnsReturnIdRouteRouteImport } from './routes/_app/supplier-returns/$returnId/route'
import { Route as AppSupplierReturnsNewRouteImport } from './routes/_app/supplier-returns/new'
import { Route as AppSuppliersIndexRouteImport } from './routes/_app/suppliers/index'
import { Route as AppSuppliersSupplierIdRouteRouteImport } from './routes/_app/suppliers/$supplierId/route'
import { Route as AppSuppliersNewRouteImport } from './routes/_app/suppliers/new'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks/index'
import { Route as AppTasksTaskIdRouteImport } from './routes/_app/tasks/$taskId'
import { Route as AppTeamsIndexRouteImport } from './routes/_app/teams/index'
import { Route as AppTeamsTeamIdRouteImport } from './routes/_app/teams/$teamId'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users/$userId'
import { Route as AppUsersNewRouteImport } from './routes/_app/users/new'
import { Route as AppWorkflowsIndexRouteImport } from './routes/_app/workflows/index'
import { Route as AppWorkflowsWorkflowIdRouteImport } from './routes/_app/workflows/$workflowId'
import { Route as AppWorkflowsDelegationsRouteImport } from './routes/_app/workflows/delegations'
import { Route as AppWorkflowsRunsRouteRouteImport } from './routes/_app/workflows/runs/route'
import { Route as PlatformConsoleIndexRouteImport } from './routes/platform/_console/index'
import { Route as PlatformConsoleDashboardRouteImport } from './routes/platform/_console/dashboard'
import { Route as PlatformConsoleFeedbackRouteImport } from './routes/platform/_console/feedback'
import { Route as PlatformConsoleProfileRouteImport } from './routes/platform/_console/profile'
import { Route as PlatformConsoleSubscriptionsRouteImport } from './routes/platform/_console/subscriptions'
import { Route as AppChequesChequeIdIndexRouteImport } from './routes/_app/cheques/$chequeId/index'
import { Route as AppCommissionsMineIndexRouteImport } from './routes/_app/commissions/mine/index'
import { Route as AppCommissionsMineStatementIdRouteImport } from './routes/_app/commissions/mine/$statementId'
import { Route as AppCommissionsPlansIndexRouteImport } from './routes/_app/commissions/plans/index'
import { Route as AppCommissionsPlansPlanIdRouteImport } from './routes/_app/commissions/plans/$planId'
import { Route as AppCommissionsPlansNewRouteImport } from './routes/_app/commissions/plans/new'
import { Route as AppCommissionsRunsIndexRouteImport } from './routes/_app/commissions/runs/index'
import { Route as AppCommissionsRunsRunIdRouteImport } from './routes/_app/commissions/runs/$runId'
import { Route as AppCommissionsStatementsStatementIdRouteImport } from './routes/_app/commissions/statements/$statementId'
import { Route as AppCreditNotesCreditNoteIdIndexRouteImport } from './routes/_app/credit-notes/$creditNoteId/index'
import { Route as AppCreditNotesCreditNoteIdEditRouteImport } from './routes/_app/credit-notes/$creditNoteId/edit'
import { Route as AppCreditNotesCreditNoteIdPrintRouteImport } from './routes/_app/credit-notes/$creditNoteId/print'
import { Route as AppCustomersCustomerIdIndexRouteImport } from './routes/_app/customers/$customerId/index'
import { Route as AppCustomersCustomerIdEditRouteImport } from './routes/_app/customers/$customerId/edit'
import { Route as AppExpensesExpenseIdIndexRouteImport } from './routes/_app/expenses/$expenseId/index'
import { Route as AppExpensesExpenseIdEditRouteImport } from './routes/_app/expenses/$expenseId/edit'
import { Route as AppExpensesRecurringIndexRouteImport } from './routes/_app/expenses/recurring/index'
import { Route as AppExpensesRecurringRecurringIdRouteRouteImport } from './routes/_app/expenses/recurring/$recurringId/route'
import { Route as AppExpensesRecurringNewRouteImport } from './routes/_app/expenses/recurring/new'
import { Route as AppHrEmployeesIndexRouteImport } from './routes/_app/hr/employees/index'
import { Route as AppHrEmployeesEmployeeIdRouteRouteImport } from './routes/_app/hr/employees/$employeeId/route'
import { Route as AppHrEmployeesNewRouteImport } from './routes/_app/hr/employees/new'
import { Route as AppInvoicesInvoiceIdIndexRouteImport } from './routes/_app/invoices/$invoiceId/index'
import { Route as AppInvoicesInvoiceIdEditRouteImport } from './routes/_app/invoices/$invoiceId/edit'
import { Route as AppInvoicesInvoiceIdPrintRouteImport } from './routes/_app/invoices/$invoiceId/print'
import { Route as AppLoyaltyMembersIndexRouteImport } from './routes/_app/loyalty/members/index'
import { Route as AppLoyaltyMembersMemberIdRouteImport } from './routes/_app/loyalty/members/$memberId'
import { Route as AppPayrollRunsIndexRouteImport } from './routes/_app/payroll/runs/index'
import { Route as AppPayrollRunsRunIdRouteRouteImport } from './routes/_app/payroll/runs/$runId/route'
import { Route as AppPosReturnsReturnIdRouteImport } from './routes/_app/pos/returns/$returnId'
import { Route as AppPosSalesSaleIdRouteImport } from './routes/_app/pos/sales/$saleId'
import { Route as AppPosShiftsIndexRouteImport } from './routes/_app/pos/shifts/index'
import { Route as AppPosShiftsShiftIdRouteImport } from './routes/_app/pos/shifts/$shiftId'
import { Route as AppProductsProductIdIndexRouteImport } from './routes/_app/products/$productId/index'
import { Route as AppProductsProductIdEditRouteImport } from './routes/_app/products/$productId/edit'
import { Route as AppProductsProductIdLabelsRouteImport } from './routes/_app/products/$productId/labels'
import { Route as AppProjectsProjectIdIndexRouteImport } from './routes/_app/projects/$projectId/index'
import { Route as AppProjectsCostEntriesIndexRouteImport } from './routes/_app/projects/cost-entries/index'
import { Route as AppProjectsCostEntriesEntryIdRouteImport } from './routes/_app/projects/cost-entries/$entryId'
import { Route as AppProjectsMaterialIssuesIndexRouteImport } from './routes/_app/projects/material-issues/index'
import { Route as AppProjectsMaterialIssuesIssueIdRouteImport } from './routes/_app/projects/material-issues/$issueId'
import { Route as AppProjectsTimeIndexRouteImport } from './routes/_app/projects/time/index'
import { Route as AppProjectsTimeApprovalsRouteImport } from './routes/_app/projects/time/approvals'
import { Route as AppPurchasesPurchaseIdIndexRouteImport } from './routes/_app/purchases/$purchaseId/index'
import { Route as AppPurchasesPurchaseIdEditRouteImport } from './routes/_app/purchases/$purchaseId/edit'
import { Route as AppPurchasesPurchaseIdPrintRouteImport } from './routes/_app/purchases/$purchaseId/print'
import { Route as AppQuotationsQuotationIdIndexRouteImport } from './routes/_app/quotations/$quotationId/index'
import { Route as AppQuotationsQuotationIdEditRouteImport } from './routes/_app/quotations/$quotationId/edit'
import { Route as AppQuotationsQuotationIdPrintRouteImport } from './routes/_app/quotations/$quotationId/print'
import { Route as AppReceiptsReceiptIdIndexRouteImport } from './routes/_app/receipts/$receiptId/index'
import { Route as AppReceiptsReceiptIdPrintRouteImport } from './routes/_app/receipts/$receiptId/print'
import { Route as AppRefundsRefundIdIndexRouteImport } from './routes/_app/refunds/$refundId/index'
import { Route as AppRefundsRefundIdPrintRouteImport } from './routes/_app/refunds/$refundId/print'
import { Route as AppServiceAssetsIndexRouteImport } from './routes/_app/service/assets/index'
import { Route as AppServiceAssetsAssetIdRouteImport } from './routes/_app/service/assets/$assetId'
import { Route as AppServiceAssetsLabelsRouteImport } from './routes/_app/service/assets/labels'
import { Route as AppServiceContractsIndexRouteImport } from './routes/_app/service/contracts/index'
import { Route as AppServiceContractsContractIdRouteRouteImport } from './routes/_app/service/contracts/$contractId/route'
import { Route as AppServiceContractsBillingRouteImport } from './routes/_app/service/contracts/billing'
import { Route as AppServiceContractsInsightsRouteImport } from './routes/_app/service/contracts/insights'
import { Route as AppServiceContractsNewRouteImport } from './routes/_app/service/contracts/new'
import { Route as AppServiceJobsIndexRouteImport } from './routes/_app/service/jobs/index'
import { Route as AppServiceJobsJobIdRouteRouteImport } from './routes/_app/service/jobs/$jobId/route'
import { Route as AppServiceSitesIndexRouteImport } from './routes/_app/service/sites/index'
import { Route as AppServiceSitesSiteIdRouteImport } from './routes/_app/service/sites/$siteId'
import { Route as AppServiceVisitsIndexRouteImport } from './routes/_app/service/visits/index'
import { Route as AppServiceVisitsVisitIdRouteRouteImport } from './routes/_app/service/visits/$visitId/route'
import { Route as AppSettingsAiIndexRouteImport } from './routes/_app/settings/ai/index'
import { Route as AppSettingsAiUsageRouteImport } from './routes/_app/settings/ai/usage'
import { Route as AppStockTransfersTransferIdIndexRouteImport } from './routes/_app/stock-transfers/$transferId/index'
import { Route as AppStockTransfersTransferIdEditRouteImport } from './routes/_app/stock-transfers/$transferId/edit'
import { Route as AppStockTransfersTransferIdPrintRouteImport } from './routes/_app/stock-transfers/$transferId/print'
import { Route as AppSupplierPaymentsPaymentIdIndexRouteImport } from './routes/_app/supplier-payments/$paymentId/index'
import { Route as AppSupplierPaymentsPaymentIdPrintRouteImport } from './routes/_app/supplier-payments/$paymentId/print'
import { Route as AppSupplierRefundsRefundIdIndexRouteImport } from './routes/_app/supplier-refunds/$refundId/index'
import { Route as AppSupplierRefundsRefundIdPrintRouteImport } from './routes/_app/supplier-refunds/$refundId/print'
import { Route as AppSupplierReturnsReturnIdIndexRouteImport } from './routes/_app/supplier-returns/$returnId/index'
import { Route as AppSupplierReturnsReturnIdEditRouteImport } from './routes/_app/supplier-returns/$returnId/edit'
import { Route as AppSupplierReturnsReturnIdPrintRouteImport } from './routes/_app/supplier-returns/$returnId/print'
import { Route as AppSuppliersSupplierIdIndexRouteImport } from './routes/_app/suppliers/$supplierId/index'
import { Route as AppSuppliersSupplierIdEditRouteImport } from './routes/_app/suppliers/$supplierId/edit'
import { Route as AppWorkflowsRunsIndexRouteImport } from './routes/_app/workflows/runs/index'
import { Route as AppWorkflowsRunsRunIdRouteImport } from './routes/_app/workflows/runs/$runId'
import { Route as PlatformConsoleTenantsIndexRouteImport } from './routes/platform/_console/tenants/index'
import { Route as PlatformConsoleTenantsTenantIdRouteImport } from './routes/platform/_console/tenants/$tenantId'
import { Route as PlatformConsoleTenantsNewRouteImport } from './routes/platform/_console/tenants/new'
import { Route as AppExpensesRecurringRecurringIdIndexRouteImport } from './routes/_app/expenses/recurring/$recurringId/index'
import { Route as AppExpensesRecurringRecurringIdEditRouteImport } from './routes/_app/expenses/recurring/$recurringId/edit'
import { Route as AppHrEmployeesEmployeeIdIndexRouteImport } from './routes/_app/hr/employees/$employeeId/index'
import { Route as AppHrEmployeesEmployeeIdEditRouteImport } from './routes/_app/hr/employees/$employeeId/edit'
import { Route as AppPayrollRunsRunIdIndexRouteImport } from './routes/_app/payroll/runs/$runId/index'
import { Route as AppProjectsProjectIdContractStatementRouteImport } from './routes/_app/projects/$projectId/contract/statement'
import { Route as AppProjectsProjectIdReportsIndexRouteImport } from './routes/_app/projects/$projectId/reports/index'
import { Route as AppServiceContractsContractIdIndexRouteImport } from './routes/_app/service/contracts/$contractId/index'
import { Route as AppServiceContractsContractIdEditRouteImport } from './routes/_app/service/contracts/$contractId/edit'
import { Route as AppServiceContractsContractIdPrintRouteImport } from './routes/_app/service/contracts/$contractId/print'
import { Route as AppServiceJobsJobIdIndexRouteImport } from './routes/_app/service/jobs/$jobId/index'
import { Route as AppServiceJobsJobIdEstimateRouteImport } from './routes/_app/service/jobs/$jobId/estimate'
import { Route as AppServiceVisitsVisitIdIndexRouteImport } from './routes/_app/service/visits/$visitId/index'
import { Route as AppServiceVisitsVisitIdReportRouteImport } from './routes/_app/service/visits/$visitId/report'
import { Route as AppPayrollRunsRunIdPayslipsPayslipIdRouteImport } from './routes/_app/payroll/runs/$runId/payslips/$payslipId'
import { Route as AppProjectsProjectIdClaimsClaimIdIndexRouteImport } from './routes/_app/projects/$projectId/claims/$claimId/index'
import { Route as AppProjectsProjectIdClaimsClaimIdPrintRouteImport } from './routes/_app/projects/$projectId/claims/$claimId/print'
import { Route as AppProjectsProjectIdReportsReportIdIndexRouteImport } from './routes/_app/projects/$projectId/reports/$reportId/index'
import { Route as AppProjectsProjectIdReportsReportIdPrintRouteImport } from './routes/_app/projects/$projectId/reports/$reportId/print'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountMappingRoute = AppAccountMappingRouteImport.update({
  id: '/account-mapping',
  path: '/account-mapping',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRouteRoute = AppApprovalsRouteRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditLogRoute = AppAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AppRoute,
} as any)
const AppBalanceSheetRoute = AppBalanceSheetRouteImport.update({
  id: '/balance-sheet',
  path: '/balance-sheet',
  getParentRoute: () => AppRoute,
} as any)
const AppBankStatementsRouteRoute = AppBankStatementsRouteRouteImport.update({
  id: '/bank-statements',
  path: '/bank-statements',
  getParentRoute: () => AppRoute,
} as any)
const AppBooksHealthRoute = AppBooksHealthRouteImport.update({
  id: '/books-health',
  path: '/books-health',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppCashBankRoute = AppCashBankRouteImport.update({
  id: '/cash-bank',
  path: '/cash-bank',
  getParentRoute: () => AppRoute,
} as any)
const AppCashFlowRoute = AppCashFlowRouteImport.update({
  id: '/cash-flow',
  path: '/cash-flow',
  getParentRoute: () => AppRoute,
} as any)
const AppChangePasswordRoute = AppChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AppRoute,
} as any)
const AppChequesRouteRoute = AppChequesRouteRouteImport.update({
  id: '/cheques',
  path: '/cheques',
  getParentRoute: () => AppRoute,
} as any)
const AppCommissionsRouteRoute = AppCommissionsRouteRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => AppRoute,
} as any)
const AppCreditNotesRouteRoute = AppCreditNotesRouteRouteImport.update({
  id: '/credit-notes',
  path: '/credit-notes',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomerGroupsRoute = AppCustomerGroupsRouteImport.update({
  id: '/customer-groups',
  path: '/customer-groups',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRouteRoute = AppCustomersRouteRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppExpenseCategoriesRoute = AppExpenseCategoriesRouteImport.update({
  id: '/expense-categories',
  path: '/expense-categories',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesRouteRoute = AppExpensesRouteRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppFiscalYearsRoute = AppFiscalYearsRouteImport.update({
  id: '/fiscal-years',
  path: '/fiscal-years',
  getParentRoute: () => AppRoute,
} as any)
const AppGeneralLedgerRoute = AppGeneralLedgerRouteImport.update({
  id: '/general-ledger',
  path: '/general-ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppHrRouteRoute = AppHrRouteRouteImport.update({
  id: '/hr',
  path: '/hr',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesRouteRoute = AppInvoicesRouteRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppJournalEntriesRouteRoute = AppJournalEntriesRouteRouteImport.update({
  id: '/journal-entries',
  path: '/journal-entries',
  getParentRoute: () => AppRoute,
} as any)
const AppLowStockRoute = AppLowStockRouteImport.update({
  id: '/low-stock',
  path: '/low-stock',
  getParentRoute: () => AppRoute,
} as any)
const AppLoyaltyRouteRoute = AppLoyaltyRouteRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => AppRoute,
} as any)
const AppMyWorkRoute = AppMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AppRoute,
} as any)
const AppPayablesAgingRoute = AppPayablesAgingRouteImport.update({
  id: '/payables-aging',
  path: '/payables-aging',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollRouteRoute = AppPayrollRouteRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AppRoute,
} as any)
const AppPosSummaryRoute = AppPosSummaryRouteImport.update({
  id: '/pos-summary',
  path: '/pos-summary',
  getParentRoute: () => AppRoute,
} as any)
const AppPrivacyRequestsRouteRoute = AppPrivacyRequestsRouteRouteImport.update({
  id: '/privacy-requests',
  path: '/privacy-requests',
  getParentRoute: () => AppRoute,
} as any)
const AppProductAttributesRoute = AppProductAttributesRouteImport.update({
  id: '/product-attributes',
  path: '/product-attributes',
  getParentRoute: () => AppRoute,
} as any)
const AppProductCategoriesRoute = AppProductCategoriesRouteImport.update({
  id: '/product-categories',
  path: '/product-categories',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRouteRoute = AppProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppProfitAndLossRoute = AppProfitAndLossRouteImport.update({
  id: '/profit-and-loss',
  path: '/profit-and-loss',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectBudgetVsActualRoute =
  AppProjectBudgetVsActualRouteImport.update({
    id: '/project-budget-vs-actual',
    path: '/project-budget-vs-actual',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectProfitabilityRoute = AppProjectProfitabilityRouteImport.update({
  id: '/project-profitability',
  path: '/project-profitability',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectUnbilledWorkRoute = AppProjectUnbilledWorkRouteImport.update({
  id: '/project-unbilled-work',
  path: '/project-unbilled-work',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectUtilisationRoute = AppProjectUtilisationRouteImport.update({
  id: '/project-utilisation',
  path: '/project-utilisation',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRouteRoute = AppProjectsRouteRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasesRouteRoute = AppPurchasesRouteRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasesByProductRoute = AppPurchasesByProductRouteImport.update({
  id: '/purchases-by-product',
  path: '/purchases-by-product',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasesBySupplierRoute = AppPurchasesBySupplierRouteImport.update({
  id: '/purchases-by-supplier',
  path: '/purchases-by-supplier',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotationsRouteRoute = AppQuotationsRouteRouteImport.update({
  id: '/quotations',
  path: '/quotations',
  getParentRoute: () => AppRoute,
} as any)
const AppReceiptsRouteRoute = AppReceiptsRouteRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => AppRoute,
} as any)
const AppReceivablesAgingRoute = AppReceivablesAgingRouteImport.update({
  id: '/receivables-aging',
  path: '/receivables-aging',
  getParentRoute: () => AppRoute,
} as any)
const AppRefundsRouteRoute = AppRefundsRouteRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppRolesRouteRoute = AppRolesRouteRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesByCustomerRoute = AppSalesByCustomerRouteImport.update({
  id: '/sales-by-customer',
  path: '/sales-by-customer',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesByPeriodRoute = AppSalesByPeriodRouteImport.update({
  id: '/sales-by-period',
  path: '/sales-by-period',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesByProductRoute = AppSalesByProductRouteImport.update({
  id: '/sales-by-product',
  path: '/sales-by-product',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesBySalespersonRoute = AppSalesBySalespersonRouteImport.update({
  id: '/sales-by-salesperson',
  path: '/sales-by-salesperson',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesByUserRoute = AppSalesByUserRouteImport.update({
  id: '/sales-by-user',
  path: '/sales-by-user',
  getParentRoute: () => AppRoute,
} as any)
const AppSerialsRouteRoute = AppSerialsRouteRouteImport.update({
  id: '/serials',
  path: '/serials',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceRouteRoute = AppServiceRouteRouteImport.update({
  id: '/service',
  path: '/service',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppStockRoute = AppStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AppRoute,
} as any)
const AppStockAdjustmentsRouteRoute =
  AppStockAdjustmentsRouteRouteImport.update({
    id: '/stock-adjustments',
    path: '/stock-adjustments',
    getParentRoute: () => AppRoute,
  } as any)
const AppStockMovementsRoute = AppStockMovementsRouteImport.update({
  id: '/stock-movements',
  path: '/stock-movements',
  getParentRoute: () => AppRoute,
} as any)
const AppStockTransfersRouteRoute = AppStockTransfersRouteRouteImport.update({
  id: '/stock-transfers',
  path: '/stock-transfers',
  getParentRoute: () => AppRoute,
} as any)
const AppStockValuationRoute = AppStockValuationRouteImport.update({
  id: '/stock-valuation',
  path: '/stock-valuation',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierGroupsRoute = AppSupplierGroupsRouteImport.update({
  id: '/supplier-groups',
  path: '/supplier-groups',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierPaymentsRouteRoute =
  AppSupplierPaymentsRouteRouteImport.update({
    id: '/supplier-payments',
    path: '/supplier-payments',
    getParentRoute: () => AppRoute,
  } as any)
const AppSupplierRefundsRouteRoute = AppSupplierRefundsRouteRouteImport.update({
  id: '/supplier-refunds',
  path: '/supplier-refunds',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierReturnsRouteRoute = AppSupplierReturnsRouteRouteImport.update({
  id: '/supplier-returns',
  path: '/supplier-returns',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersRouteRoute = AppSuppliersRouteRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => AppRoute,
} as any)
const AppTaskReportRoute = AppTaskReportRouteImport.update({
  id: '/task-report',
  path: '/task-report',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRouteRoute = AppTasksRouteRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppTaxRatesRoute = AppTaxRatesRouteImport.update({
  id: '/tax-rates',
  path: '/tax-rates',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamsRouteRoute = AppTeamsRouteRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersRoute = AppTransfersRouteImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => AppRoute,
} as any)
const AppTrialBalanceRoute = AppTrialBalanceRouteImport.update({
  id: '/trial-balance',
  path: '/trial-balance',
  getParentRoute: () => AppRoute,
} as any)
const AppUnitsRoute = AppUnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRouteRoute = AppUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppVatReturnRoute = AppVatReturnRouteImport.update({
  id: '/vat-return',
  path: '/vat-return',
  getParentRoute: () => AppRoute,
} as any)
const AppWarehousesRoute = AppWarehousesRouteImport.update({
  id: '/warehouses',
  path: '/warehouses',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkflowsRouteRoute = AppWorkflowsRouteRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AppRoute,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformConsoleRoute = PlatformConsoleRouteImport.update({
  id: '/platform/_console',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformLoginRoute = PlatformLoginRouteImport.update({
  id: '/platform/login',
  path: '/platform/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordTokenRoute = SetPasswordTokenRouteImport.update({
  id: '/set-password/$token',
  path: '/set-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppApprovalsIndexRoute = AppApprovalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppApprovalsRouteRoute,
} as any)
const AppApprovalsRunIdRoute = AppApprovalsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => AppApprovalsRouteRoute,
} as any)
const AppBankStatementsIndexRoute = AppBankStatementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBankStatementsRouteRoute,
} as any)
const AppBankStatementsStatementIdRoute =
  AppBankStatementsStatementIdRouteImport.update({
    id: '/$statementId',
    path: '/$statementId',
    getParentRoute: () => AppBankStatementsRouteRoute,
  } as any)
const AppBankStatementsNewRoute = AppBankStatementsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppBankStatementsRouteRoute,
} as any)
const AppChequesIndexRoute = AppChequesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChequesRouteRoute,
} as any)
const AppChequesChequeIdRouteRoute = AppChequesChequeIdRouteRouteImport.update({
  id: '/$chequeId',
  path: '/$chequeId',
  getParentRoute: () => AppChequesRouteRoute,
} as any)
const AppCommissionsIndexRoute = AppCommissionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCommissionsRouteRoute,
} as any)
const AppCommissionsMineRouteRoute = AppCommissionsMineRouteRouteImport.update({
  id: '/mine',
  path: '/mine',
  getParentRoute: () => AppCommissionsRouteRoute,
} as any)
const AppCommissionsPlansRouteRoute =
  AppCommissionsPlansRouteRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AppCommissionsRouteRoute,
  } as any)
const AppCommissionsRunsRouteRoute = AppCommissionsRunsRouteRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AppCommissionsRouteRoute,
} as any)
const AppCommissionsStatementsRouteRoute =
  AppCommissionsStatementsRouteRouteImport.update({
    id: '/statements',
    path: '/statements',
    getParentRoute: () => AppCommissionsRouteRoute,
  } as any)
const AppCreditNotesIndexRoute = AppCreditNotesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCreditNotesRouteRoute,
} as any)
const AppCreditNotesCreditNoteIdRouteRoute =
  AppCreditNotesCreditNoteIdRouteRouteImport.update({
    id: '/$creditNoteId',
    path: '/$creditNoteId',
    getParentRoute: () => AppCreditNotesRouteRoute,
  } as any)
const AppCreditNotesNewRoute = AppCreditNotesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppCreditNotesRouteRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomersRouteRoute,
} as any)
const AppCustomersCustomerIdRouteRoute =
  AppCustomersCustomerIdRouteRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => AppCustomersRouteRoute,
  } as any)
const AppCustomersNewRoute = AppCustomersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppCustomersRouteRoute,
} as any)
const AppExpensesIndexRoute = AppExpensesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppExpensesRouteRoute,
} as any)
const AppExpensesExpenseIdRouteRoute =
  AppExpensesExpenseIdRouteRouteImport.update({
    id: '/$expenseId',
    path: '/$expenseId',
    getParentRoute: () => AppExpensesRouteRoute,
  } as any)
const AppExpensesNewRoute = AppExpensesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppExpensesRouteRoute,
} as any)
const AppExpensesRecurringRouteRoute =
  AppExpensesRecurringRouteRouteImport.update({
    id: '/recurring',
    path: '/recurring',
    getParentRoute: () => AppExpensesRouteRoute,
  } as any)
const AppHrIndexRoute = AppHrIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHrRouteRoute,
} as any)
const AppHrDocumentsRoute = AppHrDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppHrRouteRoute,
} as any)
const AppHrEmployeesRouteRoute = AppHrEmployeesRouteRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AppHrRouteRoute,
} as any)
const AppHrPayComponentsRoute = AppHrPayComponentsRouteImport.update({
  id: '/pay-components',
  path: '/pay-components',
  getParentRoute: () => AppHrRouteRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInvoicesRouteRoute,
} as any)
const AppInvoicesInvoiceIdRouteRoute =
  AppInvoicesInvoiceIdRouteRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => AppInvoicesRouteRoute,
  } as any)
const AppInvoicesNewRoute = AppInvoicesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppInvoicesRouteRoute,
} as any)
const AppJournalEntriesIndexRoute = AppJournalEntriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppJournalEntriesRouteRoute,
} as any)
const AppJournalEntriesEntryIdRoute =
  AppJournalEntriesEntryIdRouteImport.update({
    id: '/$entryId',
    path: '/$entryId',
    getParentRoute: () => AppJournalEntriesRouteRoute,
  } as any)
const AppJournalEntriesNewRoute = AppJournalEntriesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppJournalEntriesRouteRoute,
} as any)
const AppLoyaltyIndexRoute = AppLoyaltyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLoyaltyRouteRoute,
} as any)
const AppLoyaltyMembersRouteRoute = AppLoyaltyMembersRouteRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppLoyaltyRouteRoute,
} as any)
const AppLoyaltyProgramRoute = AppLoyaltyProgramRouteImport.update({
  id: '/program',
  path: '/program',
  getParentRoute: () => AppLoyaltyRouteRoute,
} as any)
const AppLoyaltyTransactionsRoute = AppLoyaltyTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppLoyaltyRouteRoute,
} as any)
const AppPayrollIndexRoute = AppPayrollIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPayrollRouteRoute,
} as any)
const AppPayrollContributionsRoute = AppPayrollContributionsRouteImport.update({
  id: '/contributions',
  path: '/contributions',
  getParentRoute: () => AppPayrollRouteRoute,
} as any)
const AppPayrollRunsRouteRoute = AppPayrollRunsRouteRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AppPayrollRouteRoute,
} as any)
const AppPayrollSettingsRoute = AppPayrollSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppPayrollRouteRoute,
} as any)
const AppPosIndexRoute = AppPosIndexRouteImport.update({
  id: '/pos/',
  path: '/pos/',
  getParentRoute: () => AppRoute,
} as any)
const AppPosShiftsRouteRoute = AppPosShiftsRouteRouteImport.update({
  id: '/pos/shifts',
  path: '/pos/shifts',
  getParentRoute: () => AppRoute,
} as any)
const AppPosTillsRoute = AppPosTillsRouteImport.update({
  id: '/pos/tills',
  path: '/pos/tills',
  getParentRoute: () => AppRoute,
} as any)
const AppPrivacyRequestsIndexRoute = AppPrivacyRequestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPrivacyRequestsRouteRoute,
} as any)
const AppPrivacyRequestsRequestIdRoute =
  AppPrivacyRequestsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => AppPrivacyRequestsRouteRoute,
  } as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProductsRouteRoute,
} as any)
const AppProductsProductIdRouteRoute =
  AppProductsProductIdRouteRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AppProductsRouteRoute,
  } as any)
const AppProductsNewRoute = AppProductsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppProductsRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsProjectIdRouteRoute =
  AppProjectsProjectIdRouteRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsCostEntriesRouteRoute =
  AppProjectsCostEntriesRouteRouteImport.update({
    id: '/cost-entries',
    path: '/cost-entries',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsGuaranteesRoute = AppProjectsGuaranteesRouteImport.update({
  id: '/guarantees',
  path: '/guarantees',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsMaterialIssuesRouteRoute =
  AppProjectsMaterialIssuesRouteRouteImport.update({
    id: '/material-issues',
    path: '/material-issues',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsRatesRoute = AppProjectsRatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsReconciliationRoute =
  AppProjectsReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsStatusReportsRoute =
  AppProjectsStatusReportsRouteImport.update({
    id: '/status-reports',
    path: '/status-reports',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppPurchasesIndexRoute = AppPurchasesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPurchasesRouteRoute,
} as any)
const AppPurchasesPurchaseIdRouteRoute =
  AppPurchasesPurchaseIdRouteRouteImport.update({
    id: '/$purchaseId',
    path: '/$purchaseId',
    getParentRoute: () => AppPurchasesRouteRoute,
  } as any)
const AppPurchasesNewRoute = AppPurchasesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppPurchasesRouteRoute,
} as any)
const AppQuotationsIndexRoute = AppQuotationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppQuotationsRouteRoute,
} as any)
const AppQuotationsQuotationIdRouteRoute =
  AppQuotationsQuotationIdRouteRouteImport.update({
    id: '/$quotationId',
    path: '/$quotationId',
    getParentRoute: () => AppQuotationsRouteRoute,
  } as any)
const AppQuotationsNewRoute = AppQuotationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppQuotationsRouteRoute,
} as any)
const AppReceiptsIndexRoute = AppReceiptsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReceiptsRouteRoute,
} as any)
const AppReceiptsReceiptIdRouteRoute =
  AppReceiptsReceiptIdRouteRouteImport.update({
    id: '/$receiptId',
    path: '/$receiptId',
    getParentRoute: () => AppReceiptsRouteRoute,
  } as any)
const AppReceiptsNewRoute = AppReceiptsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppReceiptsRouteRoute,
} as any)
const AppRefundsIndexRoute = AppRefundsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRefundsRouteRoute,
} as any)
const AppRefundsRefundIdRouteRoute = AppRefundsRefundIdRouteRouteImport.update({
  id: '/$refundId',
  path: '/$refundId',
  getParentRoute: () => AppRefundsRouteRoute,
} as any)
const AppRefundsNewRoute = AppRefundsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRefundsRouteRoute,
} as any)
const AppRolesIndexRoute = AppRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRolesRouteRoute,
} as any)
const AppRolesRoleIdRoute = AppRolesRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => AppRolesRouteRoute,
} as any)
const AppRolesNewRoute = AppRolesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRolesRouteRoute,
} as any)
const AppSerialsIndexRoute = AppSerialsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSerialsRouteRoute,
} as any)
const AppSerialsSerialIdRoute = AppSerialsSerialIdRouteImport.update({
  id: '/$serialId',
  path: '/$serialId',
  getParentRoute: () => AppSerialsRouteRoute,
} as any)
const AppServiceIndexRoute = AppServiceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceAssetsRouteRoute = AppServiceAssetsRouteRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceCollectionsRoute = AppServiceCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceContractsRouteRoute =
  AppServiceContractsRouteRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => AppServiceRouteRoute,
  } as any)
const AppServiceFollowUpsRoute = AppServiceFollowUpsRouteImport.update({
  id: '/follow-ups',
  path: '/follow-ups',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceJobsRouteRoute = AppServiceJobsRouteRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceMyVisitsRoute = AppServiceMyVisitsRouteImport.update({
  id: '/my-visits',
  path: '/my-visits',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceScheduleRoute = AppServiceScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceSitesRouteRoute = AppServiceSitesRouteRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppServiceVisitsRouteRoute = AppServiceVisitsRouteRouteImport.update({
  id: '/visits',
  path: '/visits',
  getParentRoute: () => AppServiceRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAccountMappingRoute =
  AppSettingsAccountMappingRouteImport.update({
    id: '/account-mapping',
    path: '/account-mapping',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAccountingChecksRoute =
  AppSettingsAccountingChecksRouteImport.update({
    id: '/accounting-checks',
    path: '/accounting-checks',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAppearanceRoute = AppSettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCalendarRoute = AppSettingsCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCommissionsRoute = AppSettingsCommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCompanyRoute = AppSettingsCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsContractsRoute = AppSettingsContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDefaultsRoute = AppSettingsDefaultsRouteImport.update({
  id: '/defaults',
  path: '/defaults',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsLegalHoldsRoute = AppSettingsLegalHoldsRouteImport.update({
  id: '/legal-holds',
  path: '/legal-holds',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsLockDateRoute = AppSettingsLockDateRouteImport.update({
  id: '/lock-date',
  path: '/lock-date',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMessageOutboxRoute =
  AppSettingsMessageOutboxRouteImport.update({
    id: '/message-outbox',
    path: '/message-outbox',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsMessageTemplatesRoute =
  AppSettingsMessageTemplatesRouteImport.update({
    id: '/message-templates',
    path: '/message-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsModulesRoute = AppSettingsModulesRouteImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsNumberingRoute = AppSettingsNumberingRouteImport.update({
  id: '/numbering',
  path: '/numbering',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOrganizationRoute = AppSettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPaymentMethodsRoute =
  AppSettingsPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPrintingRoute = AppSettingsPrintingRouteImport.update({
  id: '/printing',
  path: '/printing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsProjectContractingRoute =
  AppSettingsProjectContractingRouteImport.update({
    id: '/project-contracting',
    path: '/project-contracting',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsProjectCostCategoriesRoute =
  AppSettingsProjectCostCategoriesRouteImport.update({
    id: '/project-cost-categories',
    path: '/project-cost-categories',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsProjectInsightsRoute =
  AppSettingsProjectInsightsRouteImport.update({
    id: '/project-insights',
    path: '/project-insights',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsProjectRateRolesRoute =
  AppSettingsProjectRateRolesRouteImport.update({
    id: '/project-rate-roles',
    path: '/project-rate-roles',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsProjectTypesRoute = AppSettingsProjectTypesRouteImport.update({
  id: '/project-types',
  path: '/project-types',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsProjectsRoute = AppSettingsProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsRegionalRoute = AppSettingsRegionalRouteImport.update({
  id: '/regional',
  path: '/regional',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsServiceRoute = AppSettingsServiceRouteImport.update({
  id: '/service',
  path: '/service',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsServiceAssetTypesRoute =
  AppSettingsServiceAssetTypesRouteImport.update({
    id: '/service-asset-types',
    path: '/service-asset-types',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsServiceSiteTemplatesRoute =
  AppSettingsServiceSiteTemplatesRouteImport.update({
    id: '/service-site-templates',
    path: '/service-site-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsStockPolicyRoute = AppSettingsStockPolicyRouteImport.update({
  id: '/stock-policy',
  path: '/stock-policy',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsSystemRoute = AppSettingsSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTasksRoute = AppSettingsTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTaxRatesRoute = AppSettingsTaxRatesRouteImport.update({
  id: '/tax-rates',
  path: '/tax-rates',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamsRoute = AppSettingsTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTypographyRoute = AppSettingsTypographyRouteImport.update({
  id: '/typography',
  path: '/typography',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsWorkLocationsRoute =
  AppSettingsWorkLocationsRouteImport.update({
    id: '/work-locations',
    path: '/work-locations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppStockAdjustmentsIndexRoute =
  AppStockAdjustmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockAdjustmentsRouteRoute,
  } as any)
const AppStockAdjustmentsAdjustmentIdRoute =
  AppStockAdjustmentsAdjustmentIdRouteImport.update({
    id: '/$adjustmentId',
    path: '/$adjustmentId',
    getParentRoute: () => AppStockAdjustmentsRouteRoute,
  } as any)
const AppStockAdjustmentsNewRoute = AppStockAdjustmentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppStockAdjustmentsRouteRoute,
} as any)
const AppStockTransfersIndexRoute = AppStockTransfersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStockTransfersRouteRoute,
} as any)
const AppStockTransfersTransferIdRouteRoute =
  AppStockTransfersTransferIdRouteRouteImport.update({
    id: '/$transferId',
    path: '/$transferId',
    getParentRoute: () => AppStockTransfersRouteRoute,
  } as any)
const AppStockTransfersNewRoute = AppStockTransfersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppStockTransfersRouteRoute,
} as any)
const AppSupplierPaymentsIndexRoute =
  AppSupplierPaymentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSupplierPaymentsRouteRoute,
  } as any)
const AppSupplierPaymentsPaymentIdRouteRoute =
  AppSupplierPaymentsPaymentIdRouteRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => AppSupplierPaymentsRouteRoute,
  } as any)
const AppSupplierPaymentsNewRoute = AppSupplierPaymentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppSupplierPaymentsRouteRoute,
} as any)
const AppSupplierRefundsIndexRoute = AppSupplierRefundsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSupplierRefundsRouteRoute,
} as any)
const AppSupplierRefundsRefundIdRouteRoute =
  AppSupplierRefundsRefundIdRouteRouteImport.update({
    id: '/$refundId',
    path: '/$refundId',
    getParentRoute: () => AppSupplierRefundsRouteRoute,
  } as any)
const AppSupplierRefundsNewRoute = AppSupplierRefundsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppSupplierRefundsRouteRoute,
} as any)
const AppSupplierReturnsIndexRoute = AppSupplierReturnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSupplierReturnsRouteRoute,
} as any)
const AppSupplierReturnsReturnIdRouteRoute =
  AppSupplierReturnsReturnIdRouteRouteImport.update({
    id: '/$returnId',
    path: '/$returnId',
    getParentRoute: () => AppSupplierReturnsRouteRoute,
  } as any)
const AppSupplierReturnsNewRoute = AppSupplierReturnsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppSupplierReturnsRouteRoute,
} as any)
const AppSuppliersIndexRoute = AppSuppliersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSuppliersRouteRoute,
} as any)
const AppSuppliersSupplierIdRouteRoute =
  AppSuppliersSupplierIdRouteRouteImport.update({
    id: '/$supplierId',
    path: '/$supplierId',
    getParentRoute: () => AppSuppliersRouteRoute,
  } as any)
const AppSuppliersNewRoute = AppSuppliersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppSuppliersRouteRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTasksRouteRoute,
} as any)
const AppTasksTaskIdRoute = AppTasksTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => AppTasksRouteRoute,
} as any)
const AppTeamsIndexRoute = AppTeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTeamsRouteRoute,
} as any)
const AppTeamsTeamIdRoute = AppTeamsTeamIdRouteImport.update({
  id: '/$teamId',
  path: '/$teamId',
  getParentRoute: () => AppTeamsRouteRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersNewRoute = AppUsersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppWorkflowsIndexRoute = AppWorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkflowsRouteRoute,
} as any)
const AppWorkflowsWorkflowIdRoute = AppWorkflowsWorkflowIdRouteImport.update({
  id: '/$workflowId',
  path: '/$workflowId',
  getParentRoute: () => AppWorkflowsRouteRoute,
} as any)
const AppWorkflowsDelegationsRoute = AppWorkflowsDelegationsRouteImport.update({
  id: '/delegations',
  path: '/delegations',
  getParentRoute: () => AppWorkflowsRouteRoute,
} as any)
const AppWorkflowsRunsRouteRoute = AppWorkflowsRunsRouteRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AppWorkflowsRouteRoute,
} as any)
const PlatformConsoleIndexRoute = PlatformConsoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformConsoleRoute,
} as any)
const PlatformConsoleDashboardRoute =
  PlatformConsoleDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => PlatformConsoleRoute,
  } as any)
const PlatformConsoleFeedbackRoute = PlatformConsoleFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => PlatformConsoleRoute,
} as any)
const PlatformConsoleProfileRoute = PlatformConsoleProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PlatformConsoleRoute,
} as any)
const PlatformConsoleSubscriptionsRoute =
  PlatformConsoleSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => PlatformConsoleRoute,
  } as any)
const AppChequesChequeIdIndexRoute = AppChequesChequeIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChequesChequeIdRouteRoute,
} as any)
const AppCommissionsMineIndexRoute = AppCommissionsMineIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCommissionsMineRouteRoute,
} as any)
const AppCommissionsMineStatementIdRoute =
  AppCommissionsMineStatementIdRouteImport.update({
    id: '/$statementId',
    path: '/$statementId',
    getParentRoute: () => AppCommissionsMineRouteRoute,
  } as any)
const AppCommissionsPlansIndexRoute =
  AppCommissionsPlansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCommissionsPlansRouteRoute,
  } as any)
const AppCommissionsPlansPlanIdRoute =
  AppCommissionsPlansPlanIdRouteImport.update({
    id: '/$planId',
    path: '/$planId',
    getParentRoute: () => AppCommissionsPlansRouteRoute,
  } as any)
const AppCommissionsPlansNewRoute = AppCommissionsPlansNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppCommissionsPlansRouteRoute,
} as any)
const AppCommissionsRunsIndexRoute = AppCommissionsRunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCommissionsRunsRouteRoute,
} as any)
const AppCommissionsRunsRunIdRoute = AppCommissionsRunsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => AppCommissionsRunsRouteRoute,
} as any)
const AppCommissionsStatementsStatementIdRoute =
  AppCommissionsStatementsStatementIdRouteImport.update({
    id: '/$statementId',
    path: '/$statementId',
    getParentRoute: () => AppCommissionsStatementsRouteRoute,
  } as any)
const AppCreditNotesCreditNoteIdIndexRoute =
  AppCreditNotesCreditNoteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreditNotesCreditNoteIdRouteRoute,
  } as any)
const AppCreditNotesCreditNoteIdEditRoute =
  AppCreditNotesCreditNoteIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppCreditNotesCreditNoteIdRouteRoute,
  } as any)
const AppCreditNotesCreditNoteIdPrintRoute =
  AppCreditNotesCreditNoteIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppCreditNotesCreditNoteIdRouteRoute,
  } as any)
const AppCustomersCustomerIdIndexRoute =
  AppCustomersCustomerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCustomersCustomerIdRouteRoute,
  } as any)
const AppCustomersCustomerIdEditRoute =
  AppCustomersCustomerIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppCustomersCustomerIdRouteRoute,
  } as any)
const AppExpensesExpenseIdIndexRoute =
  AppExpensesExpenseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppExpensesExpenseIdRouteRoute,
  } as any)
const AppExpensesExpenseIdEditRoute =
  AppExpensesExpenseIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppExpensesExpenseIdRouteRoute,
  } as any)
const AppExpensesRecurringIndexRoute =
  AppExpensesRecurringIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppExpensesRecurringRouteRoute,
  } as any)
const AppExpensesRecurringRecurringIdRouteRoute =
  AppExpensesRecurringRecurringIdRouteRouteImport.update({
    id: '/$recurringId',
    path: '/$recurringId',
    getParentRoute: () => AppExpensesRecurringRouteRoute,
  } as any)
const AppExpensesRecurringNewRoute = AppExpensesRecurringNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppExpensesRecurringRouteRoute,
} as any)
const AppHrEmployeesIndexRoute = AppHrEmployeesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHrEmployeesRouteRoute,
} as any)
const AppHrEmployeesEmployeeIdRouteRoute =
  AppHrEmployeesEmployeeIdRouteRouteImport.update({
    id: '/$employeeId',
    path: '/$employeeId',
    getParentRoute: () => AppHrEmployeesRouteRoute,
  } as any)
const AppHrEmployeesNewRoute = AppHrEmployeesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppHrEmployeesRouteRoute,
} as any)
const AppInvoicesInvoiceIdIndexRoute =
  AppInvoicesInvoiceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInvoicesInvoiceIdRouteRoute,
  } as any)
const AppInvoicesInvoiceIdEditRoute =
  AppInvoicesInvoiceIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppInvoicesInvoiceIdRouteRoute,
  } as any)
const AppInvoicesInvoiceIdPrintRoute =
  AppInvoicesInvoiceIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppInvoicesInvoiceIdRouteRoute,
  } as any)
const AppLoyaltyMembersIndexRoute = AppLoyaltyMembersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLoyaltyMembersRouteRoute,
} as any)
const AppLoyaltyMembersMemberIdRoute =
  AppLoyaltyMembersMemberIdRouteImport.update({
    id: '/$memberId',
    path: '/$memberId',
    getParentRoute: () => AppLoyaltyMembersRouteRoute,
  } as any)
const AppPayrollRunsIndexRoute = AppPayrollRunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPayrollRunsRouteRoute,
} as any)
const AppPayrollRunsRunIdRouteRoute =
  AppPayrollRunsRunIdRouteRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AppPayrollRunsRouteRoute,
  } as any)
const AppPosReturnsReturnIdRoute = AppPosReturnsReturnIdRouteImport.update({
  id: '/pos/returns/$returnId',
  path: '/pos/returns/$returnId',
  getParentRoute: () => AppRoute,
} as any)
const AppPosSalesSaleIdRoute = AppPosSalesSaleIdRouteImport.update({
  id: '/pos/sales/$saleId',
  path: '/pos/sales/$saleId',
  getParentRoute: () => AppRoute,
} as any)
const AppPosShiftsIndexRoute = AppPosShiftsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPosShiftsRouteRoute,
} as any)
const AppPosShiftsShiftIdRoute = AppPosShiftsShiftIdRouteImport.update({
  id: '/$shiftId',
  path: '/$shiftId',
  getParentRoute: () => AppPosShiftsRouteRoute,
} as any)
const AppProductsProductIdIndexRoute =
  AppProductsProductIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProductsProductIdRouteRoute,
  } as any)
const AppProductsProductIdEditRoute =
  AppProductsProductIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppProductsProductIdRouteRoute,
  } as any)
const AppProductsProductIdLabelsRoute =
  AppProductsProductIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => AppProductsProductIdRouteRoute,
  } as any)
const AppProjectsProjectIdIndexRoute =
  AppProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppProjectsCostEntriesIndexRoute =
  AppProjectsCostEntriesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsCostEntriesRouteRoute,
  } as any)
const AppProjectsCostEntriesEntryIdRoute =
  AppProjectsCostEntriesEntryIdRouteImport.update({
    id: '/$entryId',
    path: '/$entryId',
    getParentRoute: () => AppProjectsCostEntriesRouteRoute,
  } as any)
const AppProjectsMaterialIssuesIndexRoute =
  AppProjectsMaterialIssuesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsMaterialIssuesRouteRoute,
  } as any)
const AppProjectsMaterialIssuesIssueIdRoute =
  AppProjectsMaterialIssuesIssueIdRouteImport.update({
    id: '/$issueId',
    path: '/$issueId',
    getParentRoute: () => AppProjectsMaterialIssuesRouteRoute,
  } as any)
const AppProjectsTimeIndexRoute = AppProjectsTimeIndexRouteImport.update({
  id: '/time/',
  path: '/time/',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsTimeApprovalsRoute =
  AppProjectsTimeApprovalsRouteImport.update({
    id: '/time/approvals',
    path: '/time/approvals',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppPurchasesPurchaseIdIndexRoute =
  AppPurchasesPurchaseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPurchasesPurchaseIdRouteRoute,
  } as any)
const AppPurchasesPurchaseIdEditRoute =
  AppPurchasesPurchaseIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppPurchasesPurchaseIdRouteRoute,
  } as any)
const AppPurchasesPurchaseIdPrintRoute =
  AppPurchasesPurchaseIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppPurchasesPurchaseIdRouteRoute,
  } as any)
const AppQuotationsQuotationIdIndexRoute =
  AppQuotationsQuotationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppQuotationsQuotationIdRouteRoute,
  } as any)
const AppQuotationsQuotationIdEditRoute =
  AppQuotationsQuotationIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppQuotationsQuotationIdRouteRoute,
  } as any)
const AppQuotationsQuotationIdPrintRoute =
  AppQuotationsQuotationIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppQuotationsQuotationIdRouteRoute,
  } as any)
const AppReceiptsReceiptIdIndexRoute =
  AppReceiptsReceiptIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppReceiptsReceiptIdRouteRoute,
  } as any)
const AppReceiptsReceiptIdPrintRoute =
  AppReceiptsReceiptIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppReceiptsReceiptIdRouteRoute,
  } as any)
const AppRefundsRefundIdIndexRoute = AppRefundsRefundIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRefundsRefundIdRouteRoute,
} as any)
const AppRefundsRefundIdPrintRoute = AppRefundsRefundIdPrintRouteImport.update({
  id: '/print',
  path: '/print',
  getParentRoute: () => AppRefundsRefundIdRouteRoute,
} as any)
const AppServiceAssetsIndexRoute = AppServiceAssetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppServiceAssetsRouteRoute,
} as any)
const AppServiceAssetsAssetIdRoute = AppServiceAssetsAssetIdRouteImport.update({
  id: '/$assetId',
  path: '/$assetId',
  getParentRoute: () => AppServiceAssetsRouteRoute,
} as any)
const AppServiceAssetsLabelsRoute = AppServiceAssetsLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => AppServiceAssetsRouteRoute,
} as any)
const AppServiceContractsIndexRoute =
  AppServiceContractsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppServiceContractsRouteRoute,
  } as any)
const AppServiceContractsContractIdRouteRoute =
  AppServiceContractsContractIdRouteRouteImport.update({
    id: '/$contractId',
    path: '/$contractId',
    getParentRoute: () => AppServiceContractsRouteRoute,
  } as any)
const AppServiceContractsBillingRoute =
  AppServiceContractsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppServiceContractsRouteRoute,
  } as any)
const AppServiceContractsInsightsRoute =
  AppServiceContractsInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AppServiceContractsRouteRoute,
  } as any)
const AppServiceContractsNewRoute = AppServiceContractsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppServiceContractsRouteRoute,
} as any)
const AppServiceJobsIndexRoute = AppServiceJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppServiceJobsRouteRoute,
} as any)
const AppServiceJobsJobIdRouteRoute =
  AppServiceJobsJobIdRouteRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => AppServiceJobsRouteRoute,
  } as any)
const AppServiceSitesIndexRoute = AppServiceSitesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppServiceSitesRouteRoute,
} as any)
const AppServiceSitesSiteIdRoute = AppServiceSitesSiteIdRouteImport.update({
  id: '/$siteId',
  path: '/$siteId',
  getParentRoute: () => AppServiceSitesRouteRoute,
} as any)
const AppServiceVisitsIndexRoute = AppServiceVisitsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppServiceVisitsRouteRoute,
} as any)
const AppServiceVisitsVisitIdRouteRoute =
  AppServiceVisitsVisitIdRouteRouteImport.update({
    id: '/$visitId',
    path: '/$visitId',
    getParentRoute: () => AppServiceVisitsRouteRoute,
  } as any)
const AppSettingsAiIndexRoute = AppSettingsAiIndexRouteImport.update({
  id: '/ai/',
  path: '/ai/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAiUsageRoute = AppSettingsAiUsageRouteImport.update({
  id: '/ai/usage',
  path: '/ai/usage',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppStockTransfersTransferIdIndexRoute =
  AppStockTransfersTransferIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockTransfersTransferIdRouteRoute,
  } as any)
const AppStockTransfersTransferIdEditRoute =
  AppStockTransfersTransferIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppStockTransfersTransferIdRouteRoute,
  } as any)
const AppStockTransfersTransferIdPrintRoute =
  AppStockTransfersTransferIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppStockTransfersTransferIdRouteRoute,
  } as any)
const AppSupplierPaymentsPaymentIdIndexRoute =
  AppSupplierPaymentsPaymentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSupplierPaymentsPaymentIdRouteRoute,
  } as any)
const AppSupplierPaymentsPaymentIdPrintRoute =
  AppSupplierPaymentsPaymentIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppSupplierPaymentsPaymentIdRouteRoute,
  } as any)
const AppSupplierRefundsRefundIdIndexRoute =
  AppSupplierRefundsRefundIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSupplierRefundsRefundIdRouteRoute,
  } as any)
const AppSupplierRefundsRefundIdPrintRoute =
  AppSupplierRefundsRefundIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppSupplierRefundsRefundIdRouteRoute,
  } as any)
const AppSupplierReturnsReturnIdIndexRoute =
  AppSupplierReturnsReturnIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSupplierReturnsReturnIdRouteRoute,
  } as any)
const AppSupplierReturnsReturnIdEditRoute =
  AppSupplierReturnsReturnIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppSupplierReturnsReturnIdRouteRoute,
  } as any)
const AppSupplierReturnsReturnIdPrintRoute =
  AppSupplierReturnsReturnIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppSupplierReturnsReturnIdRouteRoute,
  } as any)
const AppSuppliersSupplierIdIndexRoute =
  AppSuppliersSupplierIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSuppliersSupplierIdRouteRoute,
  } as any)
const AppSuppliersSupplierIdEditRoute =
  AppSuppliersSupplierIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppSuppliersSupplierIdRouteRoute,
  } as any)
const AppWorkflowsRunsIndexRoute = AppWorkflowsRunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkflowsRunsRouteRoute,
} as any)
const AppWorkflowsRunsRunIdRoute = AppWorkflowsRunsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => AppWorkflowsRunsRouteRoute,
} as any)
const PlatformConsoleTenantsIndexRoute =
  PlatformConsoleTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => PlatformConsoleRoute,
  } as any)
const PlatformConsoleTenantsTenantIdRoute =
  PlatformConsoleTenantsTenantIdRouteImport.update({
    id: '/tenants/$tenantId',
    path: '/tenants/$tenantId',
    getParentRoute: () => PlatformConsoleRoute,
  } as any)
const PlatformConsoleTenantsNewRoute =
  PlatformConsoleTenantsNewRouteImport.update({
    id: '/tenants/new',
    path: '/tenants/new',
    getParentRoute: () => PlatformConsoleRoute,
  } as any)
const AppExpensesRecurringRecurringIdIndexRoute =
  AppExpensesRecurringRecurringIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppExpensesRecurringRecurringIdRouteRoute,
  } as any)
const AppExpensesRecurringRecurringIdEditRoute =
  AppExpensesRecurringRecurringIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppExpensesRecurringRecurringIdRouteRoute,
  } as any)
const AppHrEmployeesEmployeeIdIndexRoute =
  AppHrEmployeesEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppHrEmployeesEmployeeIdRouteRoute,
  } as any)
const AppHrEmployeesEmployeeIdEditRoute =
  AppHrEmployeesEmployeeIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppHrEmployeesEmployeeIdRouteRoute,
  } as any)
const AppPayrollRunsRunIdIndexRoute =
  AppPayrollRunsRunIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPayrollRunsRunIdRouteRoute,
  } as any)
const AppProjectsProjectIdContractStatementRoute =
  AppProjectsProjectIdContractStatementRouteImport.update({
    id: '/contract/statement',
    path: '/contract/statement',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppProjectsProjectIdReportsIndexRoute =
  AppProjectsProjectIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppServiceContractsContractIdIndexRoute =
  AppServiceContractsContractIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppServiceContractsContractIdRouteRoute,
  } as any)
const AppServiceContractsContractIdEditRoute =
  AppServiceContractsContractIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppServiceContractsContractIdRouteRoute,
  } as any)
const AppServiceContractsContractIdPrintRoute =
  AppServiceContractsContractIdPrintRouteImport.update({
    id: '/print',
    path: '/print',
    getParentRoute: () => AppServiceContractsContractIdRouteRoute,
  } as any)
const AppServiceJobsJobIdIndexRoute =
  AppServiceJobsJobIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppServiceJobsJobIdRouteRoute,
  } as any)
const AppServiceJobsJobIdEstimateRoute =
  AppServiceJobsJobIdEstimateRouteImport.update({
    id: '/estimate',
    path: '/estimate',
    getParentRoute: () => AppServiceJobsJobIdRouteRoute,
  } as any)
const AppServiceVisitsVisitIdIndexRoute =
  AppServiceVisitsVisitIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppServiceVisitsVisitIdRouteRoute,
  } as any)
const AppServiceVisitsVisitIdReportRoute =
  AppServiceVisitsVisitIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => AppServiceVisitsVisitIdRouteRoute,
  } as any)
const AppPayrollRunsRunIdPayslipsPayslipIdRoute =
  AppPayrollRunsRunIdPayslipsPayslipIdRouteImport.update({
    id: '/payslips/$payslipId',
    path: '/payslips/$payslipId',
    getParentRoute: () => AppPayrollRunsRunIdRouteRoute,
  } as any)
const AppProjectsProjectIdClaimsClaimIdIndexRoute =
  AppProjectsProjectIdClaimsClaimIdIndexRouteImport.update({
    id: '/claims/$claimId/',
    path: '/claims/$claimId/',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppProjectsProjectIdClaimsClaimIdPrintRoute =
  AppProjectsProjectIdClaimsClaimIdPrintRouteImport.update({
    id: '/claims/$claimId/print',
    path: '/claims/$claimId/print',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppProjectsProjectIdReportsReportIdIndexRoute =
  AppProjectsProjectIdReportsReportIdIndexRouteImport.update({
    id: '/reports/$reportId/',
    path: '/reports/$reportId/',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppProjectsProjectIdReportsReportIdPrintRoute =
  AppProjectsProjectIdReportsReportIdPrintRouteImport.update({
    id: '/reports/$reportId/print',
    path: '/reports/$reportId/print',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/approvals': typeof AppApprovalsRouteRouteWithChildren
  '/bank-statements': typeof AppBankStatementsRouteRouteWithChildren
  '/cheques': typeof AppChequesRouteRouteWithChildren
  '/commissions': typeof AppCommissionsRouteRouteWithChildren
  '/credit-notes': typeof AppCreditNotesRouteRouteWithChildren
  '/customers': typeof AppCustomersRouteRouteWithChildren
  '/expenses': typeof AppExpensesRouteRouteWithChildren
  '/hr': typeof AppHrRouteRouteWithChildren
  '/invoices': typeof AppInvoicesRouteRouteWithChildren
  '/journal-entries': typeof AppJournalEntriesRouteRouteWithChildren
  '/loyalty': typeof AppLoyaltyRouteRouteWithChildren
  '/payroll': typeof AppPayrollRouteRouteWithChildren
  '/privacy-requests': typeof AppPrivacyRequestsRouteRouteWithChildren
  '/products': typeof AppProductsRouteRouteWithChildren
  '/projects': typeof AppProjectsRouteRouteWithChildren
  '/purchases': typeof AppPurchasesRouteRouteWithChildren
  '/quotations': typeof AppQuotationsRouteRouteWithChildren
  '/receipts': typeof AppReceiptsRouteRouteWithChildren
  '/refunds': typeof AppRefundsRouteRouteWithChildren
  '/roles': typeof AppRolesRouteRouteWithChildren
  '/serials': typeof AppSerialsRouteRouteWithChildren
  '/service': typeof AppServiceRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/stock-adjustments': typeof AppStockAdjustmentsRouteRouteWithChildren
  '/stock-transfers': typeof AppStockTransfersRouteRouteWithChildren
  '/supplier-payments': typeof AppSupplierPaymentsRouteRouteWithChildren
  '/supplier-refunds': typeof AppSupplierRefundsRouteRouteWithChildren
  '/supplier-returns': typeof AppSupplierReturnsRouteRouteWithChildren
  '/suppliers': typeof AppSuppliersRouteRouteWithChildren
  '/tasks': typeof AppTasksRouteRouteWithChildren
  '/teams': typeof AppTeamsRouteRouteWithChildren
  '/users': typeof AppUsersRouteRouteWithChildren
  '/workflows': typeof AppWorkflowsRouteRouteWithChildren
  '/account-mapping': typeof AppAccountMappingRoute
  '/accounts': typeof AppAccountsRoute
  '/audit-log': typeof AppAuditLogRoute
  '/balance-sheet': typeof AppBalanceSheetRoute
  '/books-health': typeof AppBooksHealthRoute
  '/calendar': typeof AppCalendarRoute
  '/cash-bank': typeof AppCashBankRoute
  '/cash-flow': typeof AppCashFlowRoute
  '/change-password': typeof AppChangePasswordRoute
  '/customer-groups': typeof AppCustomerGroupsRoute
  '/expense-categories': typeof AppExpenseCategoriesRoute
  '/fiscal-years': typeof AppFiscalYearsRoute
  '/general-ledger': typeof AppGeneralLedgerRoute
  '/low-stock': typeof AppLowStockRoute
  '/my-work': typeof AppMyWorkRoute
  '/payables-aging': typeof AppPayablesAgingRoute
  '/pos-summary': typeof AppPosSummaryRoute
  '/product-attributes': typeof AppProductAttributesRoute
  '/product-categories': typeof AppProductCategoriesRoute
  '/profit-and-loss': typeof AppProfitAndLossRoute
  '/project-budget-vs-actual': typeof AppProjectBudgetVsActualRoute
  '/project-profitability': typeof AppProjectProfitabilityRoute
  '/project-unbilled-work': typeof AppProjectUnbilledWorkRoute
  '/project-utilisation': typeof AppProjectUtilisationRoute
  '/purchases-by-product': typeof AppPurchasesByProductRoute
  '/purchases-by-supplier': typeof AppPurchasesBySupplierRoute
  '/receivables-aging': typeof AppReceivablesAgingRoute
  '/reports': typeof AppReportsRoute
  '/sales-by-customer': typeof AppSalesByCustomerRoute
  '/sales-by-period': typeof AppSalesByPeriodRoute
  '/sales-by-product': typeof AppSalesByProductRoute
  '/sales-by-salesperson': typeof AppSalesBySalespersonRoute
  '/sales-by-user': typeof AppSalesByUserRoute
  '/stock': typeof AppStockRoute
  '/stock-movements': typeof AppStockMovementsRoute
  '/stock-valuation': typeof AppStockValuationRoute
  '/supplier-groups': typeof AppSupplierGroupsRoute
  '/task-report': typeof AppTaskReportRoute
  '/tax-rates': typeof AppTaxRatesRoute
  '/transfers': typeof AppTransfersRoute
  '/trial-balance': typeof AppTrialBalanceRoute
  '/units': typeof AppUnitsRoute
  '/vat-return': typeof AppVatReturnRoute
  '/warehouses': typeof AppWarehousesRoute
  '/p/$token': typeof PTokenRoute
  '/platform': typeof PlatformConsoleRouteWithChildren
  '/platform/login': typeof PlatformLoginRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/cheques/$chequeId': typeof AppChequesChequeIdRouteRouteWithChildren
  '/commissions/mine': typeof AppCommissionsMineRouteRouteWithChildren
  '/commissions/plans': typeof AppCommissionsPlansRouteRouteWithChildren
  '/commissions/runs': typeof AppCommissionsRunsRouteRouteWithChildren
  '/commissions/statements': typeof AppCommissionsStatementsRouteRouteWithChildren
  '/credit-notes/$creditNoteId': typeof AppCreditNotesCreditNoteIdRouteRouteWithChildren
  '/customers/$customerId': typeof AppCustomersCustomerIdRouteRouteWithChildren
  '/expenses/$expenseId': typeof AppExpensesExpenseIdRouteRouteWithChildren
  '/expenses/recurring': typeof AppExpensesRecurringRouteRouteWithChildren
  '/hr/employees': typeof AppHrEmployeesRouteRouteWithChildren
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRouteRouteWithChildren
  '/loyalty/members': typeof AppLoyaltyMembersRouteRouteWithChildren
  '/payroll/runs': typeof AppPayrollRunsRouteRouteWithChildren
  '/pos/shifts': typeof AppPosShiftsRouteRouteWithChildren
  '/products/$productId': typeof AppProductsProductIdRouteRouteWithChildren
  '/projects/$projectId': typeof AppProjectsProjectIdRouteRouteWithChildren
  '/projects/cost-entries': typeof AppProjectsCostEntriesRouteRouteWithChildren
  '/projects/material-issues': typeof AppProjectsMaterialIssuesRouteRouteWithChildren
  '/purchases/$purchaseId': typeof AppPurchasesPurchaseIdRouteRouteWithChildren
  '/quotations/$quotationId': typeof AppQuotationsQuotationIdRouteRouteWithChildren
  '/receipts/$receiptId': typeof AppReceiptsReceiptIdRouteRouteWithChildren
  '/refunds/$refundId': typeof AppRefundsRefundIdRouteRouteWithChildren
  '/service/assets': typeof AppServiceAssetsRouteRouteWithChildren
  '/service/contracts': typeof AppServiceContractsRouteRouteWithChildren
  '/service/jobs': typeof AppServiceJobsRouteRouteWithChildren
  '/service/sites': typeof AppServiceSitesRouteRouteWithChildren
  '/service/visits': typeof AppServiceVisitsRouteRouteWithChildren
  '/stock-transfers/$transferId': typeof AppStockTransfersTransferIdRouteRouteWithChildren
  '/supplier-payments/$paymentId': typeof AppSupplierPaymentsPaymentIdRouteRouteWithChildren
  '/supplier-refunds/$refundId': typeof AppSupplierRefundsRefundIdRouteRouteWithChildren
  '/supplier-returns/$returnId': typeof AppSupplierReturnsReturnIdRouteRouteWithChildren
  '/suppliers/$supplierId': typeof AppSuppliersSupplierIdRouteRouteWithChildren
  '/workflows/runs': typeof AppWorkflowsRunsRouteRouteWithChildren
  '/approvals/$runId': typeof AppApprovalsRunIdRoute
  '/bank-statements/$statementId': typeof AppBankStatementsStatementIdRoute
  '/bank-statements/new': typeof AppBankStatementsNewRoute
  '/credit-notes/new': typeof AppCreditNotesNewRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/expenses/new': typeof AppExpensesNewRoute
  '/hr/documents': typeof AppHrDocumentsRoute
  '/hr/pay-components': typeof AppHrPayComponentsRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/journal-entries/$entryId': typeof AppJournalEntriesEntryIdRoute
  '/journal-entries/new': typeof AppJournalEntriesNewRoute
  '/loyalty/program': typeof AppLoyaltyProgramRoute
  '/loyalty/transactions': typeof AppLoyaltyTransactionsRoute
  '/payroll/contributions': typeof AppPayrollContributionsRoute
  '/payroll/settings': typeof AppPayrollSettingsRoute
  '/pos/tills': typeof AppPosTillsRoute
  '/privacy-requests/$requestId': typeof AppPrivacyRequestsRequestIdRoute
  '/products/new': typeof AppProductsNewRoute
  '/projects/guarantees': typeof AppProjectsGuaranteesRoute
  '/projects/rates': typeof AppProjectsRatesRoute
  '/projects/reconciliation': typeof AppProjectsReconciliationRoute
  '/projects/status-reports': typeof AppProjectsStatusReportsRoute
  '/purchases/new': typeof AppPurchasesNewRoute
  '/quotations/new': typeof AppQuotationsNewRoute
  '/receipts/new': typeof AppReceiptsNewRoute
  '/refunds/new': typeof AppRefundsNewRoute
  '/roles/$roleId': typeof AppRolesRoleIdRoute
  '/roles/new': typeof AppRolesNewRoute
  '/serials/$serialId': typeof AppSerialsSerialIdRoute
  '/service/collections': typeof AppServiceCollectionsRoute
  '/service/follow-ups': typeof AppServiceFollowUpsRoute
  '/service/my-visits': typeof AppServiceMyVisitsRoute
  '/service/schedule': typeof AppServiceScheduleRoute
  '/settings/account-mapping': typeof AppSettingsAccountMappingRoute
  '/settings/accounting-checks': typeof AppSettingsAccountingChecksRoute
  '/settings/appearance': typeof AppSettingsAppearanceRoute
  '/settings/calendar': typeof AppSettingsCalendarRoute
  '/settings/commissions': typeof AppSettingsCommissionsRoute
  '/settings/company': typeof AppSettingsCompanyRoute
  '/settings/contracts': typeof AppSettingsContractsRoute
  '/settings/defaults': typeof AppSettingsDefaultsRoute
  '/settings/legal-holds': typeof AppSettingsLegalHoldsRoute
  '/settings/lock-date': typeof AppSettingsLockDateRoute
  '/settings/message-outbox': typeof AppSettingsMessageOutboxRoute
  '/settings/message-templates': typeof AppSettingsMessageTemplatesRoute
  '/settings/modules': typeof AppSettingsModulesRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/numbering': typeof AppSettingsNumberingRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/payment-methods': typeof AppSettingsPaymentMethodsRoute
  '/settings/printing': typeof AppSettingsPrintingRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/project-contracting': typeof AppSettingsProjectContractingRoute
  '/settings/project-cost-categories': typeof AppSettingsProjectCostCategoriesRoute
  '/settings/project-insights': typeof AppSettingsProjectInsightsRoute
  '/settings/project-rate-roles': typeof AppSettingsProjectRateRolesRoute
  '/settings/project-types': typeof AppSettingsProjectTypesRoute
  '/settings/projects': typeof AppSettingsProjectsRoute
  '/settings/regional': typeof AppSettingsRegionalRoute
  '/settings/service': typeof AppSettingsServiceRoute
  '/settings/service-asset-types': typeof AppSettingsServiceAssetTypesRoute
  '/settings/service-site-templates': typeof AppSettingsServiceSiteTemplatesRoute
  '/settings/stock-policy': typeof AppSettingsStockPolicyRoute
  '/settings/system': typeof AppSettingsSystemRoute
  '/settings/tasks': typeof AppSettingsTasksRoute
  '/settings/tax-rates': typeof AppSettingsTaxRatesRoute
  '/settings/teams': typeof AppSettingsTeamsRoute
  '/settings/typography': typeof AppSettingsTypographyRoute
  '/settings/work-locations': typeof AppSettingsWorkLocationsRoute
  '/stock-adjustments/$adjustmentId': typeof AppStockAdjustmentsAdjustmentIdRoute
  '/stock-adjustments/new': typeof AppStockAdjustmentsNewRoute
  '/stock-transfers/new': typeof AppStockTransfersNewRoute
  '/supplier-payments/new': typeof AppSupplierPaymentsNewRoute
  '/supplier-refunds/new': typeof AppSupplierRefundsNewRoute
  '/supplier-returns/new': typeof AppSupplierReturnsNewRoute
  '/suppliers/new': typeof AppSuppliersNewRoute
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/teams/$teamId': typeof AppTeamsTeamIdRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/users/new': typeof AppUsersNewRoute
  '/workflows/$workflowId': typeof AppWorkflowsWorkflowIdRoute
  '/workflows/delegations': typeof AppWorkflowsDelegationsRoute
  '/platform/dashboard': typeof PlatformConsoleDashboardRoute
  '/platform/feedback': typeof PlatformConsoleFeedbackRoute
  '/platform/profile': typeof PlatformConsoleProfileRoute
  '/platform/subscriptions': typeof PlatformConsoleSubscriptionsRoute
  '/approvals/': typeof AppApprovalsIndexRoute
  '/bank-statements/': typeof AppBankStatementsIndexRoute
  '/cheques/': typeof AppChequesIndexRoute
  '/commissions/': typeof AppCommissionsIndexRoute
  '/credit-notes/': typeof AppCreditNotesIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/expenses/': typeof AppExpensesIndexRoute
  '/hr/': typeof AppHrIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/journal-entries/': typeof AppJournalEntriesIndexRoute
  '/loyalty/': typeof AppLoyaltyIndexRoute
  '/payroll/': typeof AppPayrollIndexRoute
  '/pos/': typeof AppPosIndexRoute
  '/privacy-requests/': typeof AppPrivacyRequestsIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/purchases/': typeof AppPurchasesIndexRoute
  '/quotations/': typeof AppQuotationsIndexRoute
  '/receipts/': typeof AppReceiptsIndexRoute
  '/refunds/': typeof AppRefundsIndexRoute
  '/roles/': typeof AppRolesIndexRoute
  '/serials/': typeof AppSerialsIndexRoute
  '/service/': typeof AppServiceIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/stock-adjustments/': typeof AppStockAdjustmentsIndexRoute
  '/stock-transfers/': typeof AppStockTransfersIndexRoute
  '/supplier-payments/': typeof AppSupplierPaymentsIndexRoute
  '/supplier-refunds/': typeof AppSupplierRefundsIndexRoute
  '/supplier-returns/': typeof AppSupplierReturnsIndexRoute
  '/suppliers/': typeof AppSuppliersIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/teams/': typeof AppTeamsIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/workflows/': typeof AppWorkflowsIndexRoute
  '/platform/': typeof PlatformConsoleIndexRoute
  '/expenses/recurring/$recurringId': typeof AppExpensesRecurringRecurringIdRouteRouteWithChildren
  '/hr/employees/$employeeId': typeof AppHrEmployeesEmployeeIdRouteRouteWithChildren
  '/payroll/runs/$runId': typeof AppPayrollRunsRunIdRouteRouteWithChildren
  '/service/contracts/$contractId': typeof AppServiceContractsContractIdRouteRouteWithChildren
  '/service/jobs/$jobId': typeof AppServiceJobsJobIdRouteRouteWithChildren
  '/service/visits/$visitId': typeof AppServiceVisitsVisitIdRouteRouteWithChildren
  '/commissions/mine/$statementId': typeof AppCommissionsMineStatementIdRoute
  '/commissions/plans/$planId': typeof AppCommissionsPlansPlanIdRoute
  '/commissions/plans/new': typeof AppCommissionsPlansNewRoute
  '/commissions/runs/$runId': typeof AppCommissionsRunsRunIdRoute
  '/commissions/statements/$statementId': typeof AppCommissionsStatementsStatementIdRoute
  '/credit-notes/$creditNoteId/edit': typeof AppCreditNotesCreditNoteIdEditRoute
  '/credit-notes/$creditNoteId/print': typeof AppCreditNotesCreditNoteIdPrintRoute
  '/customers/$customerId/edit': typeof AppCustomersCustomerIdEditRoute
  '/expenses/$expenseId/edit': typeof AppExpensesExpenseIdEditRoute
  '/expenses/recurring/new': typeof AppExpensesRecurringNewRoute
  '/hr/employees/new': typeof AppHrEmployeesNewRoute
  '/invoices/$invoiceId/edit': typeof AppInvoicesInvoiceIdEditRoute
  '/invoices/$invoiceId/print': typeof AppInvoicesInvoiceIdPrintRoute
  '/loyalty/members/$memberId': typeof AppLoyaltyMembersMemberIdRoute
  '/pos/returns/$returnId': typeof AppPosReturnsReturnIdRoute
  '/pos/sales/$saleId': typeof AppPosSalesSaleIdRoute
  '/pos/shifts/$shiftId': typeof AppPosShiftsShiftIdRoute
  '/products/$productId/edit': typeof AppProductsProductIdEditRoute
  '/products/$productId/labels': typeof AppProductsProductIdLabelsRoute
  '/projects/cost-entries/$entryId': typeof AppProjectsCostEntriesEntryIdRoute
  '/projects/material-issues/$issueId': typeof AppProjectsMaterialIssuesIssueIdRoute
  '/projects/time/approvals': typeof AppProjectsTimeApprovalsRoute
  '/purchases/$purchaseId/edit': typeof AppPurchasesPurchaseIdEditRoute
  '/purchases/$purchaseId/print': typeof AppPurchasesPurchaseIdPrintRoute
  '/quotations/$quotationId/edit': typeof AppQuotationsQuotationIdEditRoute
  '/quotations/$quotationId/print': typeof AppQuotationsQuotationIdPrintRoute
  '/receipts/$receiptId/print': typeof AppReceiptsReceiptIdPrintRoute
  '/refunds/$refundId/print': typeof AppRefundsRefundIdPrintRoute
  '/service/assets/$assetId': typeof AppServiceAssetsAssetIdRoute
  '/service/assets/labels': typeof AppServiceAssetsLabelsRoute
  '/service/contracts/billing': typeof AppServiceContractsBillingRoute
  '/service/contracts/insights': typeof AppServiceContractsInsightsRoute
  '/service/contracts/new': typeof AppServiceContractsNewRoute
  '/service/sites/$siteId': typeof AppServiceSitesSiteIdRoute
  '/settings/ai/usage': typeof AppSettingsAiUsageRoute
  '/stock-transfers/$transferId/edit': typeof AppStockTransfersTransferIdEditRoute
  '/stock-transfers/$transferId/print': typeof AppStockTransfersTransferIdPrintRoute
  '/supplier-payments/$paymentId/print': typeof AppSupplierPaymentsPaymentIdPrintRoute
  '/supplier-refunds/$refundId/print': typeof AppSupplierRefundsRefundIdPrintRoute
  '/supplier-returns/$returnId/edit': typeof AppSupplierReturnsReturnIdEditRoute
  '/supplier-returns/$returnId/print': typeof AppSupplierReturnsReturnIdPrintRoute
  '/suppliers/$supplierId/edit': typeof AppSuppliersSupplierIdEditRoute
  '/workflows/runs/$runId': typeof AppWorkflowsRunsRunIdRoute
  '/platform/tenants/$tenantId': typeof PlatformConsoleTenantsTenantIdRoute
  '/platform/tenants/new': typeof PlatformConsoleTenantsNewRoute
  '/cheques/$chequeId/': typeof AppChequesChequeIdIndexRoute
  '/commissions/mine/': typeof AppCommissionsMineIndexRoute
  '/commissions/plans/': typeof AppCommissionsPlansIndexRoute
  '/commissions/runs/': typeof AppCommissionsRunsIndexRoute
  '/credit-notes/$creditNoteId/': typeof AppCreditNotesCreditNoteIdIndexRoute
  '/customers/$customerId/': typeof AppCustomersCustomerIdIndexRoute
  '/expenses/$expenseId/': typeof AppExpensesExpenseIdIndexRoute
  '/expenses/recurring/': typeof AppExpensesRecurringIndexRoute
  '/hr/employees/': typeof AppHrEmployeesIndexRoute
  '/invoices/$invoiceId/': typeof AppInvoicesInvoiceIdIndexRoute
  '/loyalty/members/': typeof AppLoyaltyMembersIndexRoute
  '/payroll/runs/': typeof AppPayrollRunsIndexRoute
  '/pos/shifts/': typeof AppPosShiftsIndexRoute
  '/products/$productId/': typeof AppProductsProductIdIndexRoute
  '/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/projects/cost-entries/': typeof AppProjectsCostEntriesIndexRoute
  '/projects/material-issues/': typeof AppProjectsMaterialIssuesIndexRoute
  '/projects/time/': typeof AppProjectsTimeIndexRoute
  '/purchases/$purchaseId/': typeof AppPurchasesPurchaseIdIndexRoute
  '/quotations/$quotationId/': typeof AppQuotationsQuotationIdIndexRoute
  '/receipts/$receiptId/': typeof AppReceiptsReceiptIdIndexRoute
  '/refunds/$refundId/': typeof AppRefundsRefundIdIndexRoute
  '/service/assets/': typeof AppServiceAssetsIndexRoute
  '/service/contracts/': typeof AppServiceContractsIndexRoute
  '/service/jobs/': typeof AppServiceJobsIndexRoute
  '/service/sites/': typeof AppServiceSitesIndexRoute
  '/service/visits/': typeof AppServiceVisitsIndexRoute
  '/settings/ai/': typeof AppSettingsAiIndexRoute
  '/stock-transfers/$transferId/': typeof AppStockTransfersTransferIdIndexRoute
  '/supplier-payments/$paymentId/': typeof AppSupplierPaymentsPaymentIdIndexRoute
  '/supplier-refunds/$refundId/': typeof AppSupplierRefundsRefundIdIndexRoute
  '/supplier-returns/$returnId/': typeof AppSupplierReturnsReturnIdIndexRoute
  '/suppliers/$supplierId/': typeof AppSuppliersSupplierIdIndexRoute
  '/workflows/runs/': typeof AppWorkflowsRunsIndexRoute
  '/platform/tenants/': typeof PlatformConsoleTenantsIndexRoute
  '/expenses/recurring/$recurringId/edit': typeof AppExpensesRecurringRecurringIdEditRoute
  '/hr/employees/$employeeId/edit': typeof AppHrEmployeesEmployeeIdEditRoute
  '/projects/$projectId/contract/statement': typeof AppProjectsProjectIdContractStatementRoute
  '/service/contracts/$contractId/edit': typeof AppServiceContractsContractIdEditRoute
  '/service/contracts/$contractId/print': typeof AppServiceContractsContractIdPrintRoute
  '/service/jobs/$jobId/estimate': typeof AppServiceJobsJobIdEstimateRoute
  '/service/visits/$visitId/report': typeof AppServiceVisitsVisitIdReportRoute
  '/expenses/recurring/$recurringId/': typeof AppExpensesRecurringRecurringIdIndexRoute
  '/hr/employees/$employeeId/': typeof AppHrEmployeesEmployeeIdIndexRoute
  '/payroll/runs/$runId/': typeof AppPayrollRunsRunIdIndexRoute
  '/projects/$projectId/reports/': typeof AppProjectsProjectIdReportsIndexRoute
  '/service/contracts/$contractId/': typeof AppServiceContractsContractIdIndexRoute
  '/service/jobs/$jobId/': typeof AppServiceJobsJobIdIndexRoute
  '/service/visits/$visitId/': typeof AppServiceVisitsVisitIdIndexRoute
  '/payroll/runs/$runId/payslips/$payslipId': typeof AppPayrollRunsRunIdPayslipsPayslipIdRoute
  '/projects/$projectId/claims/$claimId/print': typeof AppProjectsProjectIdClaimsClaimIdPrintRoute
  '/projects/$projectId/reports/$reportId/print': typeof AppProjectsProjectIdReportsReportIdPrintRoute
  '/projects/$projectId/claims/$claimId/': typeof AppProjectsProjectIdClaimsClaimIdIndexRoute
  '/projects/$projectId/reports/$reportId/': typeof AppProjectsProjectIdReportsReportIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/account-mapping': typeof AppAccountMappingRoute
  '/accounts': typeof AppAccountsRoute
  '/audit-log': typeof AppAuditLogRoute
  '/balance-sheet': typeof AppBalanceSheetRoute
  '/books-health': typeof AppBooksHealthRoute
  '/calendar': typeof AppCalendarRoute
  '/cash-bank': typeof AppCashBankRoute
  '/cash-flow': typeof AppCashFlowRoute
  '/change-password': typeof AppChangePasswordRoute
  '/customer-groups': typeof AppCustomerGroupsRoute
  '/expense-categories': typeof AppExpenseCategoriesRoute
  '/fiscal-years': typeof AppFiscalYearsRoute
  '/general-ledger': typeof AppGeneralLedgerRoute
  '/low-stock': typeof AppLowStockRoute
  '/my-work': typeof AppMyWorkRoute
  '/payables-aging': typeof AppPayablesAgingRoute
  '/pos-summary': typeof AppPosSummaryRoute
  '/product-attributes': typeof AppProductAttributesRoute
  '/product-categories': typeof AppProductCategoriesRoute
  '/profit-and-loss': typeof AppProfitAndLossRoute
  '/project-budget-vs-actual': typeof AppProjectBudgetVsActualRoute
  '/project-profitability': typeof AppProjectProfitabilityRoute
  '/project-unbilled-work': typeof AppProjectUnbilledWorkRoute
  '/project-utilisation': typeof AppProjectUtilisationRoute
  '/purchases-by-product': typeof AppPurchasesByProductRoute
  '/purchases-by-supplier': typeof AppPurchasesBySupplierRoute
  '/receivables-aging': typeof AppReceivablesAgingRoute
  '/reports': typeof AppReportsRoute
  '/sales-by-customer': typeof AppSalesByCustomerRoute
  '/sales-by-period': typeof AppSalesByPeriodRoute
  '/sales-by-product': typeof AppSalesByProductRoute
  '/sales-by-salesperson': typeof AppSalesBySalespersonRoute
  '/sales-by-user': typeof AppSalesByUserRoute
  '/stock': typeof AppStockRoute
  '/stock-movements': typeof AppStockMovementsRoute
  '/stock-valuation': typeof AppStockValuationRoute
  '/supplier-groups': typeof AppSupplierGroupsRoute
  '/task-report': typeof AppTaskReportRoute
  '/tax-rates': typeof AppTaxRatesRoute
  '/transfers': typeof AppTransfersRoute
  '/trial-balance': typeof AppTrialBalanceRoute
  '/units': typeof AppUnitsRoute
  '/vat-return': typeof AppVatReturnRoute
  '/warehouses': typeof AppWarehousesRoute
  '/p/$token': typeof PTokenRoute
  '/platform/login': typeof PlatformLoginRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/': typeof AppIndexRoute
  '/commissions/statements': typeof AppCommissionsStatementsRouteRouteWithChildren
  '/approvals/$runId': typeof AppApprovalsRunIdRoute
  '/bank-statements/$statementId': typeof AppBankStatementsStatementIdRoute
  '/bank-statements/new': typeof AppBankStatementsNewRoute
  '/credit-notes/new': typeof AppCreditNotesNewRoute
  '/customers/new': typeof AppCustomersNewRoute
  '/expenses/new': typeof AppExpensesNewRoute
  '/hr/documents': typeof AppHrDocumentsRoute
  '/hr/pay-components': typeof AppHrPayComponentsRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/journal-entries/$entryId': typeof AppJournalEntriesEntryIdRoute
  '/journal-entries/new': typeof AppJournalEntriesNewRoute
  '/loyalty/program': typeof AppLoyaltyProgramRoute
  '/loyalty/transactions': typeof AppLoyaltyTransactionsRoute
  '/payroll/contributions': typeof AppPayrollContributionsRoute
  '/payroll/settings': typeof AppPayrollSettingsRoute
  '/pos/tills': typeof AppPosTillsRoute
  '/privacy-requests/$requestId': typeof AppPrivacyRequestsRequestIdRoute
  '/products/new': typeof AppProductsNewRoute
  '/projects/guarantees': typeof AppProjectsGuaranteesRoute
  '/projects/rates': typeof AppProjectsRatesRoute
  '/projects/reconciliation': typeof AppProjectsReconciliationRoute
  '/projects/status-reports': typeof AppProjectsStatusReportsRoute
  '/purchases/new': typeof AppPurchasesNewRoute
  '/quotations/new': typeof AppQuotationsNewRoute
  '/receipts/new': typeof AppReceiptsNewRoute
  '/refunds/new': typeof AppRefundsNewRoute
  '/roles/$roleId': typeof AppRolesRoleIdRoute
  '/roles/new': typeof AppRolesNewRoute
  '/serials/$serialId': typeof AppSerialsSerialIdRoute
  '/service/collections': typeof AppServiceCollectionsRoute
  '/service/follow-ups': typeof AppServiceFollowUpsRoute
  '/service/my-visits': typeof AppServiceMyVisitsRoute
  '/service/schedule': typeof AppServiceScheduleRoute
  '/settings/account-mapping': typeof AppSettingsAccountMappingRoute
  '/settings/accounting-checks': typeof AppSettingsAccountingChecksRoute
  '/settings/appearance': typeof AppSettingsAppearanceRoute
  '/settings/calendar': typeof AppSettingsCalendarRoute
  '/settings/commissions': typeof AppSettingsCommissionsRoute
  '/settings/company': typeof AppSettingsCompanyRoute
  '/settings/contracts': typeof AppSettingsContractsRoute
  '/settings/defaults': typeof AppSettingsDefaultsRoute
  '/settings/legal-holds': typeof AppSettingsLegalHoldsRoute
  '/settings/lock-date': typeof AppSettingsLockDateRoute
  '/settings/message-outbox': typeof AppSettingsMessageOutboxRoute
  '/settings/message-templates': typeof AppSettingsMessageTemplatesRoute
  '/settings/modules': typeof AppSettingsModulesRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/numbering': typeof AppSettingsNumberingRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/payment-methods': typeof AppSettingsPaymentMethodsRoute
  '/settings/printing': typeof AppSettingsPrintingRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/project-contracting': typeof AppSettingsProjectContractingRoute
  '/settings/project-cost-categories': typeof AppSettingsProjectCostCategoriesRoute
  '/settings/project-insights': typeof AppSettingsProjectInsightsRoute
  '/settings/project-rate-roles': typeof AppSettingsProjectRateRolesRoute
  '/settings/project-types': typeof AppSettingsProjectTypesRoute
  '/settings/projects': typeof AppSettingsProjectsRoute
  '/settings/regional': typeof AppSettingsRegionalRoute
  '/settings/service': typeof AppSettingsServiceRoute
  '/settings/service-asset-types': typeof AppSettingsServiceAssetTypesRoute
  '/settings/service-site-templates': typeof AppSettingsServiceSiteTemplatesRoute
  '/settings/stock-policy': typeof AppSettingsStockPolicyRoute
  '/settings/system': typeof AppSettingsSystemRoute
  '/settings/tasks': typeof AppSettingsTasksRoute
  '/settings/tax-rates': typeof AppSettingsTaxRatesRoute
  '/settings/teams': typeof AppSettingsTeamsRoute
  '/settings/typography': typeof AppSettingsTypographyRoute
  '/settings/work-locations': typeof AppSettingsWorkLocationsRoute
  '/stock-adjustments/$adjustmentId': typeof AppStockAdjustmentsAdjustmentIdRoute
  '/stock-adjustments/new': typeof AppStockAdjustmentsNewRoute
  '/stock-transfers/new': typeof AppStockTransfersNewRoute
  '/supplier-payments/new': typeof AppSupplierPaymentsNewRoute
  '/supplier-refunds/new': typeof AppSupplierRefundsNewRoute
  '/supplier-returns/new': typeof AppSupplierReturnsNewRoute
  '/suppliers/new': typeof AppSuppliersNewRoute
  '/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/teams/$teamId': typeof AppTeamsTeamIdRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/users/new': typeof AppUsersNewRoute
  '/workflows/$workflowId': typeof AppWorkflowsWorkflowIdRoute
  '/workflows/delegations': typeof AppWorkflowsDelegationsRoute
  '/platform/dashboard': typeof PlatformConsoleDashboardRoute
  '/platform/feedback': typeof PlatformConsoleFeedbackRoute
  '/platform/profile': typeof PlatformConsoleProfileRoute
  '/platform/subscriptions': typeof PlatformConsoleSubscriptionsRoute
  '/approvals': typeof AppApprovalsIndexRoute
  '/bank-statements': typeof AppBankStatementsIndexRoute
  '/cheques': typeof AppChequesIndexRoute
  '/commissions': typeof AppCommissionsIndexRoute
  '/credit-notes': typeof AppCreditNotesIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/expenses': typeof AppExpensesIndexRoute
  '/hr': typeof AppHrIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/journal-entries': typeof AppJournalEntriesIndexRoute
  '/loyalty': typeof AppLoyaltyIndexRoute
  '/payroll': typeof AppPayrollIndexRoute
  '/pos': typeof AppPosIndexRoute
  '/privacy-requests': typeof AppPrivacyRequestsIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/purchases': typeof AppPurchasesIndexRoute
  '/quotations': typeof AppQuotationsIndexRoute
  '/receipts': typeof AppReceiptsIndexRoute
  '/refunds': typeof AppRefundsIndexRoute
  '/roles': typeof AppRolesIndexRoute
  '/serials': typeof AppSerialsIndexRoute
  '/service': typeof AppServiceIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/stock-adjustments': typeof AppStockAdjustmentsIndexRoute
  '/stock-transfers': typeof AppStockTransfersIndexRoute
  '/supplier-payments': typeof AppSupplierPaymentsIndexRoute
  '/supplier-refunds': typeof AppSupplierRefundsIndexRoute
  '/supplier-returns': typeof AppSupplierReturnsIndexRoute
  '/suppliers': typeof AppSuppliersIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/teams': typeof AppTeamsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/workflows': typeof AppWorkflowsIndexRoute
  '/platform': typeof PlatformConsoleIndexRoute
  '/commissions/mine/$statementId': typeof AppCommissionsMineStatementIdRoute
  '/commissions/plans/$planId': typeof AppCommissionsPlansPlanIdRoute
  '/commissions/plans/new': typeof AppCommissionsPlansNewRoute
  '/commissions/runs/$runId': typeof AppCommissionsRunsRunIdRoute
  '/commissions/statements/$statementId': typeof AppCommissionsStatementsStatementIdRoute
  '/credit-notes/$creditNoteId/edit': typeof AppCreditNotesCreditNoteIdEditRoute
  '/credit-notes/$creditNoteId/print': typeof AppCreditNotesCreditNoteIdPrintRoute
  '/customers/$customerId/edit': typeof AppCustomersCustomerIdEditRoute
  '/expenses/$expenseId/edit': typeof AppExpensesExpenseIdEditRoute
  '/expenses/recurring/new': typeof AppExpensesRecurringNewRoute
  '/hr/employees/new': typeof AppHrEmployeesNewRoute
  '/invoices/$invoiceId/edit': typeof AppInvoicesInvoiceIdEditRoute
  '/invoices/$invoiceId/print': typeof AppInvoicesInvoiceIdPrintRoute
  '/loyalty/members/$memberId': typeof AppLoyaltyMembersMemberIdRoute
  '/pos/returns/$returnId': typeof AppPosReturnsReturnIdRoute
  '/pos/sales/$saleId': typeof AppPosSalesSaleIdRoute
  '/pos/shifts/$shiftId': typeof AppPosShiftsShiftIdRoute
  '/products/$productId/edit': typeof AppProductsProductIdEditRoute
  '/products/$productId/labels': typeof AppProductsProductIdLabelsRoute
  '/projects/cost-entries/$entryId': typeof AppProjectsCostEntriesEntryIdRoute
  '/projects/material-issues/$issueId': typeof AppProjectsMaterialIssuesIssueIdRoute
  '/projects/time/approvals': typeof AppProjectsTimeApprovalsRoute
  '/purchases/$purchaseId/edit': typeof AppPurchasesPurchaseIdEditRoute
  '/purchases/$purchaseId/print': typeof AppPurchasesPurchaseIdPrintRoute
  '/quotations/$quotationId/edit': typeof AppQuotationsQuotationIdEditRoute
  '/quotations/$quotationId/print': typeof AppQuotationsQuotationIdPrintRoute
  '/receipts/$receiptId/print': typeof AppReceiptsReceiptIdPrintRoute
  '/refunds/$refundId/print': typeof AppRefundsRefundIdPrintRoute
  '/service/assets/$assetId': typeof AppServiceAssetsAssetIdRoute
  '/service/assets/labels': typeof AppServiceAssetsLabelsRoute
  '/service/contracts/billing': typeof AppServiceContractsBillingRoute
  '/service/contracts/insights': typeof AppServiceContractsInsightsRoute
  '/service/contracts/new': typeof AppServiceContractsNewRoute
  '/service/sites/$siteId': typeof AppServiceSitesSiteIdRoute
  '/settings/ai/usage': typeof AppSettingsAiUsageRoute
  '/stock-transfers/$transferId/edit': typeof AppStockTransfersTransferIdEditRoute
  '/stock-transfers/$transferId/print': typeof AppStockTransfersTransferIdPrintRoute
  '/supplier-payments/$paymentId/print': typeof AppSupplierPaymentsPaymentIdPrintRoute
  '/supplier-refunds/$refundId/print': typeof AppSupplierRefundsRefundIdPrintRoute
  '/supplier-returns/$returnId/edit': typeof AppSupplierReturnsReturnIdEditRoute
  '/supplier-returns/$returnId/print': typeof AppSupplierReturnsReturnIdPrintRoute
  '/suppliers/$supplierId/edit': typeof AppSuppliersSupplierIdEditRoute
  '/workflows/runs/$runId': typeof AppWorkflowsRunsRunIdRoute
  '/platform/tenants/$tenantId': typeof PlatformConsoleTenantsTenantIdRoute
  '/platform/tenants/new': typeof PlatformConsoleTenantsNewRoute
  '/cheques/$chequeId': typeof AppChequesChequeIdIndexRoute
  '/commissions/mine': typeof AppCommissionsMineIndexRoute
  '/commissions/plans': typeof AppCommissionsPlansIndexRoute
  '/commissions/runs': typeof AppCommissionsRunsIndexRoute
  '/credit-notes/$creditNoteId': typeof AppCreditNotesCreditNoteIdIndexRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdIndexRoute
  '/expenses/$expenseId': typeof AppExpensesExpenseIdIndexRoute
  '/expenses/recurring': typeof AppExpensesRecurringIndexRoute
  '/hr/employees': typeof AppHrEmployeesIndexRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdIndexRoute
  '/loyalty/members': typeof AppLoyaltyMembersIndexRoute
  '/payroll/runs': typeof AppPayrollRunsIndexRoute
  '/pos/shifts': typeof AppPosShiftsIndexRoute
  '/products/$productId': typeof AppProductsProductIdIndexRoute
  '/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
  '/projects/cost-entries': typeof AppProjectsCostEntriesIndexRoute
  '/projects/material-issues': typeof AppProjectsMaterialIssuesIndexRoute
  '/projects/time': typeof AppProjectsTimeIndexRoute
  '/purchases/$purchaseId': typeof AppPurchasesPurchaseIdIndexRoute
  '/quotations/$quotationId': typeof AppQuotationsQuotationIdIndexRoute
  '/receipts/$receiptId': typeof AppReceiptsReceiptIdIndexRoute
  '/refunds/$refundId': typeof AppRefundsRefundIdIndexRoute
  '/service/assets': typeof AppServiceAssetsIndexRoute
  '/service/contracts': typeof AppServiceContractsIndexRoute
  '/service/jobs': typeof AppServiceJobsIndexRoute
  '/service/sites': typeof AppServiceSitesIndexRoute
  '/service/visits': typeof AppServiceVisitsIndexRoute
  '/settings/ai': typeof AppSettingsAiIndexRoute
  '/stock-transfers/$transferId': typeof AppStockTransfersTransferIdIndexRoute
  '/supplier-payments/$paymentId': typeof AppSupplierPaymentsPaymentIdIndexRoute
  '/supplier-refunds/$refundId': typeof AppSupplierRefundsRefundIdIndexRoute
  '/supplier-returns/$returnId': typeof AppSupplierReturnsReturnIdIndexRoute
  '/suppliers/$supplierId': typeof AppSuppliersSupplierIdIndexRoute
  '/workflows/runs': typeof AppWorkflowsRunsIndexRoute
  '/platform/tenants': typeof PlatformConsoleTenantsIndexRoute
  '/expenses/recurring/$recurringId/edit': typeof AppExpensesRecurringRecurringIdEditRoute
  '/hr/employees/$employeeId/edit': typeof AppHrEmployeesEmployeeIdEditRoute
  '/projects/$projectId/contract/statement': typeof AppProjectsProjectIdContractStatementRoute
  '/service/contracts/$contractId/edit': typeof AppServiceContractsContractIdEditRoute
  '/service/contracts/$contractId/print': typeof AppServiceContractsContractIdPrintRoute
  '/service/jobs/$jobId/estimate': typeof AppServiceJobsJobIdEstimateRoute
  '/service/visits/$visitId/report': typeof AppServiceVisitsVisitIdReportRoute
  '/expenses/recurring/$recurringId': typeof AppExpensesRecurringRecurringIdIndexRoute
  '/hr/employees/$employeeId': typeof AppHrEmployeesEmployeeIdIndexRoute
  '/payroll/runs/$runId': typeof AppPayrollRunsRunIdIndexRoute
  '/projects/$projectId/reports': typeof AppProjectsProjectIdReportsIndexRoute
  '/service/contracts/$contractId': typeof AppServiceContractsContractIdIndexRoute
  '/service/jobs/$jobId': typeof AppServiceJobsJobIdIndexRoute
  '/service/visits/$visitId': typeof AppServiceVisitsVisitIdIndexRoute
  '/payroll/runs/$runId/payslips/$payslipId': typeof AppPayrollRunsRunIdPayslipsPayslipIdRoute
  '/projects/$projectId/claims/$claimId/print': typeof AppProjectsProjectIdClaimsClaimIdPrintRoute
  '/projects/$projectId/reports/$reportId/print': typeof AppProjectsProjectIdReportsReportIdPrintRoute
  '/projects/$projectId/claims/$claimId': typeof AppProjectsProjectIdClaimsClaimIdIndexRoute
  '/projects/$projectId/reports/$reportId': typeof AppProjectsProjectIdReportsReportIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/approvals': typeof AppApprovalsRouteRouteWithChildren
  '/_app/bank-statements': typeof AppBankStatementsRouteRouteWithChildren
  '/_app/cheques': typeof AppChequesRouteRouteWithChildren
  '/_app/commissions': typeof AppCommissionsRouteRouteWithChildren
  '/_app/credit-notes': typeof AppCreditNotesRouteRouteWithChildren
  '/_app/customers': typeof AppCustomersRouteRouteWithChildren
  '/_app/expenses': typeof AppExpensesRouteRouteWithChildren
  '/_app/hr': typeof AppHrRouteRouteWithChildren
  '/_app/invoices': typeof AppInvoicesRouteRouteWithChildren
  '/_app/journal-entries': typeof AppJournalEntriesRouteRouteWithChildren
  '/_app/loyalty': typeof AppLoyaltyRouteRouteWithChildren
  '/_app/payroll': typeof AppPayrollRouteRouteWithChildren
  '/_app/privacy-requests': typeof AppPrivacyRequestsRouteRouteWithChildren
  '/_app/products': typeof AppProductsRouteRouteWithChildren
  '/_app/projects': typeof AppProjectsRouteRouteWithChildren
  '/_app/purchases': typeof AppPurchasesRouteRouteWithChildren
  '/_app/quotations': typeof AppQuotationsRouteRouteWithChildren
  '/_app/receipts': typeof AppReceiptsRouteRouteWithChildren
  '/_app/refunds': typeof AppRefundsRouteRouteWithChildren
  '/_app/roles': typeof AppRolesRouteRouteWithChildren
  '/_app/serials': typeof AppSerialsRouteRouteWithChildren
  '/_app/service': typeof AppServiceRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/stock-adjustments': typeof AppStockAdjustmentsRouteRouteWithChildren
  '/_app/stock-transfers': typeof AppStockTransfersRouteRouteWithChildren
  '/_app/supplier-payments': typeof AppSupplierPaymentsRouteRouteWithChildren
  '/_app/supplier-refunds': typeof AppSupplierRefundsRouteRouteWithChildren
  '/_app/supplier-returns': typeof AppSupplierReturnsRouteRouteWithChildren
  '/_app/suppliers': typeof AppSuppliersRouteRouteWithChildren
  '/_app/tasks': typeof AppTasksRouteRouteWithChildren
  '/_app/teams': typeof AppTeamsRouteRouteWithChildren
  '/_app/users': typeof AppUsersRouteRouteWithChildren
  '/_app/workflows': typeof AppWorkflowsRouteRouteWithChildren
  '/_app/account-mapping': typeof AppAccountMappingRoute
  '/_app/accounts': typeof AppAccountsRoute
  '/_app/audit-log': typeof AppAuditLogRoute
  '/_app/balance-sheet': typeof AppBalanceSheetRoute
  '/_app/books-health': typeof AppBooksHealthRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/cash-bank': typeof AppCashBankRoute
  '/_app/cash-flow': typeof AppCashFlowRoute
  '/_app/change-password': typeof AppChangePasswordRoute
  '/_app/customer-groups': typeof AppCustomerGroupsRoute
  '/_app/expense-categories': typeof AppExpenseCategoriesRoute
  '/_app/fiscal-years': typeof AppFiscalYearsRoute
  '/_app/general-ledger': typeof AppGeneralLedgerRoute
  '/_app/low-stock': typeof AppLowStockRoute
  '/_app/my-work': typeof AppMyWorkRoute
  '/_app/payables-aging': typeof AppPayablesAgingRoute
  '/_app/pos-summary': typeof AppPosSummaryRoute
  '/_app/product-attributes': typeof AppProductAttributesRoute
  '/_app/product-categories': typeof AppProductCategoriesRoute
  '/_app/profit-and-loss': typeof AppProfitAndLossRoute
  '/_app/project-budget-vs-actual': typeof AppProjectBudgetVsActualRoute
  '/_app/project-profitability': typeof AppProjectProfitabilityRoute
  '/_app/project-unbilled-work': typeof AppProjectUnbilledWorkRoute
  '/_app/project-utilisation': typeof AppProjectUtilisationRoute
  '/_app/purchases-by-product': typeof AppPurchasesByProductRoute
  '/_app/purchases-by-supplier': typeof AppPurchasesBySupplierRoute
  '/_app/receivables-aging': typeof AppReceivablesAgingRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/sales-by-customer': typeof AppSalesByCustomerRoute
  '/_app/sales-by-period': typeof AppSalesByPeriodRoute
  '/_app/sales-by-product': typeof AppSalesByProductRoute
  '/_app/sales-by-salesperson': typeof AppSalesBySalespersonRoute
  '/_app/sales-by-user': typeof AppSalesByUserRoute
  '/_app/stock': typeof AppStockRoute
  '/_app/stock-movements': typeof AppStockMovementsRoute
  '/_app/stock-valuation': typeof AppStockValuationRoute
  '/_app/supplier-groups': typeof AppSupplierGroupsRoute
  '/_app/task-report': typeof AppTaskReportRoute
  '/_app/tax-rates': typeof AppTaxRatesRoute
  '/_app/transfers': typeof AppTransfersRoute
  '/_app/trial-balance': typeof AppTrialBalanceRoute
  '/_app/units': typeof AppUnitsRoute
  '/_app/vat-return': typeof AppVatReturnRoute
  '/_app/warehouses': typeof AppWarehousesRoute
  '/p/$token': typeof PTokenRoute
  '/platform/_console': typeof PlatformConsoleRouteWithChildren
  '/platform/login': typeof PlatformLoginRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/cheques/$chequeId': typeof AppChequesChequeIdRouteRouteWithChildren
  '/_app/commissions/mine': typeof AppCommissionsMineRouteRouteWithChildren
  '/_app/commissions/plans': typeof AppCommissionsPlansRouteRouteWithChildren
  '/_app/commissions/runs': typeof AppCommissionsRunsRouteRouteWithChildren
  '/_app/commissions/statements': typeof AppCommissionsStatementsRouteRouteWithChildren
  '/_app/credit-notes/$creditNoteId': typeof AppCreditNotesCreditNoteIdRouteRouteWithChildren
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRouteRouteWithChildren
  '/_app/expenses/$expenseId': typeof AppExpensesExpenseIdRouteRouteWithChildren
  '/_app/expenses/recurring': typeof AppExpensesRecurringRouteRouteWithChildren
  '/_app/hr/employees': typeof AppHrEmployeesRouteRouteWithChildren
  '/_app/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRouteRouteWithChildren
  '/_app/loyalty/members': typeof AppLoyaltyMembersRouteRouteWithChildren
  '/_app/payroll/runs': typeof AppPayrollRunsRouteRouteWithChildren
  '/_app/pos/shifts': typeof AppPosShiftsRouteRouteWithChildren
  '/_app/products/$productId': typeof AppProductsProductIdRouteRouteWithChildren
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteRouteWithChildren
  '/_app/projects/cost-entries': typeof AppProjectsCostEntriesRouteRouteWithChildren
  '/_app/projects/material-issues': typeof AppProjectsMaterialIssuesRouteRouteWithChildren
  '/_app/purchases/$purchaseId': typeof AppPurchasesPurchaseIdRouteRouteWithChildren
  '/_app/quotations/$quotationId': typeof AppQuotationsQuotationIdRouteRouteWithChildren
  '/_app/receipts/$receiptId': typeof AppReceiptsReceiptIdRouteRouteWithChildren
  '/_app/refunds/$refundId': typeof AppRefundsRefundIdRouteRouteWithChildren
  '/_app/service/assets': typeof AppServiceAssetsRouteRouteWithChildren
  '/_app/service/contracts': typeof AppServiceContractsRouteRouteWithChildren
  '/_app/service/jobs': typeof AppServiceJobsRouteRouteWithChildren
  '/_app/service/sites': typeof AppServiceSitesRouteRouteWithChildren
  '/_app/service/visits': typeof AppServiceVisitsRouteRouteWithChildren
  '/_app/stock-transfers/$transferId': typeof AppStockTransfersTransferIdRouteRouteWithChildren
  '/_app/supplier-payments/$paymentId': typeof AppSupplierPaymentsPaymentIdRouteRouteWithChildren
  '/_app/supplier-refunds/$refundId': typeof AppSupplierRefundsRefundIdRouteRouteWithChildren
  '/_app/supplier-returns/$returnId': typeof AppSupplierReturnsReturnIdRouteRouteWithChildren
  '/_app/suppliers/$supplierId': typeof AppSuppliersSupplierIdRouteRouteWithChildren
  '/_app/workflows/runs': typeof AppWorkflowsRunsRouteRouteWithChildren
  '/_app/approvals/$runId': typeof AppApprovalsRunIdRoute
  '/_app/bank-statements/$statementId': typeof AppBankStatementsStatementIdRoute
  '/_app/bank-statements/new': typeof AppBankStatementsNewRoute
  '/_app/credit-notes/new': typeof AppCreditNotesNewRoute
  '/_app/customers/new': typeof AppCustomersNewRoute
  '/_app/expenses/new': typeof AppExpensesNewRoute
  '/_app/hr/documents': typeof AppHrDocumentsRoute
  '/_app/hr/pay-components': typeof AppHrPayComponentsRoute
  '/_app/invoices/new': typeof AppInvoicesNewRoute
  '/_app/journal-entries/$entryId': typeof AppJournalEntriesEntryIdRoute
  '/_app/journal-entries/new': typeof AppJournalEntriesNewRoute
  '/_app/loyalty/program': typeof AppLoyaltyProgramRoute
  '/_app/loyalty/transactions': typeof AppLoyaltyTransactionsRoute
  '/_app/payroll/contributions': typeof AppPayrollContributionsRoute
  '/_app/payroll/settings': typeof AppPayrollSettingsRoute
  '/_app/pos/tills': typeof AppPosTillsRoute
  '/_app/privacy-requests/$requestId': typeof AppPrivacyRequestsRequestIdRoute
  '/_app/products/new': typeof AppProductsNewRoute
  '/_app/projects/guarantees': typeof AppProjectsGuaranteesRoute
  '/_app/projects/rates': typeof AppProjectsRatesRoute
  '/_app/projects/reconciliation': typeof AppProjectsReconciliationRoute
  '/_app/projects/status-reports': typeof AppProjectsStatusReportsRoute
  '/_app/purchases/new': typeof AppPurchasesNewRoute
  '/_app/quotations/new': typeof AppQuotationsNewRoute
  '/_app/receipts/new': typeof AppReceiptsNewRoute
  '/_app/refunds/new': typeof AppRefundsNewRoute
  '/_app/roles/$roleId': typeof AppRolesRoleIdRoute
  '/_app/roles/new': typeof AppRolesNewRoute
  '/_app/serials/$serialId': typeof AppSerialsSerialIdRoute
  '/_app/service/collections': typeof AppServiceCollectionsRoute
  '/_app/service/follow-ups': typeof AppServiceFollowUpsRoute
  '/_app/service/my-visits': typeof AppServiceMyVisitsRoute
  '/_app/service/schedule': typeof AppServiceScheduleRoute
  '/_app/settings/account-mapping': typeof AppSettingsAccountMappingRoute
  '/_app/settings/accounting-checks': typeof AppSettingsAccountingChecksRoute
  '/_app/settings/appearance': typeof AppSettingsAppearanceRoute
  '/_app/settings/calendar': typeof AppSettingsCalendarRoute
  '/_app/settings/commissions': typeof AppSettingsCommissionsRoute
  '/_app/settings/company': typeof AppSettingsCompanyRoute
  '/_app/settings/contracts': typeof AppSettingsContractsRoute
  '/_app/settings/defaults': typeof AppSettingsDefaultsRoute
  '/_app/settings/legal-holds': typeof AppSettingsLegalHoldsRoute
  '/_app/settings/lock-date': typeof AppSettingsLockDateRoute
  '/_app/settings/message-outbox': typeof AppSettingsMessageOutboxRoute
  '/_app/settings/message-templates': typeof AppSettingsMessageTemplatesRoute
  '/_app/settings/modules': typeof AppSettingsModulesRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/numbering': typeof AppSettingsNumberingRoute
  '/_app/settings/organization': typeof AppSettingsOrganizationRoute
  '/_app/settings/payment-methods': typeof AppSettingsPaymentMethodsRoute
  '/_app/settings/printing': typeof AppSettingsPrintingRoute
  '/_app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/_app/settings/project-contracting': typeof AppSettingsProjectContractingRoute
  '/_app/settings/project-cost-categories': typeof AppSettingsProjectCostCategoriesRoute
  '/_app/settings/project-insights': typeof AppSettingsProjectInsightsRoute
  '/_app/settings/project-rate-roles': typeof AppSettingsProjectRateRolesRoute
  '/_app/settings/project-types': typeof AppSettingsProjectTypesRoute
  '/_app/settings/projects': typeof AppSettingsProjectsRoute
  '/_app/settings/regional': typeof AppSettingsRegionalRoute
  '/_app/settings/service': typeof AppSettingsServiceRoute
  '/_app/settings/service-asset-types': typeof AppSettingsServiceAssetTypesRoute
  '/_app/settings/service-site-templates': typeof AppSettingsServiceSiteTemplatesRoute
  '/_app/settings/stock-policy': typeof AppSettingsStockPolicyRoute
  '/_app/settings/system': typeof AppSettingsSystemRoute
  '/_app/settings/tasks': typeof AppSettingsTasksRoute
  '/_app/settings/tax-rates': typeof AppSettingsTaxRatesRoute
  '/_app/settings/teams': typeof AppSettingsTeamsRoute
  '/_app/settings/typography': typeof AppSettingsTypographyRoute
  '/_app/settings/work-locations': typeof AppSettingsWorkLocationsRoute
  '/_app/stock-adjustments/$adjustmentId': typeof AppStockAdjustmentsAdjustmentIdRoute
  '/_app/stock-adjustments/new': typeof AppStockAdjustmentsNewRoute
  '/_app/stock-transfers/new': typeof AppStockTransfersNewRoute
  '/_app/supplier-payments/new': typeof AppSupplierPaymentsNewRoute
  '/_app/supplier-refunds/new': typeof AppSupplierRefundsNewRoute
  '/_app/supplier-returns/new': typeof AppSupplierReturnsNewRoute
  '/_app/suppliers/new': typeof AppSuppliersNewRoute
  '/_app/tasks/$taskId': typeof AppTasksTaskIdRoute
  '/_app/teams/$teamId': typeof AppTeamsTeamIdRoute
  '/_app/users/$userId': typeof AppUsersUserIdRoute
  '/_app/users/new': typeof AppUsersNewRoute
  '/_app/workflows/$workflowId': typeof AppWorkflowsWorkflowIdRoute
  '/_app/workflows/delegations': typeof AppWorkflowsDelegationsRoute
  '/platform/_console/dashboard': typeof PlatformConsoleDashboardRoute
  '/platform/_console/feedback': typeof PlatformConsoleFeedbackRoute
  '/platform/_console/profile': typeof PlatformConsoleProfileRoute
  '/platform/_console/subscriptions': typeof PlatformConsoleSubscriptionsRoute
  '/_app/approvals/': typeof AppApprovalsIndexRoute
  '/_app/bank-statements/': typeof AppBankStatementsIndexRoute
  '/_app/cheques/': typeof AppChequesIndexRoute
  '/_app/commissions/': typeof AppCommissionsIndexRoute
  '/_app/credit-notes/': typeof AppCreditNotesIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/expenses/': typeof AppExpensesIndexRoute
  '/_app/hr/': typeof AppHrIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/journal-entries/': typeof AppJournalEntriesIndexRoute
  '/_app/loyalty/': typeof AppLoyaltyIndexRoute
  '/_app/payroll/': typeof AppPayrollIndexRoute
  '/_app/pos/': typeof AppPosIndexRoute
  '/_app/privacy-requests/': typeof AppPrivacyRequestsIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/purchases/': typeof AppPurchasesIndexRoute
  '/_app/quotations/': typeof AppQuotationsIndexRoute
  '/_app/receipts/': typeof AppReceiptsIndexRoute
  '/_app/refunds/': typeof AppRefundsIndexRoute
  '/_app/roles/': typeof AppRolesIndexRoute
  '/_app/serials/': typeof AppSerialsIndexRoute
  '/_app/service/': typeof AppServiceIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/stock-adjustments/': typeof AppStockAdjustmentsIndexRoute
  '/_app/stock-transfers/': typeof AppStockTransfersIndexRoute
  '/_app/supplier-payments/': typeof AppSupplierPaymentsIndexRoute
  '/_app/supplier-refunds/': typeof AppSupplierRefundsIndexRoute
  '/_app/supplier-returns/': typeof AppSupplierReturnsIndexRoute
  '/_app/suppliers/': typeof AppSuppliersIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/teams/': typeof AppTeamsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/workflows/': typeof AppWorkflowsIndexRoute
  '/platform/_console/': typeof PlatformConsoleIndexRoute
  '/_app/expenses/recurring/$recurringId': typeof AppExpensesRecurringRecurringIdRouteRouteWithChildren
  '/_app/hr/employees/$employeeId': typeof AppHrEmployeesEmployeeIdRouteRouteWithChildren
  '/_app/payroll/runs/$runId': typeof AppPayrollRunsRunIdRouteRouteWithChildren
  '/_app/service/contracts/$contractId': typeof AppServiceContractsContractIdRouteRouteWithChildren
  '/_app/service/jobs/$jobId': typeof AppServiceJobsJobIdRouteRouteWithChildren
  '/_app/service/visits/$visitId': typeof AppServiceVisitsVisitIdRouteRouteWithChildren
  '/_app/commissions/mine/$statementId': typeof AppCommissionsMineStatementIdRoute
  '/_app/commissions/plans/$planId': typeof AppCommissionsPlansPlanIdRoute
  '/_app/commissions/plans/new': typeof AppCommissionsPlansNewRoute
  '/_app/commissions/runs/$runId': typeof AppCommissionsRunsRunIdRoute
  '/_app/commissions/statements/$statementId': typeof AppCommissionsStatementsStatementIdRoute
  '/_app/credit-notes/$creditNoteId/edit': typeof AppCreditNotesCreditNoteIdEditRoute
  '/_app/credit-notes/$creditNoteId/print': typeof AppCreditNotesCreditNoteIdPrintRoute
  '/_app/customers/$customerId/edit': typeof AppCustomersCustomerIdEditRoute
  '/_app/expenses/$expenseId/edit': typeof AppExpensesExpenseIdEditRoute
  '/_app/expenses/recurring/new': typeof AppExpensesRecurringNewRoute
  '/_app/hr/employees/new': typeof AppHrEmployeesNewRoute
  '/_app/invoices/$invoiceId/edit': typeof AppInvoicesInvoiceIdEditRoute
  '/_app/invoices/$invoiceId/print': typeof AppInvoicesInvoiceIdPrintRoute
  '/_app/loyalty/members/$memberId': typeof AppLoyaltyMembersMemberIdRoute
  '/_app/pos/returns/$returnId': typeof AppPosReturnsReturnIdRoute
  '/_app/pos/sales/$saleId': typeof AppPosSalesSaleIdRoute
  '/_app/pos/shifts/$shiftId': typeof AppPosShiftsShiftIdRoute
  '/_app/products/$productId/edit': typeof AppProductsProductIdEditRoute
  '/_app/products/$productId/labels': typeof AppProductsProductIdLabelsRoute
  '/_app/projects/cost-entries/$entryId': typeof AppProjectsCostEntriesEntryIdRoute
  '/_app/projects/material-issues/$issueId': typeof AppProjectsMaterialIssuesIssueIdRoute
  '/_app/projects/time/approvals': typeof AppProjectsTimeApprovalsRoute
  '/_app/purchases/$purchaseId/edit': typeof AppPurchasesPurchaseIdEditRoute
  '/_app/purchases/$purchaseId/print': typeof AppPurchasesPurchaseIdPrintRoute
  '/_app/quotations/$quotationId/edit': typeof AppQuotationsQuotationIdEditRoute
  '/_app/quotations/$quotationId/print': typeof AppQuotationsQuotationIdPrintRoute
  '/_app/receipts/$receiptId/print': typeof AppReceiptsReceiptIdPrintRoute
  '/_app/refunds/$refundId/print': typeof AppRefundsRefundIdPrintRoute
  '/_app/service/assets/$assetId': typeof AppServiceAssetsAssetIdRoute
  '/_app/service/assets/labels': typeof AppServiceAssetsLabelsRoute
  '/_app/service/contracts/billing': typeof AppServiceContractsBillingRoute
  '/_app/service/contracts/insights': typeof AppServiceContractsInsightsRoute
  '/_app/service/contracts/new': typeof AppServiceContractsNewRoute
  '/_app/service/sites/$siteId': typeof AppServiceSitesSiteIdRoute
  '/_app/settings/ai/usage': typeof AppSettingsAiUsageRoute
  '/_app/stock-transfers/$transferId/edit': typeof AppStockTransfersTransferIdEditRoute
  '/_app/stock-transfers/$transferId/print': typeof AppStockTransfersTransferIdPrintRoute
  '/_app/supplier-payments/$paymentId/print': typeof AppSupplierPaymentsPaymentIdPrintRoute
  '/_app/supplier-refunds/$refundId/print': typeof AppSupplierRefundsRefundIdPrintRoute
  '/_app/supplier-returns/$returnId/edit': typeof AppSupplierReturnsReturnIdEditRoute
  '/_app/supplier-returns/$returnId/print': typeof AppSupplierReturnsReturnIdPrintRoute
  '/_app/suppliers/$supplierId/edit': typeof AppSuppliersSupplierIdEditRoute
  '/_app/workflows/runs/$runId': typeof AppWorkflowsRunsRunIdRoute
  '/platform/_console/tenants/$tenantId': typeof PlatformConsoleTenantsTenantIdRoute
  '/platform/_console/tenants/new': typeof PlatformConsoleTenantsNewRoute
  '/_app/cheques/$chequeId/': typeof AppChequesChequeIdIndexRoute
  '/_app/commissions/mine/': typeof AppCommissionsMineIndexRoute
  '/_app/commissions/plans/': typeof AppCommissionsPlansIndexRoute
  '/_app/commissions/runs/': typeof AppCommissionsRunsIndexRoute
  '/_app/credit-notes/$creditNoteId/': typeof AppCreditNotesCreditNoteIdIndexRoute
  '/_app/customers/$customerId/': typeof AppCustomersCustomerIdIndexRoute
  '/_app/expenses/$expenseId/': typeof AppExpensesExpenseIdIndexRoute
  '/_app/expenses/recurring/': typeof AppExpensesRecurringIndexRoute
  '/_app/hr/employees/': typeof AppHrEmployeesIndexRoute
  '/_app/invoices/$invoiceId/': typeof AppInvoicesInvoiceIdIndexRoute
  '/_app/loyalty/members/': typeof AppLoyaltyMembersIndexRoute
  '/_app/payroll/runs/': typeof AppPayrollRunsIndexRoute
  '/_app/pos/shifts/': typeof AppPosShiftsIndexRoute
  '/_app/products/$productId/': typeof AppProductsProductIdIndexRoute
  '/_app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/_app/projects/cost-entries/': typeof AppProjectsCostEntriesIndexRoute
  '/_app/projects/material-issues/': typeof AppProjectsMaterialIssuesIndexRoute
  '/_app/projects/time/': typeof AppProjectsTimeIndexRoute
  '/_app/purchases/$purchaseId/': typeof AppPurchasesPurchaseIdIndexRoute
  '/_app/quotations/$quotationId/': typeof AppQuotationsQuotationIdIndexRoute
  '/_app/receipts/$receiptId/': typeof AppReceiptsReceiptIdIndexRoute
  '/_app/refunds/$refundId/': typeof AppRefundsRefundIdIndexRoute
  '/_app/service/assets/': typeof AppServiceAssetsIndexRoute
  '/_app/service/contracts/': typeof AppServiceContractsIndexRoute
  '/_app/service/jobs/': typeof AppServiceJobsIndexRoute
  '/_app/service/sites/': typeof AppServiceSitesIndexRoute
  '/_app/service/visits/': typeof AppServiceVisitsIndexRoute
  '/_app/settings/ai/': typeof AppSettingsAiIndexRoute
  '/_app/stock-transfers/$transferId/': typeof AppStockTransfersTransferIdIndexRoute
  '/_app/supplier-payments/$paymentId/': typeof AppSupplierPaymentsPaymentIdIndexRoute
  '/_app/supplier-refunds/$refundId/': typeof AppSupplierRefundsRefundIdIndexRoute
  '/_app/supplier-returns/$returnId/': typeof AppSupplierReturnsReturnIdIndexRoute
  '/_app/suppliers/$supplierId/': typeof AppSuppliersSupplierIdIndexRoute
  '/_app/workflows/runs/': typeof AppWorkflowsRunsIndexRoute
  '/platform/_console/tenants/': typeof PlatformConsoleTenantsIndexRoute
  '/_app/expenses/recurring/$recurringId/edit': typeof AppExpensesRecurringRecurringIdEditRoute
  '/_app/hr/employees/$employeeId/edit': typeof AppHrEmployeesEmployeeIdEditRoute
  '/_app/projects/$projectId/contract/statement': typeof AppProjectsProjectIdContractStatementRoute
  '/_app/service/contracts/$contractId/edit': typeof AppServiceContractsContractIdEditRoute
  '/_app/service/contracts/$contractId/print': typeof AppServiceContractsContractIdPrintRoute
  '/_app/service/jobs/$jobId/estimate': typeof AppServiceJobsJobIdEstimateRoute
  '/_app/service/visits/$visitId/report': typeof AppServiceVisitsVisitIdReportRoute
  '/_app/expenses/recurring/$recurringId/': typeof AppExpensesRecurringRecurringIdIndexRoute
  '/_app/hr/employees/$employeeId/': typeof AppHrEmployeesEmployeeIdIndexRoute
  '/_app/payroll/runs/$runId/': typeof AppPayrollRunsRunIdIndexRoute
  '/_app/projects/$projectId/reports/': typeof AppProjectsProjectIdReportsIndexRoute
  '/_app/service/contracts/$contractId/': typeof AppServiceContractsContractIdIndexRoute
  '/_app/service/jobs/$jobId/': typeof AppServiceJobsJobIdIndexRoute
  '/_app/service/visits/$visitId/': typeof AppServiceVisitsVisitIdIndexRoute
  '/_app/payroll/runs/$runId/payslips/$payslipId': typeof AppPayrollRunsRunIdPayslipsPayslipIdRoute
  '/_app/projects/$projectId/claims/$claimId/print': typeof AppProjectsProjectIdClaimsClaimIdPrintRoute
  '/_app/projects/$projectId/reports/$reportId/print': typeof AppProjectsProjectIdReportsReportIdPrintRoute
  '/_app/projects/$projectId/claims/$claimId/': typeof AppProjectsProjectIdClaimsClaimIdIndexRoute
  '/_app/projects/$projectId/reports/$reportId/': typeof AppProjectsProjectIdReportsReportIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/approvals'
    | '/bank-statements'
    | '/cheques'
    | '/commissions'
    | '/credit-notes'
    | '/customers'
    | '/expenses'
    | '/hr'
    | '/invoices'
    | '/journal-entries'
    | '/loyalty'
    | '/payroll'
    | '/privacy-requests'
    | '/products'
    | '/projects'
    | '/purchases'
    | '/quotations'
    | '/receipts'
    | '/refunds'
    | '/roles'
    | '/serials'
    | '/service'
    | '/settings'
    | '/stock-adjustments'
    | '/stock-transfers'
    | '/supplier-payments'
    | '/supplier-refunds'
    | '/supplier-returns'
    | '/suppliers'
    | '/tasks'
    | '/teams'
    | '/users'
    | '/workflows'
    | '/account-mapping'
    | '/accounts'
    | '/audit-log'
    | '/balance-sheet'
    | '/books-health'
    | '/calendar'
    | '/cash-bank'
    | '/cash-flow'
    | '/change-password'
    | '/customer-groups'
    | '/expense-categories'
    | '/fiscal-years'
    | '/general-ledger'
    | '/low-stock'
    | '/my-work'
    | '/payables-aging'
    | '/pos-summary'
    | '/product-attributes'
    | '/product-categories'
    | '/profit-and-loss'
    | '/project-budget-vs-actual'
    | '/project-profitability'
    | '/project-unbilled-work'
    | '/project-utilisation'
    | '/purchases-by-product'
    | '/purchases-by-supplier'
    | '/receivables-aging'
    | '/reports'
    | '/sales-by-customer'
    | '/sales-by-period'
    | '/sales-by-product'
    | '/sales-by-salesperson'
    | '/sales-by-user'
    | '/stock'
    | '/stock-movements'
    | '/stock-valuation'
    | '/supplier-groups'
    | '/task-report'
    | '/tax-rates'
    | '/transfers'
    | '/trial-balance'
    | '/units'
    | '/vat-return'
    | '/warehouses'
    | '/p/$token'
    | '/platform'
    | '/platform/login'
    | '/set-password/$token'
    | '/cheques/$chequeId'
    | '/commissions/mine'
    | '/commissions/plans'
    | '/commissions/runs'
    | '/commissions/statements'
    | '/credit-notes/$creditNoteId'
    | '/customers/$customerId'
    | '/expenses/$expenseId'
    | '/expenses/recurring'
    | '/hr/employees'
    | '/invoices/$invoiceId'
    | '/loyalty/members'
    | '/payroll/runs'
    | '/pos/shifts'
    | '/products/$productId'
    | '/projects/$projectId'
    | '/projects/cost-entries'
    | '/projects/material-issues'
    | '/purchases/$purchaseId'
    | '/quotations/$quotationId'
    | '/receipts/$receiptId'
    | '/refunds/$refundId'
    | '/service/assets'
    | '/service/contracts'
    | '/service/jobs'
    | '/service/sites'
    | '/service/visits'
    | '/stock-transfers/$transferId'
    | '/supplier-payments/$paymentId'
    | '/supplier-refunds/$refundId'
    | '/supplier-returns/$returnId'
    | '/suppliers/$supplierId'
    | '/workflows/runs'
    | '/approvals/$runId'
    | '/bank-statements/$statementId'
    | '/bank-statements/new'
    | '/credit-notes/new'
    | '/customers/new'
    | '/expenses/new'
    | '/hr/documents'
    | '/hr/pay-components'
    | '/invoices/new'
    | '/journal-entries/$entryId'
    | '/journal-entries/new'
    | '/loyalty/program'
    | '/loyalty/transactions'
    | '/payroll/contributions'
    | '/payroll/settings'
    | '/pos/tills'
    | '/privacy-requests/$requestId'
    | '/products/new'
    | '/projects/guarantees'
    | '/projects/rates'
    | '/projects/reconciliation'
    | '/projects/status-reports'
    | '/purchases/new'
    | '/quotations/new'
    | '/receipts/new'
    | '/refunds/new'
    | '/roles/$roleId'
    | '/roles/new'
    | '/serials/$serialId'
    | '/service/collections'
    | '/service/follow-ups'
    | '/service/my-visits'
    | '/service/schedule'
    | '/settings/account-mapping'
    | '/settings/accounting-checks'
    | '/settings/appearance'
    | '/settings/calendar'
    | '/settings/commissions'
    | '/settings/company'
    | '/settings/contracts'
    | '/settings/defaults'
    | '/settings/legal-holds'
    | '/settings/lock-date'
    | '/settings/message-outbox'
    | '/settings/message-templates'
    | '/settings/modules'
    | '/settings/notifications'
    | '/settings/numbering'
    | '/settings/organization'
    | '/settings/payment-methods'
    | '/settings/printing'
    | '/settings/privacy'
    | '/settings/project-contracting'
    | '/settings/project-cost-categories'
    | '/settings/project-insights'
    | '/settings/project-rate-roles'
    | '/settings/project-types'
    | '/settings/projects'
    | '/settings/regional'
    | '/settings/service'
    | '/settings/service-asset-types'
    | '/settings/service-site-templates'
    | '/settings/stock-policy'
    | '/settings/system'
    | '/settings/tasks'
    | '/settings/tax-rates'
    | '/settings/teams'
    | '/settings/typography'
    | '/settings/work-locations'
    | '/stock-adjustments/$adjustmentId'
    | '/stock-adjustments/new'
    | '/stock-transfers/new'
    | '/supplier-payments/new'
    | '/supplier-refunds/new'
    | '/supplier-returns/new'
    | '/suppliers/new'
    | '/tasks/$taskId'
    | '/teams/$teamId'
    | '/users/$userId'
    | '/users/new'
    | '/workflows/$workflowId'
    | '/workflows/delegations'
    | '/platform/dashboard'
    | '/platform/feedback'
    | '/platform/profile'
    | '/platform/subscriptions'
    | '/approvals/'
    | '/bank-statements/'
    | '/cheques/'
    | '/commissions/'
    | '/credit-notes/'
    | '/customers/'
    | '/expenses/'
    | '/hr/'
    | '/invoices/'
    | '/journal-entries/'
    | '/loyalty/'
    | '/payroll/'
    | '/pos/'
    | '/privacy-requests/'
    | '/products/'
    | '/projects/'
    | '/purchases/'
    | '/quotations/'
    | '/receipts/'
    | '/refunds/'
    | '/roles/'
    | '/serials/'
    | '/service/'
    | '/settings/'
    | '/stock-adjustments/'
    | '/stock-transfers/'
    | '/supplier-payments/'
    | '/supplier-refunds/'
    | '/supplier-returns/'
    | '/suppliers/'
    | '/tasks/'
    | '/teams/'
    | '/users/'
    | '/workflows/'
    | '/platform/'
    | '/expenses/recurring/$recurringId'
    | '/hr/employees/$employeeId'
    | '/payroll/runs/$runId'
    | '/service/contracts/$contractId'
    | '/service/jobs/$jobId'
    | '/service/visits/$visitId'
    | '/commissions/mine/$statementId'
    | '/commissions/plans/$planId'
    | '/commissions/plans/new'
    | '/commissions/runs/$runId'
    | '/commissions/statements/$statementId'
    | '/credit-notes/$creditNoteId/edit'
    | '/credit-notes/$creditNoteId/print'
    | '/customers/$customerId/edit'
    | '/expenses/$expenseId/edit'
    | '/expenses/recurring/new'
    | '/hr/employees/new'
    | '/invoices/$invoiceId/edit'
    | '/invoices/$invoiceId/print'
    | '/loyalty/members/$memberId'
    | '/pos/returns/$returnId'
    | '/pos/sales/$saleId'
    | '/pos/shifts/$shiftId'
    | '/products/$productId/edit'
    | '/products/$productId/labels'
    | '/projects/cost-entries/$entryId'
    | '/projects/material-issues/$issueId'
    | '/projects/time/approvals'
    | '/purchases/$purchaseId/edit'
    | '/purchases/$purchaseId/print'
    | '/quotations/$quotationId/edit'
    | '/quotations/$quotationId/print'
    | '/receipts/$receiptId/print'
    | '/refunds/$refundId/print'
    | '/service/assets/$assetId'
    | '/service/assets/labels'
    | '/service/contracts/billing'
    | '/service/contracts/insights'
    | '/service/contracts/new'
    | '/service/sites/$siteId'
    | '/settings/ai/usage'
    | '/stock-transfers/$transferId/edit'
    | '/stock-transfers/$transferId/print'
    | '/supplier-payments/$paymentId/print'
    | '/supplier-refunds/$refundId/print'
    | '/supplier-returns/$returnId/edit'
    | '/supplier-returns/$returnId/print'
    | '/suppliers/$supplierId/edit'
    | '/workflows/runs/$runId'
    | '/platform/tenants/$tenantId'
    | '/platform/tenants/new'
    | '/cheques/$chequeId/'
    | '/commissions/mine/'
    | '/commissions/plans/'
    | '/commissions/runs/'
    | '/credit-notes/$creditNoteId/'
    | '/customers/$customerId/'
    | '/expenses/$expenseId/'
    | '/expenses/recurring/'
    | '/hr/employees/'
    | '/invoices/$invoiceId/'
    | '/loyalty/members/'
    | '/payroll/runs/'
    | '/pos/shifts/'
    | '/products/$productId/'
    | '/projects/$projectId/'
    | '/projects/cost-entries/'
    | '/projects/material-issues/'
    | '/projects/time/'
    | '/purchases/$purchaseId/'
    | '/quotations/$quotationId/'
    | '/receipts/$receiptId/'
    | '/refunds/$refundId/'
    | '/service/assets/'
    | '/service/contracts/'
    | '/service/jobs/'
    | '/service/sites/'
    | '/service/visits/'
    | '/settings/ai/'
    | '/stock-transfers/$transferId/'
    | '/supplier-payments/$paymentId/'
    | '/supplier-refunds/$refundId/'
    | '/supplier-returns/$returnId/'
    | '/suppliers/$supplierId/'
    | '/workflows/runs/'
    | '/platform/tenants/'
    | '/expenses/recurring/$recurringId/edit'
    | '/hr/employees/$employeeId/edit'
    | '/projects/$projectId/contract/statement'
    | '/service/contracts/$contractId/edit'
    | '/service/contracts/$contractId/print'
    | '/service/jobs/$jobId/estimate'
    | '/service/visits/$visitId/report'
    | '/expenses/recurring/$recurringId/'
    | '/hr/employees/$employeeId/'
    | '/payroll/runs/$runId/'
    | '/projects/$projectId/reports/'
    | '/service/contracts/$contractId/'
    | '/service/jobs/$jobId/'
    | '/service/visits/$visitId/'
    | '/payroll/runs/$runId/payslips/$payslipId'
    | '/projects/$projectId/claims/$claimId/print'
    | '/projects/$projectId/reports/$reportId/print'
    | '/projects/$projectId/claims/$claimId/'
    | '/projects/$projectId/reports/$reportId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/account-mapping'
    | '/accounts'
    | '/audit-log'
    | '/balance-sheet'
    | '/books-health'
    | '/calendar'
    | '/cash-bank'
    | '/cash-flow'
    | '/change-password'
    | '/customer-groups'
    | '/expense-categories'
    | '/fiscal-years'
    | '/general-ledger'
    | '/low-stock'
    | '/my-work'
    | '/payables-aging'
    | '/pos-summary'
    | '/product-attributes'
    | '/product-categories'
    | '/profit-and-loss'
    | '/project-budget-vs-actual'
    | '/project-profitability'
    | '/project-unbilled-work'
    | '/project-utilisation'
    | '/purchases-by-product'
    | '/purchases-by-supplier'
    | '/receivables-aging'
    | '/reports'
    | '/sales-by-customer'
    | '/sales-by-period'
    | '/sales-by-product'
    | '/sales-by-salesperson'
    | '/sales-by-user'
    | '/stock'
    | '/stock-movements'
    | '/stock-valuation'
    | '/supplier-groups'
    | '/task-report'
    | '/tax-rates'
    | '/transfers'
    | '/trial-balance'
    | '/units'
    | '/vat-return'
    | '/warehouses'
    | '/p/$token'
    | '/platform/login'
    | '/set-password/$token'
    | '/'
    | '/commissions/statements'
    | '/approvals/$runId'
    | '/bank-statements/$statementId'
    | '/bank-statements/new'
    | '/credit-notes/new'
    | '/customers/new'
    | '/expenses/new'
    | '/hr/documents'
    | '/hr/pay-components'
    | '/invoices/new'
    | '/journal-entries/$entryId'
    | '/journal-entries/new'
    | '/loyalty/program'
    | '/loyalty/transactions'
    | '/payroll/contributions'
    | '/payroll/settings'
    | '/pos/tills'
    | '/privacy-requests/$requestId'
    | '/products/new'
    | '/projects/guarantees'
    | '/projects/rates'
    | '/projects/reconciliation'
    | '/projects/status-reports'
    | '/purchases/new'
    | '/quotations/new'
    | '/receipts/new'
    | '/refunds/new'
    | '/roles/$roleId'
    | '/roles/new'
    | '/serials/$serialId'
    | '/service/collections'
    | '/service/follow-ups'
    | '/service/my-visits'
    | '/service/schedule'
    | '/settings/account-mapping'
    | '/settings/accounting-checks'
    | '/settings/appearance'
    | '/settings/calendar'
    | '/settings/commissions'
    | '/settings/company'
    | '/settings/contracts'
    | '/settings/defaults'
    | '/settings/legal-holds'
    | '/settings/lock-date'
    | '/settings/message-outbox'
    | '/settings/message-templates'
    | '/settings/modules'
    | '/settings/notifications'
    | '/settings/numbering'
    | '/settings/organization'
    | '/settings/payment-methods'
    | '/settings/printing'
    | '/settings/privacy'
    | '/settings/project-contracting'
    | '/settings/project-cost-categories'
    | '/settings/project-insights'
    | '/settings/project-rate-roles'
    | '/settings/project-types'
    | '/settings/projects'
    | '/settings/regional'
    | '/settings/service'
    | '/settings/service-asset-types'
    | '/settings/service-site-templates'
    | '/settings/stock-policy'
    | '/settings/system'
    | '/settings/tasks'
    | '/settings/tax-rates'
    | '/settings/teams'
    | '/settings/typography'
    | '/settings/work-locations'
    | '/stock-adjustments/$adjustmentId'
    | '/stock-adjustments/new'
    | '/stock-transfers/new'
    | '/supplier-payments/new'
    | '/supplier-refunds/new'
    | '/supplier-returns/new'
    | '/suppliers/new'
    | '/tasks/$taskId'
    | '/teams/$teamId'
    | '/users/$userId'
    | '/users/new'
    | '/workflows/$workflowId'
    | '/workflows/delegations'
    | '/platform/dashboard'
    | '/platform/feedback'
    | '/platform/profile'
    | '/platform/subscriptions'
    | '/approvals'
    | '/bank-statements'
    | '/cheques'
    | '/commissions'
    | '/credit-notes'
    | '/customers'
    | '/expenses'
    | '/hr'
    | '/invoices'
    | '/journal-entries'
    | '/loyalty'
    | '/payroll'
    | '/pos'
    | '/privacy-requests'
    | '/products'
    | '/projects'
    | '/purchases'
    | '/quotations'
    | '/receipts'
    | '/refunds'
    | '/roles'
    | '/serials'
    | '/service'
    | '/settings'
    | '/stock-adjustments'
    | '/stock-transfers'
    | '/supplier-payments'
    | '/supplier-refunds'
    | '/supplier-returns'
    | '/suppliers'
    | '/tasks'
    | '/teams'
    | '/users'
    | '/workflows'
    | '/platform'
    | '/commissions/mine/$statementId'
    | '/commissions/plans/$planId'
    | '/commissions/plans/new'
    | '/commissions/runs/$runId'
    | '/commissions/statements/$statementId'
    | '/credit-notes/$creditNoteId/edit'
    | '/credit-notes/$creditNoteId/print'
    | '/customers/$customerId/edit'
    | '/expenses/$expenseId/edit'
    | '/expenses/recurring/new'
    | '/hr/employees/new'
    | '/invoices/$invoiceId/edit'
    | '/invoices/$invoiceId/print'
    | '/loyalty/members/$memberId'
    | '/pos/returns/$returnId'
    | '/pos/sales/$saleId'
    | '/pos/shifts/$shiftId'
    | '/products/$productId/edit'
    | '/products/$productId/labels'
    | '/projects/cost-entries/$entryId'
    | '/projects/material-issues/$issueId'
    | '/projects/time/approvals'
    | '/purchases/$purchaseId/edit'
    | '/purchases/$purchaseId/print'
    | '/quotations/$quotationId/edit'
    | '/quotations/$quotationId/print'
    | '/receipts/$receiptId/print'
    | '/refunds/$refundId/print'
    | '/service/assets/$assetId'
    | '/service/assets/labels'
    | '/service/contracts/billing'
    | '/service/contracts/insights'
    | '/service/contracts/new'
    | '/service/sites/$siteId'
    | '/settings/ai/usage'
    | '/stock-transfers/$transferId/edit'
    | '/stock-transfers/$transferId/print'
    | '/supplier-payments/$paymentId/print'
    | '/supplier-refunds/$refundId/print'
    | '/supplier-returns/$returnId/edit'
    | '/supplier-returns/$returnId/print'
    | '/suppliers/$supplierId/edit'
    | '/workflows/runs/$runId'
    | '/platform/tenants/$tenantId'
    | '/platform/tenants/new'
    | '/cheques/$chequeId'
    | '/commissions/mine'
    | '/commissions/plans'
    | '/commissions/runs'
    | '/credit-notes/$creditNoteId'
    | '/customers/$customerId'
    | '/expenses/$expenseId'
    | '/expenses/recurring'
    | '/hr/employees'
    | '/invoices/$invoiceId'
    | '/loyalty/members'
    | '/payroll/runs'
    | '/pos/shifts'
    | '/products/$productId'
    | '/projects/$projectId'
    | '/projects/cost-entries'
    | '/projects/material-issues'
    | '/projects/time'
    | '/purchases/$purchaseId'
    | '/quotations/$quotationId'
    | '/receipts/$receiptId'
    | '/refunds/$refundId'
    | '/service/assets'
    | '/service/contracts'
    | '/service/jobs'
    | '/service/sites'
    | '/service/visits'
    | '/settings/ai'
    | '/stock-transfers/$transferId'
    | '/supplier-payments/$paymentId'
    | '/supplier-refunds/$refundId'
    | '/supplier-returns/$returnId'
    | '/suppliers/$supplierId'
    | '/workflows/runs'
    | '/platform/tenants'
    | '/expenses/recurring/$recurringId/edit'
    | '/hr/employees/$employeeId/edit'
    | '/projects/$projectId/contract/statement'
    | '/service/contracts/$contractId/edit'
    | '/service/contracts/$contractId/print'
    | '/service/jobs/$jobId/estimate'
    | '/service/visits/$visitId/report'
    | '/expenses/recurring/$recurringId'
    | '/hr/employees/$employeeId'
    | '/payroll/runs/$runId'
    | '/projects/$projectId/reports'
    | '/service/contracts/$contractId'
    | '/service/jobs/$jobId'
    | '/service/visits/$visitId'
    | '/payroll/runs/$runId/payslips/$payslipId'
    | '/projects/$projectId/claims/$claimId/print'
    | '/projects/$projectId/reports/$reportId/print'
    | '/projects/$projectId/claims/$claimId'
    | '/projects/$projectId/reports/$reportId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/approvals'
    | '/_app/bank-statements'
    | '/_app/cheques'
    | '/_app/commissions'
    | '/_app/credit-notes'
    | '/_app/customers'
    | '/_app/expenses'
    | '/_app/hr'
    | '/_app/invoices'
    | '/_app/journal-entries'
    | '/_app/loyalty'
    | '/_app/payroll'
    | '/_app/privacy-requests'
    | '/_app/products'
    | '/_app/projects'
    | '/_app/purchases'
    | '/_app/quotations'
    | '/_app/receipts'
    | '/_app/refunds'
    | '/_app/roles'
    | '/_app/serials'
    | '/_app/service'
    | '/_app/settings'
    | '/_app/stock-adjustments'
    | '/_app/stock-transfers'
    | '/_app/supplier-payments'
    | '/_app/supplier-refunds'
    | '/_app/supplier-returns'
    | '/_app/suppliers'
    | '/_app/tasks'
    | '/_app/teams'
    | '/_app/users'
    | '/_app/workflows'
    | '/_app/account-mapping'
    | '/_app/accounts'
    | '/_app/audit-log'
    | '/_app/balance-sheet'
    | '/_app/books-health'
    | '/_app/calendar'
    | '/_app/cash-bank'
    | '/_app/cash-flow'
    | '/_app/change-password'
    | '/_app/customer-groups'
    | '/_app/expense-categories'
    | '/_app/fiscal-years'
    | '/_app/general-ledger'
    | '/_app/low-stock'
    | '/_app/my-work'
    | '/_app/payables-aging'
    | '/_app/pos-summary'
    | '/_app/product-attributes'
    | '/_app/product-categories'
    | '/_app/profit-and-loss'
    | '/_app/project-budget-vs-actual'
    | '/_app/project-profitability'
    | '/_app/project-unbilled-work'
    | '/_app/project-utilisation'
    | '/_app/purchases-by-product'
    | '/_app/purchases-by-supplier'
    | '/_app/receivables-aging'
    | '/_app/reports'
    | '/_app/sales-by-customer'
    | '/_app/sales-by-period'
    | '/_app/sales-by-product'
    | '/_app/sales-by-salesperson'
    | '/_app/sales-by-user'
    | '/_app/stock'
    | '/_app/stock-movements'
    | '/_app/stock-valuation'
    | '/_app/supplier-groups'
    | '/_app/task-report'
    | '/_app/tax-rates'
    | '/_app/transfers'
    | '/_app/trial-balance'
    | '/_app/units'
    | '/_app/vat-return'
    | '/_app/warehouses'
    | '/p/$token'
    | '/platform/_console'
    | '/platform/login'
    | '/set-password/$token'
    | '/_app/'
    | '/_app/cheques/$chequeId'
    | '/_app/commissions/mine'
    | '/_app/commissions/plans'
    | '/_app/commissions/runs'
    | '/_app/commissions/statements'
    | '/_app/credit-notes/$creditNoteId'
    | '/_app/customers/$customerId'
    | '/_app/expenses/$expenseId'
    | '/_app/expenses/recurring'
    | '/_app/hr/employees'
    | '/_app/invoices/$invoiceId'
    | '/_app/loyalty/members'
    | '/_app/payroll/runs'
    | '/_app/pos/shifts'
    | '/_app/products/$productId'
    | '/_app/projects/$projectId'
    | '/_app/projects/cost-entries'
    | '/_app/projects/material-issues'
    | '/_app/purchases/$purchaseId'
    | '/_app/quotations/$quotationId'
    | '/_app/receipts/$receiptId'
    | '/_app/refunds/$refundId'
    | '/_app/service/assets'
    | '/_app/service/contracts'
    | '/_app/service/jobs'
    | '/_app/service/sites'
    | '/_app/service/visits'
    | '/_app/stock-transfers/$transferId'
    | '/_app/supplier-payments/$paymentId'
    | '/_app/supplier-refunds/$refundId'
    | '/_app/supplier-returns/$returnId'
    | '/_app/suppliers/$supplierId'
    | '/_app/workflows/runs'
    | '/_app/approvals/$runId'
    | '/_app/bank-statements/$statementId'
    | '/_app/bank-statements/new'
    | '/_app/credit-notes/new'
    | '/_app/customers/new'
    | '/_app/expenses/new'
    | '/_app/hr/documents'
    | '/_app/hr/pay-components'
    | '/_app/invoices/new'
    | '/_app/journal-entries/$entryId'
    | '/_app/journal-entries/new'
    | '/_app/loyalty/program'
    | '/_app/loyalty/transactions'
    | '/_app/payroll/contributions'
    | '/_app/payroll/settings'
    | '/_app/pos/tills'
    | '/_app/privacy-requests/$requestId'
    | '/_app/products/new'
    | '/_app/projects/guarantees'
    | '/_app/projects/rates'
    | '/_app/projects/reconciliation'
    | '/_app/projects/status-reports'
    | '/_app/purchases/new'
    | '/_app/quotations/new'
    | '/_app/receipts/new'
    | '/_app/refunds/new'
    | '/_app/roles/$roleId'
    | '/_app/roles/new'
    | '/_app/serials/$serialId'
    | '/_app/service/collections'
    | '/_app/service/follow-ups'
    | '/_app/service/my-visits'
    | '/_app/service/schedule'
    | '/_app/settings/account-mapping'
    | '/_app/settings/accounting-checks'
    | '/_app/settings/appearance'
    | '/_app/settings/calendar'
    | '/_app/settings/commissions'
    | '/_app/settings/company'
    | '/_app/settings/contracts'
    | '/_app/settings/defaults'
    | '/_app/settings/legal-holds'
    | '/_app/settings/lock-date'
    | '/_app/settings/message-outbox'
    | '/_app/settings/message-templates'
    | '/_app/settings/modules'
    | '/_app/settings/notifications'
    | '/_app/settings/numbering'
    | '/_app/settings/organization'
    | '/_app/settings/payment-methods'
    | '/_app/settings/printing'
    | '/_app/settings/privacy'
    | '/_app/settings/project-contracting'
    | '/_app/settings/project-cost-categories'
    | '/_app/settings/project-insights'
    | '/_app/settings/project-rate-roles'
    | '/_app/settings/project-types'
    | '/_app/settings/projects'
    | '/_app/settings/regional'
    | '/_app/settings/service'
    | '/_app/settings/service-asset-types'
    | '/_app/settings/service-site-templates'
    | '/_app/settings/stock-policy'
    | '/_app/settings/system'
    | '/_app/settings/tasks'
    | '/_app/settings/tax-rates'
    | '/_app/settings/teams'
    | '/_app/settings/typography'
    | '/_app/settings/work-locations'
    | '/_app/stock-adjustments/$adjustmentId'
    | '/_app/stock-adjustments/new'
    | '/_app/stock-transfers/new'
    | '/_app/supplier-payments/new'
    | '/_app/supplier-refunds/new'
    | '/_app/supplier-returns/new'
    | '/_app/suppliers/new'
    | '/_app/tasks/$taskId'
    | '/_app/teams/$teamId'
    | '/_app/users/$userId'
    | '/_app/users/new'
    | '/_app/workflows/$workflowId'
    | '/_app/workflows/delegations'
    | '/platform/_console/dashboard'
    | '/platform/_console/feedback'
    | '/platform/_console/profile'
    | '/platform/_console/subscriptions'
    | '/_app/approvals/'
    | '/_app/bank-statements/'
    | '/_app/cheques/'
    | '/_app/commissions/'
    | '/_app/credit-notes/'
    | '/_app/customers/'
    | '/_app/expenses/'
    | '/_app/hr/'
    | '/_app/invoices/'
    | '/_app/journal-entries/'
    | '/_app/loyalty/'
    | '/_app/payroll/'
    | '/_app/pos/'
    | '/_app/privacy-requests/'
    | '/_app/products/'
    | '/_app/projects/'
    | '/_app/purchases/'
    | '/_app/quotations/'
    | '/_app/receipts/'
    | '/_app/refunds/'
    | '/_app/roles/'
    | '/_app/serials/'
    | '/_app/service/'
    | '/_app/settings/'
    | '/_app/stock-adjustments/'
    | '/_app/stock-transfers/'
    | '/_app/supplier-payments/'
    | '/_app/supplier-refunds/'
    | '/_app/supplier-returns/'
    | '/_app/suppliers/'
    | '/_app/tasks/'
    | '/_app/teams/'
    | '/_app/users/'
    | '/_app/workflows/'
    | '/platform/_console/'
    | '/_app/expenses/recurring/$recurringId'
    | '/_app/hr/employees/$employeeId'
    | '/_app/payroll/runs/$runId'
    | '/_app/service/contracts/$contractId'
    | '/_app/service/jobs/$jobId'
    | '/_app/service/visits/$visitId'
    | '/_app/commissions/mine/$statementId'
    | '/_app/commissions/plans/$planId'
    | '/_app/commissions/plans/new'
    | '/_app/commissions/runs/$runId'
    | '/_app/commissions/statements/$statementId'
    | '/_app/credit-notes/$creditNoteId/edit'
    | '/_app/credit-notes/$creditNoteId/print'
    | '/_app/customers/$customerId/edit'
    | '/_app/expenses/$expenseId/edit'
    | '/_app/expenses/recurring/new'
    | '/_app/hr/employees/new'
    | '/_app/invoices/$invoiceId/edit'
    | '/_app/invoices/$invoiceId/print'
    | '/_app/loyalty/members/$memberId'
    | '/_app/pos/returns/$returnId'
    | '/_app/pos/sales/$saleId'
    | '/_app/pos/shifts/$shiftId'
    | '/_app/products/$productId/edit'
    | '/_app/products/$productId/labels'
    | '/_app/projects/cost-entries/$entryId'
    | '/_app/projects/material-issues/$issueId'
    | '/_app/projects/time/approvals'
    | '/_app/purchases/$purchaseId/edit'
    | '/_app/purchases/$purchaseId/print'
    | '/_app/quotations/$quotationId/edit'
    | '/_app/quotations/$quotationId/print'
    | '/_app/receipts/$receiptId/print'
    | '/_app/refunds/$refundId/print'
    | '/_app/service/assets/$assetId'
    | '/_app/service/assets/labels'
    | '/_app/service/contracts/billing'
    | '/_app/service/contracts/insights'
    | '/_app/service/contracts/new'
    | '/_app/service/sites/$siteId'
    | '/_app/settings/ai/usage'
    | '/_app/stock-transfers/$transferId/edit'
    | '/_app/stock-transfers/$transferId/print'
    | '/_app/supplier-payments/$paymentId/print'
    | '/_app/supplier-refunds/$refundId/print'
    | '/_app/supplier-returns/$returnId/edit'
    | '/_app/supplier-returns/$returnId/print'
    | '/_app/suppliers/$supplierId/edit'
    | '/_app/workflows/runs/$runId'
    | '/platform/_console/tenants/$tenantId'
    | '/platform/_console/tenants/new'
    | '/_app/cheques/$chequeId/'
    | '/_app/commissions/mine/'
    | '/_app/commissions/plans/'
    | '/_app/commissions/runs/'
    | '/_app/credit-notes/$creditNoteId/'
    | '/_app/customers/$customerId/'
    | '/_app/expenses/$expenseId/'
    | '/_app/expenses/recurring/'
    | '/_app/hr/employees/'
    | '/_app/invoices/$invoiceId/'
    | '/_app/loyalty/members/'
    | '/_app/payroll/runs/'
    | '/_app/pos/shifts/'
    | '/_app/products/$productId/'
    | '/_app/projects/$projectId/'
    | '/_app/projects/cost-entries/'
    | '/_app/projects/material-issues/'
    | '/_app/projects/time/'
    | '/_app/purchases/$purchaseId/'
    | '/_app/quotations/$quotationId/'
    | '/_app/receipts/$receiptId/'
    | '/_app/refunds/$refundId/'
    | '/_app/service/assets/'
    | '/_app/service/contracts/'
    | '/_app/service/jobs/'
    | '/_app/service/sites/'
    | '/_app/service/visits/'
    | '/_app/settings/ai/'
    | '/_app/stock-transfers/$transferId/'
    | '/_app/supplier-payments/$paymentId/'
    | '/_app/supplier-refunds/$refundId/'
    | '/_app/supplier-returns/$returnId/'
    | '/_app/suppliers/$supplierId/'
    | '/_app/workflows/runs/'
    | '/platform/_console/tenants/'
    | '/_app/expenses/recurring/$recurringId/edit'
    | '/_app/hr/employees/$employeeId/edit'
    | '/_app/projects/$projectId/contract/statement'
    | '/_app/service/contracts/$contractId/edit'
    | '/_app/service/contracts/$contractId/print'
    | '/_app/service/jobs/$jobId/estimate'
    | '/_app/service/visits/$visitId/report'
    | '/_app/expenses/recurring/$recurringId/'
    | '/_app/hr/employees/$employeeId/'
    | '/_app/payroll/runs/$runId/'
    | '/_app/projects/$projectId/reports/'
    | '/_app/service/contracts/$contractId/'
    | '/_app/service/jobs/$jobId/'
    | '/_app/service/visits/$visitId/'
    | '/_app/payroll/runs/$runId/payslips/$payslipId'
    | '/_app/projects/$projectId/claims/$claimId/print'
    | '/_app/projects/$projectId/reports/$reportId/print'
    | '/_app/projects/$projectId/claims/$claimId/'
    | '/_app/projects/$projectId/reports/$reportId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PTokenRoute: typeof PTokenRoute
  PlatformConsoleRoute: typeof PlatformConsoleRouteWithChildren
  PlatformLoginRoute: typeof PlatformLoginRoute
  SetPasswordTokenRoute: typeof SetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account-mapping': {
      id: '/_app/account-mapping'
      path: '/account-mapping'
      fullPath: '/account-mapping'
      preLoaderRoute: typeof AppAccountMappingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit-log': {
      id: '/_app/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AppAuditLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/balance-sheet': {
      id: '/_app/balance-sheet'
      path: '/balance-sheet'
      fullPath: '/balance-sheet'
      preLoaderRoute: typeof AppBalanceSheetRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bank-statements': {
      id: '/_app/bank-statements'
      path: '/bank-statements'
      fullPath: '/bank-statements'
      preLoaderRoute: typeof AppBankStatementsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/books-health': {
      id: '/_app/books-health'
      path: '/books-health'
      fullPath: '/books-health'
      preLoaderRoute: typeof AppBooksHealthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash-bank': {
      id: '/_app/cash-bank'
      path: '/cash-bank'
      fullPath: '/cash-bank'
      preLoaderRoute: typeof AppCashBankRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash-flow': {
      id: '/_app/cash-flow'
      path: '/cash-flow'
      fullPath: '/cash-flow'
      preLoaderRoute: typeof AppCashFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/change-password': {
      id: '/_app/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AppChangePasswordRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cheques': {
      id: '/_app/cheques'
      path: '/cheques'
      fullPath: '/cheques'
      preLoaderRoute: typeof AppChequesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/commissions': {
      id: '/_app/commissions'
      path: '/commissions'
      fullPath: '/commissions'
      preLoaderRoute: typeof AppCommissionsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/credit-notes': {
      id: '/_app/credit-notes'
      path: '/credit-notes'
      fullPath: '/credit-notes'
      preLoaderRoute: typeof AppCreditNotesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customer-groups': {
      id: '/_app/customer-groups'
      path: '/customer-groups'
      fullPath: '/customer-groups'
      preLoaderRoute: typeof AppCustomerGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expense-categories': {
      id: '/_app/expense-categories'
      path: '/expense-categories'
      fullPath: '/expense-categories'
      preLoaderRoute: typeof AppExpenseCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expenses': {
      id: '/_app/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AppExpensesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fiscal-years': {
      id: '/_app/fiscal-years'
      path: '/fiscal-years'
      fullPath: '/fiscal-years'
      preLoaderRoute: typeof AppFiscalYearsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/general-ledger': {
      id: '/_app/general-ledger'
      path: '/general-ledger'
      fullPath: '/general-ledger'
      preLoaderRoute: typeof AppGeneralLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr': {
      id: '/_app/hr'
      path: '/hr'
      fullPath: '/hr'
      preLoaderRoute: typeof AppHrRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices': {
      id: '/_app/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppInvoicesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/journal-entries': {
      id: '/_app/journal-entries'
      path: '/journal-entries'
      fullPath: '/journal-entries'
      preLoaderRoute: typeof AppJournalEntriesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/low-stock': {
      id: '/_app/low-stock'
      path: '/low-stock'
      fullPath: '/low-stock'
      preLoaderRoute: typeof AppLowStockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loyalty': {
      id: '/_app/loyalty'
      path: '/loyalty'
      fullPath: '/loyalty'
      preLoaderRoute: typeof AppLoyaltyRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-work': {
      id: '/_app/my-work'
      path: '/my-work'
      fullPath: '/my-work'
      preLoaderRoute: typeof AppMyWorkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payables-aging': {
      id: '/_app/payables-aging'
      path: '/payables-aging'
      fullPath: '/payables-aging'
      preLoaderRoute: typeof AppPayablesAgingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll': {
      id: '/_app/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof AppPayrollRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos-summary': {
      id: '/_app/pos-summary'
      path: '/pos-summary'
      fullPath: '/pos-summary'
      preLoaderRoute: typeof AppPosSummaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/privacy-requests': {
      id: '/_app/privacy-requests'
      path: '/privacy-requests'
      fullPath: '/privacy-requests'
      preLoaderRoute: typeof AppPrivacyRequestsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/product-attributes': {
      id: '/_app/product-attributes'
      path: '/product-attributes'
      fullPath: '/product-attributes'
      preLoaderRoute: typeof AppProductAttributesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/product-categories': {
      id: '/_app/product-categories'
      path: '/product-categories'
      fullPath: '/product-categories'
      preLoaderRoute: typeof AppProductCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profit-and-loss': {
      id: '/_app/profit-and-loss'
      path: '/profit-and-loss'
      fullPath: '/profit-and-loss'
      preLoaderRoute: typeof AppProfitAndLossRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project-budget-vs-actual': {
      id: '/_app/project-budget-vs-actual'
      path: '/project-budget-vs-actual'
      fullPath: '/project-budget-vs-actual'
      preLoaderRoute: typeof AppProjectBudgetVsActualRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project-profitability': {
      id: '/_app/project-profitability'
      path: '/project-profitability'
      fullPath: '/project-profitability'
      preLoaderRoute: typeof AppProjectProfitabilityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project-unbilled-work': {
      id: '/_app/project-unbilled-work'
      path: '/project-unbilled-work'
      fullPath: '/project-unbilled-work'
      preLoaderRoute: typeof AppProjectUnbilledWorkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project-utilisation': {
      id: '/_app/project-utilisation'
      path: '/project-utilisation'
      fullPath: '/project-utilisation'
      preLoaderRoute: typeof AppProjectUtilisationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchases': {
      id: '/_app/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof AppPurchasesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchases-by-product': {
      id: '/_app/purchases-by-product'
      path: '/purchases-by-product'
      fullPath: '/purchases-by-product'
      preLoaderRoute: typeof AppPurchasesByProductRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchases-by-supplier': {
      id: '/_app/purchases-by-supplier'
      path: '/purchases-by-supplier'
      fullPath: '/purchases-by-supplier'
      preLoaderRoute: typeof AppPurchasesBySupplierRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotations': {
      id: '/_app/quotations'
      path: '/quotations'
      fullPath: '/quotations'
      preLoaderRoute: typeof AppQuotationsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receipts': {
      id: '/_app/receipts'
      path: '/receipts'
      fullPath: '/receipts'
      preLoaderRoute: typeof AppReceiptsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receivables-aging': {
      id: '/_app/receivables-aging'
      path: '/receivables-aging'
      fullPath: '/receivables-aging'
      preLoaderRoute: typeof AppReceivablesAgingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/refunds': {
      id: '/_app/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof AppRefundsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles': {
      id: '/_app/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AppRolesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-by-customer': {
      id: '/_app/sales-by-customer'
      path: '/sales-by-customer'
      fullPath: '/sales-by-customer'
      preLoaderRoute: typeof AppSalesByCustomerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-by-period': {
      id: '/_app/sales-by-period'
      path: '/sales-by-period'
      fullPath: '/sales-by-period'
      preLoaderRoute: typeof AppSalesByPeriodRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-by-product': {
      id: '/_app/sales-by-product'
      path: '/sales-by-product'
      fullPath: '/sales-by-product'
      preLoaderRoute: typeof AppSalesByProductRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-by-salesperson': {
      id: '/_app/sales-by-salesperson'
      path: '/sales-by-salesperson'
      fullPath: '/sales-by-salesperson'
      preLoaderRoute: typeof AppSalesBySalespersonRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-by-user': {
      id: '/_app/sales-by-user'
      path: '/sales-by-user'
      fullPath: '/sales-by-user'
      preLoaderRoute: typeof AppSalesByUserRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/serials': {
      id: '/_app/serials'
      path: '/serials'
      fullPath: '/serials'
      preLoaderRoute: typeof AppSerialsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service': {
      id: '/_app/service'
      path: '/service'
      fullPath: '/service'
      preLoaderRoute: typeof AppServiceRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock': {
      id: '/_app/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof AppStockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-adjustments': {
      id: '/_app/stock-adjustments'
      path: '/stock-adjustments'
      fullPath: '/stock-adjustments'
      preLoaderRoute: typeof AppStockAdjustmentsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-movements': {
      id: '/_app/stock-movements'
      path: '/stock-movements'
      fullPath: '/stock-movements'
      preLoaderRoute: typeof AppStockMovementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-transfers': {
      id: '/_app/stock-transfers'
      path: '/stock-transfers'
      fullPath: '/stock-transfers'
      preLoaderRoute: typeof AppStockTransfersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-valuation': {
      id: '/_app/stock-valuation'
      path: '/stock-valuation'
      fullPath: '/stock-valuation'
      preLoaderRoute: typeof AppStockValuationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-groups': {
      id: '/_app/supplier-groups'
      path: '/supplier-groups'
      fullPath: '/supplier-groups'
      preLoaderRoute: typeof AppSupplierGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-payments': {
      id: '/_app/supplier-payments'
      path: '/supplier-payments'
      fullPath: '/supplier-payments'
      preLoaderRoute: typeof AppSupplierPaymentsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-refunds': {
      id: '/_app/supplier-refunds'
      path: '/supplier-refunds'
      fullPath: '/supplier-refunds'
      preLoaderRoute: typeof AppSupplierRefundsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier-returns': {
      id: '/_app/supplier-returns'
      path: '/supplier-returns'
      fullPath: '/supplier-returns'
      preLoaderRoute: typeof AppSupplierReturnsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers': {
      id: '/_app/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AppSuppliersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/task-report': {
      id: '/_app/task-report'
      path: '/task-report'
      fullPath: '/task-report'
      preLoaderRoute: typeof AppTaskReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tax-rates': {
      id: '/_app/tax-rates'
      path: '/tax-rates'
      fullPath: '/tax-rates'
      preLoaderRoute: typeof AppTaxRatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/teams': {
      id: '/_app/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof AppTeamsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers': {
      id: '/_app/transfers'
      path: '/transfers'
      fullPath: '/transfers'
      preLoaderRoute: typeof AppTransfersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trial-balance': {
      id: '/_app/trial-balance'
      path: '/trial-balance'
      fullPath: '/trial-balance'
      preLoaderRoute: typeof AppTrialBalanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/units': {
      id: '/_app/units'
      path: '/units'
      fullPath: '/units'
      preLoaderRoute: typeof AppUnitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vat-return': {
      id: '/_app/vat-return'
      path: '/vat-return'
      fullPath: '/vat-return'
      preLoaderRoute: typeof AppVatReturnRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehouses': {
      id: '/_app/warehouses'
      path: '/warehouses'
      fullPath: '/warehouses'
      preLoaderRoute: typeof AppWarehousesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workflows': {
      id: '/_app/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AppWorkflowsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/_console': {
      id: '/platform/_console'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformConsoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/login': {
      id: '/platform/login'
      path: '/platform/login'
      fullPath: '/platform/login'
      preLoaderRoute: typeof PlatformLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password/$token': {
      id: '/set-password/$token'
      path: '/set-password/$token'
      fullPath: '/set-password/$token'
      preLoaderRoute: typeof SetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/approvals/': {
      id: '/_app/approvals/'
      path: '/'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AppApprovalsIndexRouteImport
      parentRoute: typeof AppApprovalsRouteRoute
    }
    '/_app/approvals/$runId': {
      id: '/_app/approvals/$runId'
      path: '/$runId'
      fullPath: '/approvals/$runId'
      preLoaderRoute: typeof AppApprovalsRunIdRouteImport
      parentRoute: typeof AppApprovalsRouteRoute
    }
    '/_app/bank-statements/': {
      id: '/_app/bank-statements/'
      path: '/'
      fullPath: '/bank-statements/'
      preLoaderRoute: typeof AppBankStatementsIndexRouteImport
      parentRoute: typeof AppBankStatementsRouteRoute
    }
    '/_app/bank-statements/$statementId': {
      id: '/_app/bank-statements/$statementId'
      path: '/$statementId'
      fullPath: '/bank-statements/$statementId'
      preLoaderRoute: typeof AppBankStatementsStatementIdRouteImport
      parentRoute: typeof AppBankStatementsRouteRoute
    }
    '/_app/bank-statements/new': {
      id: '/_app/bank-statements/new'
      path: '/new'
      fullPath: '/bank-statements/new'
      preLoaderRoute: typeof AppBankStatementsNewRouteImport
      parentRoute: typeof AppBankStatementsRouteRoute
    }
    '/_app/cheques/': {
      id: '/_app/cheques/'
      path: '/'
      fullPath: '/cheques/'
      preLoaderRoute: typeof AppChequesIndexRouteImport
      parentRoute: typeof AppChequesRouteRoute
    }
    '/_app/cheques/$chequeId': {
      id: '/_app/cheques/$chequeId'
      path: '/$chequeId'
      fullPath: '/cheques/$chequeId'
      preLoaderRoute: typeof AppChequesChequeIdRouteRouteImport
      parentRoute: typeof AppChequesRouteRoute
    }
    '/_app/commissions/': {
      id: '/_app/commissions/'
      path: '/'
      fullPath: '/commissions/'
      preLoaderRoute: typeof AppCommissionsIndexRouteImport
      parentRoute: typeof AppCommissionsRouteRoute
    }
    '/_app/commissions/mine': {
      id: '/_app/commissions/mine'
      path: '/mine'
      fullPath: '/commissions/mine'
      preLoaderRoute: typeof AppCommissionsMineRouteRouteImport
      parentRoute: typeof AppCommissionsRouteRoute
    }
    '/_app/commissions/plans': {
      id: '/_app/commissions/plans'
      path: '/plans'
      fullPath: '/commissions/plans'
      preLoaderRoute: typeof AppCommissionsPlansRouteRouteImport
      parentRoute: typeof AppCommissionsRouteRoute
    }
    '/_app/commissions/runs': {
      id: '/_app/commissions/runs'
      path: '/runs'
      fullPath: '/commissions/runs'
      preLoaderRoute: typeof AppCommissionsRunsRouteRouteImport
      parentRoute: typeof AppCommissionsRouteRoute
    }
    '/_app/commissions/statements': {
      id: '/_app/commissions/statements'
      path: '/statements'
      fullPath: '/commissions/statements'
      preLoaderRoute: typeof AppCommissionsStatementsRouteRouteImport
      parentRoute: typeof AppCommissionsRouteRoute
    }
    '/_app/credit-notes/': {
      id: '/_app/credit-notes/'
      path: '/'
      fullPath: '/credit-notes/'
      preLoaderRoute: typeof AppCreditNotesIndexRouteImport
      parentRoute: typeof AppCreditNotesRouteRoute
    }
    '/_app/credit-notes/$creditNoteId': {
      id: '/_app/credit-notes/$creditNoteId'
      path: '/$creditNoteId'
      fullPath: '/credit-notes/$creditNoteId'
      preLoaderRoute: typeof AppCreditNotesCreditNoteIdRouteRouteImport
      parentRoute: typeof AppCreditNotesRouteRoute
    }
    '/_app/credit-notes/new': {
      id: '/_app/credit-notes/new'
      path: '/new'
      fullPath: '/credit-notes/new'
      preLoaderRoute: typeof AppCreditNotesNewRouteImport
      parentRoute: typeof AppCreditNotesRouteRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppCustomersRouteRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteRouteImport
      parentRoute: typeof AppCustomersRouteRoute
    }
    '/_app/customers/new': {
      id: '/_app/customers/new'
      path: '/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AppCustomersNewRouteImport
      parentRoute: typeof AppCustomersRouteRoute
    }
    '/_app/expenses/': {
      id: '/_app/expenses/'
      path: '/'
      fullPath: '/expenses/'
      preLoaderRoute: typeof AppExpensesIndexRouteImport
      parentRoute: typeof AppExpensesRouteRoute
    }
    '/_app/expenses/$expenseId': {
      id: '/_app/expenses/$expenseId'
      path: '/$expenseId'
      fullPath: '/expenses/$expenseId'
      preLoaderRoute: typeof AppExpensesExpenseIdRouteRouteImport
      parentRoute: typeof AppExpensesRouteRoute
    }
    '/_app/expenses/new': {
      id: '/_app/expenses/new'
      path: '/new'
      fullPath: '/expenses/new'
      preLoaderRoute: typeof AppExpensesNewRouteImport
      parentRoute: typeof AppExpensesRouteRoute
    }
    '/_app/expenses/recurring': {
      id: '/_app/expenses/recurring'
      path: '/recurring'
      fullPath: '/expenses/recurring'
      preLoaderRoute: typeof AppExpensesRecurringRouteRouteImport
      parentRoute: typeof AppExpensesRouteRoute
    }
    '/_app/hr/': {
      id: '/_app/hr/'
      path: '/'
      fullPath: '/hr/'
      preLoaderRoute: typeof AppHrIndexRouteImport
      parentRoute: typeof AppHrRouteRoute
    }
    '/_app/hr/documents': {
      id: '/_app/hr/documents'
      path: '/documents'
      fullPath: '/hr/documents'
      preLoaderRoute: typeof AppHrDocumentsRouteImport
      parentRoute: typeof AppHrRouteRoute
    }
    '/_app/hr/employees': {
      id: '/_app/hr/employees'
      path: '/employees'
      fullPath: '/hr/employees'
      preLoaderRoute: typeof AppHrEmployeesRouteRouteImport
      parentRoute: typeof AppHrRouteRoute
    }
    '/_app/hr/pay-components': {
      id: '/_app/hr/pay-components'
      path: '/pay-components'
      fullPath: '/hr/pay-components'
      preLoaderRoute: typeof AppHrPayComponentsRouteImport
      parentRoute: typeof AppHrRouteRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppInvoicesRouteRoute
    }
    '/_app/invoices/$invoiceId': {
      id: '/_app/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AppInvoicesInvoiceIdRouteRouteImport
      parentRoute: typeof AppInvoicesRouteRoute
    }
    '/_app/invoices/new': {
      id: '/_app/invoices/new'
      path: '/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AppInvoicesNewRouteImport
      parentRoute: typeof AppInvoicesRouteRoute
    }
    '/_app/journal-entries/': {
      id: '/_app/journal-entries/'
      path: '/'
      fullPath: '/journal-entries/'
      preLoaderRoute: typeof AppJournalEntriesIndexRouteImport
      parentRoute: typeof AppJournalEntriesRouteRoute
    }
    '/_app/journal-entries/$entryId': {
      id: '/_app/journal-entries/$entryId'
      path: '/$entryId'
      fullPath: '/journal-entries/$entryId'
      preLoaderRoute: typeof AppJournalEntriesEntryIdRouteImport
      parentRoute: typeof AppJournalEntriesRouteRoute
    }
    '/_app/journal-entries/new': {
      id: '/_app/journal-entries/new'
      path: '/new'
      fullPath: '/journal-entries/new'
      preLoaderRoute: typeof AppJournalEntriesNewRouteImport
      parentRoute: typeof AppJournalEntriesRouteRoute
    }
    '/_app/loyalty/': {
      id: '/_app/loyalty/'
      path: '/'
      fullPath: '/loyalty/'
      preLoaderRoute: typeof AppLoyaltyIndexRouteImport
      parentRoute: typeof AppLoyaltyRouteRoute
    }
    '/_app/loyalty/members': {
      id: '/_app/loyalty/members'
      path: '/members'
      fullPath: '/loyalty/members'
      preLoaderRoute: typeof AppLoyaltyMembersRouteRouteImport
      parentRoute: typeof AppLoyaltyRouteRoute
    }
    '/_app/loyalty/program': {
      id: '/_app/loyalty/program'
      path: '/program'
      fullPath: '/loyalty/program'
      preLoaderRoute: typeof AppLoyaltyProgramRouteImport
      parentRoute: typeof AppLoyaltyRouteRoute
    }
    '/_app/loyalty/transactions': {
      id: '/_app/loyalty/transactions'
      path: '/transactions'
      fullPath: '/loyalty/transactions'
      preLoaderRoute: typeof AppLoyaltyTransactionsRouteImport
      parentRoute: typeof AppLoyaltyRouteRoute
    }
    '/_app/payroll/': {
      id: '/_app/payroll/'
      path: '/'
      fullPath: '/payroll/'
      preLoaderRoute: typeof AppPayrollIndexRouteImport
      parentRoute: typeof AppPayrollRouteRoute
    }
    '/_app/payroll/contributions': {
      id: '/_app/payroll/contributions'
      path: '/contributions'
      fullPath: '/payroll/contributions'
      preLoaderRoute: typeof AppPayrollContributionsRouteImport
      parentRoute: typeof AppPayrollRouteRoute
    }
    '/_app/payroll/runs': {
      id: '/_app/payroll/runs'
      path: '/runs'
      fullPath: '/payroll/runs'
      preLoaderRoute: typeof AppPayrollRunsRouteRouteImport
      parentRoute: typeof AppPayrollRouteRoute
    }
    '/_app/payroll/settings': {
      id: '/_app/payroll/settings'
      path: '/settings'
      fullPath: '/payroll/settings'
      preLoaderRoute: typeof AppPayrollSettingsRouteImport
      parentRoute: typeof AppPayrollRouteRoute
    }
    '/_app/pos/': {
      id: '/_app/pos/'
      path: '/pos'
      fullPath: '/pos/'
      preLoaderRoute: typeof AppPosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos/shifts': {
      id: '/_app/pos/shifts'
      path: '/pos/shifts'
      fullPath: '/pos/shifts'
      preLoaderRoute: typeof AppPosShiftsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos/tills': {
      id: '/_app/pos/tills'
      path: '/pos/tills'
      fullPath: '/pos/tills'
      preLoaderRoute: typeof AppPosTillsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/privacy-requests/': {
      id: '/_app/privacy-requests/'
      path: '/'
      fullPath: '/privacy-requests/'
      preLoaderRoute: typeof AppPrivacyRequestsIndexRouteImport
      parentRoute: typeof AppPrivacyRequestsRouteRoute
    }
    '/_app/privacy-requests/$requestId': {
      id: '/_app/privacy-requests/$requestId'
      path: '/$requestId'
      fullPath: '/privacy-requests/$requestId'
      preLoaderRoute: typeof AppPrivacyRequestsRequestIdRouteImport
      parentRoute: typeof AppPrivacyRequestsRouteRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppProductsRouteRoute
    }
    '/_app/products/$productId': {
      id: '/_app/products/$productId'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AppProductsProductIdRouteRouteImport
      parentRoute: typeof AppProductsRouteRoute
    }
    '/_app/products/new': {
      id: '/_app/products/new'
      path: '/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AppProductsNewRouteImport
      parentRoute: typeof AppProductsRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/cost-entries': {
      id: '/_app/projects/cost-entries'
      path: '/cost-entries'
      fullPath: '/projects/cost-entries'
      preLoaderRoute: typeof AppProjectsCostEntriesRouteRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/guarantees': {
      id: '/_app/projects/guarantees'
      path: '/guarantees'
      fullPath: '/projects/guarantees'
      preLoaderRoute: typeof AppProjectsGuaranteesRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/material-issues': {
      id: '/_app/projects/material-issues'
      path: '/material-issues'
      fullPath: '/projects/material-issues'
      preLoaderRoute: typeof AppProjectsMaterialIssuesRouteRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/rates': {
      id: '/_app/projects/rates'
      path: '/rates'
      fullPath: '/projects/rates'
      preLoaderRoute: typeof AppProjectsRatesRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/reconciliation': {
      id: '/_app/projects/reconciliation'
      path: '/reconciliation'
      fullPath: '/projects/reconciliation'
      preLoaderRoute: typeof AppProjectsReconciliationRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/status-reports': {
      id: '/_app/projects/status-reports'
      path: '/status-reports'
      fullPath: '/projects/status-reports'
      preLoaderRoute: typeof AppProjectsStatusReportsRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/purchases/': {
      id: '/_app/purchases/'
      path: '/'
      fullPath: '/purchases/'
      preLoaderRoute: typeof AppPurchasesIndexRouteImport
      parentRoute: typeof AppPurchasesRouteRoute
    }
    '/_app/purchases/$purchaseId': {
      id: '/_app/purchases/$purchaseId'
      path: '/$purchaseId'
      fullPath: '/purchases/$purchaseId'
      preLoaderRoute: typeof AppPurchasesPurchaseIdRouteRouteImport
      parentRoute: typeof AppPurchasesRouteRoute
    }
    '/_app/purchases/new': {
      id: '/_app/purchases/new'
      path: '/new'
      fullPath: '/purchases/new'
      preLoaderRoute: typeof AppPurchasesNewRouteImport
      parentRoute: typeof AppPurchasesRouteRoute
    }
    '/_app/quotations/': {
      id: '/_app/quotations/'
      path: '/'
      fullPath: '/quotations/'
      preLoaderRoute: typeof AppQuotationsIndexRouteImport
      parentRoute: typeof AppQuotationsRouteRoute
    }
    '/_app/quotations/$quotationId': {
      id: '/_app/quotations/$quotationId'
      path: '/$quotationId'
      fullPath: '/quotations/$quotationId'
      preLoaderRoute: typeof AppQuotationsQuotationIdRouteRouteImport
      parentRoute: typeof AppQuotationsRouteRoute
    }
    '/_app/quotations/new': {
      id: '/_app/quotations/new'
      path: '/new'
      fullPath: '/quotations/new'
      preLoaderRoute: typeof AppQuotationsNewRouteImport
      parentRoute: typeof AppQuotationsRouteRoute
    }
    '/_app/receipts/': {
      id: '/_app/receipts/'
      path: '/'
      fullPath: '/receipts/'
      preLoaderRoute: typeof AppReceiptsIndexRouteImport
      parentRoute: typeof AppReceiptsRouteRoute
    }
    '/_app/receipts/$receiptId': {
      id: '/_app/receipts/$receiptId'
      path: '/$receiptId'
      fullPath: '/receipts/$receiptId'
      preLoaderRoute: typeof AppReceiptsReceiptIdRouteRouteImport
      parentRoute: typeof AppReceiptsRouteRoute
    }
    '/_app/receipts/new': {
      id: '/_app/receipts/new'
      path: '/new'
      fullPath: '/receipts/new'
      preLoaderRoute: typeof AppReceiptsNewRouteImport
      parentRoute: typeof AppReceiptsRouteRoute
    }
    '/_app/refunds/': {
      id: '/_app/refunds/'
      path: '/'
      fullPath: '/refunds/'
      preLoaderRoute: typeof AppRefundsIndexRouteImport
      parentRoute: typeof AppRefundsRouteRoute
    }
    '/_app/refunds/$refundId': {
      id: '/_app/refunds/$refundId'
      path: '/$refundId'
      fullPath: '/refunds/$refundId'
      preLoaderRoute: typeof AppRefundsRefundIdRouteRouteImport
      parentRoute: typeof AppRefundsRouteRoute
    }
    '/_app/refunds/new': {
      id: '/_app/refunds/new'
      path: '/new'
      fullPath: '/refunds/new'
      preLoaderRoute: typeof AppRefundsNewRouteImport
      parentRoute: typeof AppRefundsRouteRoute
    }
    '/_app/roles/': {
      id: '/_app/roles/'
      path: '/'
      fullPath: '/roles/'
      preLoaderRoute: typeof AppRolesIndexRouteImport
      parentRoute: typeof AppRolesRouteRoute
    }
    '/_app/roles/$roleId': {
      id: '/_app/roles/$roleId'
      path: '/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AppRolesRoleIdRouteImport
      parentRoute: typeof AppRolesRouteRoute
    }
    '/_app/roles/new': {
      id: '/_app/roles/new'
      path: '/new'
      fullPath: '/roles/new'
      preLoaderRoute: typeof AppRolesNewRouteImport
      parentRoute: typeof AppRolesRouteRoute
    }
    '/_app/serials/': {
      id: '/_app/serials/'
      path: '/'
      fullPath: '/serials/'
      preLoaderRoute: typeof AppSerialsIndexRouteImport
      parentRoute: typeof AppSerialsRouteRoute
    }
    '/_app/serials/$serialId': {
      id: '/_app/serials/$serialId'
      path: '/$serialId'
      fullPath: '/serials/$serialId'
      preLoaderRoute: typeof AppSerialsSerialIdRouteImport
      parentRoute: typeof AppSerialsRouteRoute
    }
    '/_app/service/': {
      id: '/_app/service/'
      path: '/'
      fullPath: '/service/'
      preLoaderRoute: typeof AppServiceIndexRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/assets': {
      id: '/_app/service/assets'
      path: '/assets'
      fullPath: '/service/assets'
      preLoaderRoute: typeof AppServiceAssetsRouteRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/collections': {
      id: '/_app/service/collections'
      path: '/collections'
      fullPath: '/service/collections'
      preLoaderRoute: typeof AppServiceCollectionsRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/contracts': {
      id: '/_app/service/contracts'
      path: '/contracts'
      fullPath: '/service/contracts'
      preLoaderRoute: typeof AppServiceContractsRouteRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/follow-ups': {
      id: '/_app/service/follow-ups'
      path: '/follow-ups'
      fullPath: '/service/follow-ups'
      preLoaderRoute: typeof AppServiceFollowUpsRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/jobs': {
      id: '/_app/service/jobs'
      path: '/jobs'
      fullPath: '/service/jobs'
      preLoaderRoute: typeof AppServiceJobsRouteRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/my-visits': {
      id: '/_app/service/my-visits'
      path: '/my-visits'
      fullPath: '/service/my-visits'
      preLoaderRoute: typeof AppServiceMyVisitsRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/schedule': {
      id: '/_app/service/schedule'
      path: '/schedule'
      fullPath: '/service/schedule'
      preLoaderRoute: typeof AppServiceScheduleRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/sites': {
      id: '/_app/service/sites'
      path: '/sites'
      fullPath: '/service/sites'
      preLoaderRoute: typeof AppServiceSitesRouteRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/service/visits': {
      id: '/_app/service/visits'
      path: '/visits'
      fullPath: '/service/visits'
      preLoaderRoute: typeof AppServiceVisitsRouteRouteImport
      parentRoute: typeof AppServiceRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/account-mapping': {
      id: '/_app/settings/account-mapping'
      path: '/account-mapping'
      fullPath: '/settings/account-mapping'
      preLoaderRoute: typeof AppSettingsAccountMappingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/accounting-checks': {
      id: '/_app/settings/accounting-checks'
      path: '/accounting-checks'
      fullPath: '/settings/accounting-checks'
      preLoaderRoute: typeof AppSettingsAccountingChecksRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/appearance': {
      id: '/_app/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AppSettingsAppearanceRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/calendar': {
      id: '/_app/settings/calendar'
      path: '/calendar'
      fullPath: '/settings/calendar'
      preLoaderRoute: typeof AppSettingsCalendarRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/commissions': {
      id: '/_app/settings/commissions'
      path: '/commissions'
      fullPath: '/settings/commissions'
      preLoaderRoute: typeof AppSettingsCommissionsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/company': {
      id: '/_app/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AppSettingsCompanyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/contracts': {
      id: '/_app/settings/contracts'
      path: '/contracts'
      fullPath: '/settings/contracts'
      preLoaderRoute: typeof AppSettingsContractsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/defaults': {
      id: '/_app/settings/defaults'
      path: '/defaults'
      fullPath: '/settings/defaults'
      preLoaderRoute: typeof AppSettingsDefaultsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/legal-holds': {
      id: '/_app/settings/legal-holds'
      path: '/legal-holds'
      fullPath: '/settings/legal-holds'
      preLoaderRoute: typeof AppSettingsLegalHoldsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/lock-date': {
      id: '/_app/settings/lock-date'
      path: '/lock-date'
      fullPath: '/settings/lock-date'
      preLoaderRoute: typeof AppSettingsLockDateRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/message-outbox': {
      id: '/_app/settings/message-outbox'
      path: '/message-outbox'
      fullPath: '/settings/message-outbox'
      preLoaderRoute: typeof AppSettingsMessageOutboxRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/message-templates': {
      id: '/_app/settings/message-templates'
      path: '/message-templates'
      fullPath: '/settings/message-templates'
      preLoaderRoute: typeof AppSettingsMessageTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/modules': {
      id: '/_app/settings/modules'
      path: '/modules'
      fullPath: '/settings/modules'
      preLoaderRoute: typeof AppSettingsModulesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/numbering': {
      id: '/_app/settings/numbering'
      path: '/numbering'
      fullPath: '/settings/numbering'
      preLoaderRoute: typeof AppSettingsNumberingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/organization': {
      id: '/_app/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AppSettingsOrganizationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/payment-methods': {
      id: '/_app/settings/payment-methods'
      path: '/payment-methods'
      fullPath: '/settings/payment-methods'
      preLoaderRoute: typeof AppSettingsPaymentMethodsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/printing': {
      id: '/_app/settings/printing'
      path: '/printing'
      fullPath: '/settings/printing'
      preLoaderRoute: typeof AppSettingsPrintingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/privacy': {
      id: '/_app/settings/privacy'
      path: '/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/project-contracting': {
      id: '/_app/settings/project-contracting'
      path: '/project-contracting'
      fullPath: '/settings/project-contracting'
      preLoaderRoute: typeof AppSettingsProjectContractingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/project-cost-categories': {
      id: '/_app/settings/project-cost-categories'
      path: '/project-cost-categories'
      fullPath: '/settings/project-cost-categories'
      preLoaderRoute: typeof AppSettingsProjectCostCategoriesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/project-insights': {
      id: '/_app/settings/project-insights'
      path: '/project-insights'
      fullPath: '/settings/project-insights'
      preLoaderRoute: typeof AppSettingsProjectInsightsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/project-rate-roles': {
      id: '/_app/settings/project-rate-roles'
      path: '/project-rate-roles'
      fullPath: '/settings/project-rate-roles'
      preLoaderRoute: typeof AppSettingsProjectRateRolesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/project-types': {
      id: '/_app/settings/project-types'
      path: '/project-types'
      fullPath: '/settings/project-types'
      preLoaderRoute: typeof AppSettingsProjectTypesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/projects': {
      id: '/_app/settings/projects'
      path: '/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof AppSettingsProjectsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/regional': {
      id: '/_app/settings/regional'
      path: '/regional'
      fullPath: '/settings/regional'
      preLoaderRoute: typeof AppSettingsRegionalRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/service': {
      id: '/_app/settings/service'
      path: '/service'
      fullPath: '/settings/service'
      preLoaderRoute: typeof AppSettingsServiceRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/service-asset-types': {
      id: '/_app/settings/service-asset-types'
      path: '/service-asset-types'
      fullPath: '/settings/service-asset-types'
      preLoaderRoute: typeof AppSettingsServiceAssetTypesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/service-site-templates': {
      id: '/_app/settings/service-site-templates'
      path: '/service-site-templates'
      fullPath: '/settings/service-site-templates'
      preLoaderRoute: typeof AppSettingsServiceSiteTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/stock-policy': {
      id: '/_app/settings/stock-policy'
      path: '/stock-policy'
      fullPath: '/settings/stock-policy'
      preLoaderRoute: typeof AppSettingsStockPolicyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/system': {
      id: '/_app/settings/system'
      path: '/system'
      fullPath: '/settings/system'
      preLoaderRoute: typeof AppSettingsSystemRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tasks': {
      id: '/_app/settings/tasks'
      path: '/tasks'
      fullPath: '/settings/tasks'
      preLoaderRoute: typeof AppSettingsTasksRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tax-rates': {
      id: '/_app/settings/tax-rates'
      path: '/tax-rates'
      fullPath: '/settings/tax-rates'
      preLoaderRoute: typeof AppSettingsTaxRatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/teams': {
      id: '/_app/settings/teams'
      path: '/teams'
      fullPath: '/settings/teams'
      preLoaderRoute: typeof AppSettingsTeamsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/typography': {
      id: '/_app/settings/typography'
      path: '/typography'
      fullPath: '/settings/typography'
      preLoaderRoute: typeof AppSettingsTypographyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/work-locations': {
      id: '/_app/settings/work-locations'
      path: '/work-locations'
      fullPath: '/settings/work-locations'
      preLoaderRoute: typeof AppSettingsWorkLocationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/stock-adjustments/': {
      id: '/_app/stock-adjustments/'
      path: '/'
      fullPath: '/stock-adjustments/'
      preLoaderRoute: typeof AppStockAdjustmentsIndexRouteImport
      parentRoute: typeof AppStockAdjustmentsRouteRoute
    }
    '/_app/stock-adjustments/$adjustmentId': {
      id: '/_app/stock-adjustments/$adjustmentId'
      path: '/$adjustmentId'
      fullPath: '/stock-adjustments/$adjustmentId'
      preLoaderRoute: typeof AppStockAdjustmentsAdjustmentIdRouteImport
      parentRoute: typeof AppStockAdjustmentsRouteRoute
    }
    '/_app/stock-adjustments/new': {
      id: '/_app/stock-adjustments/new'
      path: '/new'
      fullPath: '/stock-adjustments/new'
      preLoaderRoute: typeof AppStockAdjustmentsNewRouteImport
      parentRoute: typeof AppStockAdjustmentsRouteRoute
    }
    '/_app/stock-transfers/': {
      id: '/_app/stock-transfers/'
      path: '/'
      fullPath: '/stock-transfers/'
      preLoaderRoute: typeof AppStockTransfersIndexRouteImport
      parentRoute: typeof AppStockTransfersRouteRoute
    }
    '/_app/stock-transfers/$transferId': {
      id: '/_app/stock-transfers/$transferId'
      path: '/$transferId'
      fullPath: '/stock-transfers/$transferId'
      preLoaderRoute: typeof AppStockTransfersTransferIdRouteRouteImport
      parentRoute: typeof AppStockTransfersRouteRoute
    }
    '/_app/stock-transfers/new': {
      id: '/_app/stock-transfers/new'
      path: '/new'
      fullPath: '/stock-transfers/new'
      preLoaderRoute: typeof AppStockTransfersNewRouteImport
      parentRoute: typeof AppStockTransfersRouteRoute
    }
    '/_app/supplier-payments/': {
      id: '/_app/supplier-payments/'
      path: '/'
      fullPath: '/supplier-payments/'
      preLoaderRoute: typeof AppSupplierPaymentsIndexRouteImport
      parentRoute: typeof AppSupplierPaymentsRouteRoute
    }
    '/_app/supplier-payments/$paymentId': {
      id: '/_app/supplier-payments/$paymentId'
      path: '/$paymentId'
      fullPath: '/supplier-payments/$paymentId'
      preLoaderRoute: typeof AppSupplierPaymentsPaymentIdRouteRouteImport
      parentRoute: typeof AppSupplierPaymentsRouteRoute
    }
    '/_app/supplier-payments/new': {
      id: '/_app/supplier-payments/new'
      path: '/new'
      fullPath: '/supplier-payments/new'
      preLoaderRoute: typeof AppSupplierPaymentsNewRouteImport
      parentRoute: typeof AppSupplierPaymentsRouteRoute
    }
    '/_app/supplier-refunds/': {
      id: '/_app/supplier-refunds/'
      path: '/'
      fullPath: '/supplier-refunds/'
      preLoaderRoute: typeof AppSupplierRefundsIndexRouteImport
      parentRoute: typeof AppSupplierRefundsRouteRoute
    }
    '/_app/supplier-refunds/$refundId': {
      id: '/_app/supplier-refunds/$refundId'
      path: '/$refundId'
      fullPath: '/supplier-refunds/$refundId'
      preLoaderRoute: typeof AppSupplierRefundsRefundIdRouteRouteImport
      parentRoute: typeof AppSupplierRefundsRouteRoute
    }
    '/_app/supplier-refunds/new': {
      id: '/_app/supplier-refunds/new'
      path: '/new'
      fullPath: '/supplier-refunds/new'
      preLoaderRoute: typeof AppSupplierRefundsNewRouteImport
      parentRoute: typeof AppSupplierRefundsRouteRoute
    }
    '/_app/supplier-returns/': {
      id: '/_app/supplier-returns/'
      path: '/'
      fullPath: '/supplier-returns/'
      preLoaderRoute: typeof AppSupplierReturnsIndexRouteImport
      parentRoute: typeof AppSupplierReturnsRouteRoute
    }
    '/_app/supplier-returns/$returnId': {
      id: '/_app/supplier-returns/$returnId'
      path: '/$returnId'
      fullPath: '/supplier-returns/$returnId'
      preLoaderRoute: typeof AppSupplierReturnsReturnIdRouteRouteImport
      parentRoute: typeof AppSupplierReturnsRouteRoute
    }
    '/_app/supplier-returns/new': {
      id: '/_app/supplier-returns/new'
      path: '/new'
      fullPath: '/supplier-returns/new'
      preLoaderRoute: typeof AppSupplierReturnsNewRouteImport
      parentRoute: typeof AppSupplierReturnsRouteRoute
    }
    '/_app/suppliers/': {
      id: '/_app/suppliers/'
      path: '/'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AppSuppliersIndexRouteImport
      parentRoute: typeof AppSuppliersRouteRoute
    }
    '/_app/suppliers/$supplierId': {
      id: '/_app/suppliers/$supplierId'
      path: '/$supplierId'
      fullPath: '/suppliers/$supplierId'
      preLoaderRoute: typeof AppSuppliersSupplierIdRouteRouteImport
      parentRoute: typeof AppSuppliersRouteRoute
    }
    '/_app/suppliers/new': {
      id: '/_app/suppliers/new'
      path: '/new'
      fullPath: '/suppliers/new'
      preLoaderRoute: typeof AppSuppliersNewRouteImport
      parentRoute: typeof AppSuppliersRouteRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppTasksRouteRoute
    }
    '/_app/tasks/$taskId': {
      id: '/_app/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AppTasksTaskIdRouteImport
      parentRoute: typeof AppTasksRouteRoute
    }
    '/_app/teams/': {
      id: '/_app/teams/'
      path: '/'
      fullPath: '/teams/'
      preLoaderRoute: typeof AppTeamsIndexRouteImport
      parentRoute: typeof AppTeamsRouteRoute
    }
    '/_app/teams/$teamId': {
      id: '/_app/teams/$teamId'
      path: '/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof AppTeamsTeamIdRouteImport
      parentRoute: typeof AppTeamsRouteRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/$userId': {
      id: '/_app/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/new': {
      id: '/_app/users/new'
      path: '/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AppUsersNewRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/workflows/': {
      id: '/_app/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AppWorkflowsIndexRouteImport
      parentRoute: typeof AppWorkflowsRouteRoute
    }
    '/_app/workflows/$workflowId': {
      id: '/_app/workflows/$workflowId'
      path: '/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof AppWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AppWorkflowsRouteRoute
    }
    '/_app/workflows/delegations': {
      id: '/_app/workflows/delegations'
      path: '/delegations'
      fullPath: '/workflows/delegations'
      preLoaderRoute: typeof AppWorkflowsDelegationsRouteImport
      parentRoute: typeof AppWorkflowsRouteRoute
    }
    '/_app/workflows/runs': {
      id: '/_app/workflows/runs'
      path: '/runs'
      fullPath: '/workflows/runs'
      preLoaderRoute: typeof AppWorkflowsRunsRouteRouteImport
      parentRoute: typeof AppWorkflowsRouteRoute
    }
    '/platform/_console/': {
      id: '/platform/_console/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof PlatformConsoleIndexRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/platform/_console/dashboard': {
      id: '/platform/_console/dashboard'
      path: '/dashboard'
      fullPath: '/platform/dashboard'
      preLoaderRoute: typeof PlatformConsoleDashboardRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/platform/_console/feedback': {
      id: '/platform/_console/feedback'
      path: '/feedback'
      fullPath: '/platform/feedback'
      preLoaderRoute: typeof PlatformConsoleFeedbackRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/platform/_console/profile': {
      id: '/platform/_console/profile'
      path: '/profile'
      fullPath: '/platform/profile'
      preLoaderRoute: typeof PlatformConsoleProfileRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/platform/_console/subscriptions': {
      id: '/platform/_console/subscriptions'
      path: '/subscriptions'
      fullPath: '/platform/subscriptions'
      preLoaderRoute: typeof PlatformConsoleSubscriptionsRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/_app/cheques/$chequeId/': {
      id: '/_app/cheques/$chequeId/'
      path: '/'
      fullPath: '/cheques/$chequeId/'
      preLoaderRoute: typeof AppChequesChequeIdIndexRouteImport
      parentRoute: typeof AppChequesChequeIdRouteRoute
    }
    '/_app/commissions/mine/': {
      id: '/_app/commissions/mine/'
      path: '/'
      fullPath: '/commissions/mine/'
      preLoaderRoute: typeof AppCommissionsMineIndexRouteImport
      parentRoute: typeof AppCommissionsMineRouteRoute
    }
    '/_app/commissions/mine/$statementId': {
      id: '/_app/commissions/mine/$statementId'
      path: '/$statementId'
      fullPath: '/commissions/mine/$statementId'
      preLoaderRoute: typeof AppCommissionsMineStatementIdRouteImport
      parentRoute: typeof AppCommissionsMineRouteRoute
    }
    '/_app/commissions/plans/': {
      id: '/_app/commissions/plans/'
      path: '/'
      fullPath: '/commissions/plans/'
      preLoaderRoute: typeof AppCommissionsPlansIndexRouteImport
      parentRoute: typeof AppCommissionsPlansRouteRoute
    }
    '/_app/commissions/plans/$planId': {
      id: '/_app/commissions/plans/$planId'
      path: '/$planId'
      fullPath: '/commissions/plans/$planId'
      preLoaderRoute: typeof AppCommissionsPlansPlanIdRouteImport
      parentRoute: typeof AppCommissionsPlansRouteRoute
    }
    '/_app/commissions/plans/new': {
      id: '/_app/commissions/plans/new'
      path: '/new'
      fullPath: '/commissions/plans/new'
      preLoaderRoute: typeof AppCommissionsPlansNewRouteImport
      parentRoute: typeof AppCommissionsPlansRouteRoute
    }
    '/_app/commissions/runs/': {
      id: '/_app/commissions/runs/'
      path: '/'
      fullPath: '/commissions/runs/'
      preLoaderRoute: typeof AppCommissionsRunsIndexRouteImport
      parentRoute: typeof AppCommissionsRunsRouteRoute
    }
    '/_app/commissions/runs/$runId': {
      id: '/_app/commissions/runs/$runId'
      path: '/$runId'
      fullPath: '/commissions/runs/$runId'
      preLoaderRoute: typeof AppCommissionsRunsRunIdRouteImport
      parentRoute: typeof AppCommissionsRunsRouteRoute
    }
    '/_app/commissions/statements/$statementId': {
      id: '/_app/commissions/statements/$statementId'
      path: '/$statementId'
      fullPath: '/commissions/statements/$statementId'
      preLoaderRoute: typeof AppCommissionsStatementsStatementIdRouteImport
      parentRoute: typeof AppCommissionsStatementsRouteRoute
    }
    '/_app/credit-notes/$creditNoteId/': {
      id: '/_app/credit-notes/$creditNoteId/'
      path: '/'
      fullPath: '/credit-notes/$creditNoteId/'
      preLoaderRoute: typeof AppCreditNotesCreditNoteIdIndexRouteImport
      parentRoute: typeof AppCreditNotesCreditNoteIdRouteRoute
    }
    '/_app/credit-notes/$creditNoteId/edit': {
      id: '/_app/credit-notes/$creditNoteId/edit'
      path: '/edit'
      fullPath: '/credit-notes/$creditNoteId/edit'
      preLoaderRoute: typeof AppCreditNotesCreditNoteIdEditRouteImport
      parentRoute: typeof AppCreditNotesCreditNoteIdRouteRoute
    }
    '/_app/credit-notes/$creditNoteId/print': {
      id: '/_app/credit-notes/$creditNoteId/print'
      path: '/print'
      fullPath: '/credit-notes/$creditNoteId/print'
      preLoaderRoute: typeof AppCreditNotesCreditNoteIdPrintRouteImport
      parentRoute: typeof AppCreditNotesCreditNoteIdRouteRoute
    }
    '/_app/customers/$customerId/': {
      id: '/_app/customers/$customerId/'
      path: '/'
      fullPath: '/customers/$customerId/'
      preLoaderRoute: typeof AppCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AppCustomersCustomerIdRouteRoute
    }
    '/_app/customers/$customerId/edit': {
      id: '/_app/customers/$customerId/edit'
      path: '/edit'
      fullPath: '/customers/$customerId/edit'
      preLoaderRoute: typeof AppCustomersCustomerIdEditRouteImport
      parentRoute: typeof AppCustomersCustomerIdRouteRoute
    }
    '/_app/expenses/$expenseId/': {
      id: '/_app/expenses/$expenseId/'
      path: '/'
      fullPath: '/expenses/$expenseId/'
      preLoaderRoute: typeof AppExpensesExpenseIdIndexRouteImport
      parentRoute: typeof AppExpensesExpenseIdRouteRoute
    }
    '/_app/expenses/$expenseId/edit': {
      id: '/_app/expenses/$expenseId/edit'
      path: '/edit'
      fullPath: '/expenses/$expenseId/edit'
      preLoaderRoute: typeof AppExpensesExpenseIdEditRouteImport
      parentRoute: typeof AppExpensesExpenseIdRouteRoute
    }
    '/_app/expenses/recurring/': {
      id: '/_app/expenses/recurring/'
      path: '/'
      fullPath: '/expenses/recurring/'
      preLoaderRoute: typeof AppExpensesRecurringIndexRouteImport
      parentRoute: typeof AppExpensesRecurringRouteRoute
    }
    '/_app/expenses/recurring/$recurringId': {
      id: '/_app/expenses/recurring/$recurringId'
      path: '/$recurringId'
      fullPath: '/expenses/recurring/$recurringId'
      preLoaderRoute: typeof AppExpensesRecurringRecurringIdRouteRouteImport
      parentRoute: typeof AppExpensesRecurringRouteRoute
    }
    '/_app/expenses/recurring/new': {
      id: '/_app/expenses/recurring/new'
      path: '/new'
      fullPath: '/expenses/recurring/new'
      preLoaderRoute: typeof AppExpensesRecurringNewRouteImport
      parentRoute: typeof AppExpensesRecurringRouteRoute
    }
    '/_app/hr/employees/': {
      id: '/_app/hr/employees/'
      path: '/'
      fullPath: '/hr/employees/'
      preLoaderRoute: typeof AppHrEmployeesIndexRouteImport
      parentRoute: typeof AppHrEmployeesRouteRoute
    }
    '/_app/hr/employees/$employeeId': {
      id: '/_app/hr/employees/$employeeId'
      path: '/$employeeId'
      fullPath: '/hr/employees/$employeeId'
      preLoaderRoute: typeof AppHrEmployeesEmployeeIdRouteRouteImport
      parentRoute: typeof AppHrEmployeesRouteRoute
    }
    '/_app/hr/employees/new': {
      id: '/_app/hr/employees/new'
      path: '/new'
      fullPath: '/hr/employees/new'
      preLoaderRoute: typeof AppHrEmployeesNewRouteImport
      parentRoute: typeof AppHrEmployeesRouteRoute
    }
    '/_app/invoices/$invoiceId/': {
      id: '/_app/invoices/$invoiceId/'
      path: '/'
      fullPath: '/invoices/$invoiceId/'
      preLoaderRoute: typeof AppInvoicesInvoiceIdIndexRouteImport
      parentRoute: typeof AppInvoicesInvoiceIdRouteRoute
    }
    '/_app/invoices/$invoiceId/edit': {
      id: '/_app/invoices/$invoiceId/edit'
      path: '/edit'
      fullPath: '/invoices/$invoiceId/edit'
      preLoaderRoute: typeof AppInvoicesInvoiceIdEditRouteImport
      parentRoute: typeof AppInvoicesInvoiceIdRouteRoute
    }
    '/_app/invoices/$invoiceId/print': {
      id: '/_app/invoices/$invoiceId/print'
      path: '/print'
      fullPath: '/invoices/$invoiceId/print'
      preLoaderRoute: typeof AppInvoicesInvoiceIdPrintRouteImport
      parentRoute: typeof AppInvoicesInvoiceIdRouteRoute
    }
    '/_app/loyalty/members/': {
      id: '/_app/loyalty/members/'
      path: '/'
      fullPath: '/loyalty/members/'
      preLoaderRoute: typeof AppLoyaltyMembersIndexRouteImport
      parentRoute: typeof AppLoyaltyMembersRouteRoute
    }
    '/_app/loyalty/members/$memberId': {
      id: '/_app/loyalty/members/$memberId'
      path: '/$memberId'
      fullPath: '/loyalty/members/$memberId'
      preLoaderRoute: typeof AppLoyaltyMembersMemberIdRouteImport
      parentRoute: typeof AppLoyaltyMembersRouteRoute
    }
    '/_app/payroll/runs/': {
      id: '/_app/payroll/runs/'
      path: '/'
      fullPath: '/payroll/runs/'
      preLoaderRoute: typeof AppPayrollRunsIndexRouteImport
      parentRoute: typeof AppPayrollRunsRouteRoute
    }
    '/_app/payroll/runs/$runId': {
      id: '/_app/payroll/runs/$runId'
      path: '/$runId'
      fullPath: '/payroll/runs/$runId'
      preLoaderRoute: typeof AppPayrollRunsRunIdRouteRouteImport
      parentRoute: typeof AppPayrollRunsRouteRoute
    }
    '/_app/pos/returns/$returnId': {
      id: '/_app/pos/returns/$returnId'
      path: '/pos/returns/$returnId'
      fullPath: '/pos/returns/$returnId'
      preLoaderRoute: typeof AppPosReturnsReturnIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos/sales/$saleId': {
      id: '/_app/pos/sales/$saleId'
      path: '/pos/sales/$saleId'
      fullPath: '/pos/sales/$saleId'
      preLoaderRoute: typeof AppPosSalesSaleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos/shifts/': {
      id: '/_app/pos/shifts/'
      path: '/'
      fullPath: '/pos/shifts/'
      preLoaderRoute: typeof AppPosShiftsIndexRouteImport
      parentRoute: typeof AppPosShiftsRouteRoute
    }
    '/_app/pos/shifts/$shiftId': {
      id: '/_app/pos/shifts/$shiftId'
      path: '/$shiftId'
      fullPath: '/pos/shifts/$shiftId'
      preLoaderRoute: typeof AppPosShiftsShiftIdRouteImport
      parentRoute: typeof AppPosShiftsRouteRoute
    }
    '/_app/products/$productId/': {
      id: '/_app/products/$productId/'
      path: '/'
      fullPath: '/products/$productId/'
      preLoaderRoute: typeof AppProductsProductIdIndexRouteImport
      parentRoute: typeof AppProductsProductIdRouteRoute
    }
    '/_app/products/$productId/edit': {
      id: '/_app/products/$productId/edit'
      path: '/edit'
      fullPath: '/products/$productId/edit'
      preLoaderRoute: typeof AppProductsProductIdEditRouteImport
      parentRoute: typeof AppProductsProductIdRouteRoute
    }
    '/_app/products/$productId/labels': {
      id: '/_app/products/$productId/labels'
      path: '/labels'
      fullPath: '/products/$productId/labels'
      preLoaderRoute: typeof AppProductsProductIdLabelsRouteImport
      parentRoute: typeof AppProductsProductIdRouteRoute
    }
    '/_app/projects/$projectId/': {
      id: '/_app/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/projects/cost-entries/': {
      id: '/_app/projects/cost-entries/'
      path: '/'
      fullPath: '/projects/cost-entries/'
      preLoaderRoute: typeof AppProjectsCostEntriesIndexRouteImport
      parentRoute: typeof AppProjectsCostEntriesRouteRoute
    }
    '/_app/projects/cost-entries/$entryId': {
      id: '/_app/projects/cost-entries/$entryId'
      path: '/$entryId'
      fullPath: '/projects/cost-entries/$entryId'
      preLoaderRoute: typeof AppProjectsCostEntriesEntryIdRouteImport
      parentRoute: typeof AppProjectsCostEntriesRouteRoute
    }
    '/_app/projects/material-issues/': {
      id: '/_app/projects/material-issues/'
      path: '/'
      fullPath: '/projects/material-issues/'
      preLoaderRoute: typeof AppProjectsMaterialIssuesIndexRouteImport
      parentRoute: typeof AppProjectsMaterialIssuesRouteRoute
    }
    '/_app/projects/material-issues/$issueId': {
      id: '/_app/projects/material-issues/$issueId'
      path: '/$issueId'
      fullPath: '/projects/material-issues/$issueId'
      preLoaderRoute: typeof AppProjectsMaterialIssuesIssueIdRouteImport
      parentRoute: typeof AppProjectsMaterialIssuesRouteRoute
    }
    '/_app/projects/time/': {
      id: '/_app/projects/time/'
      path: '/time'
      fullPath: '/projects/time/'
      preLoaderRoute: typeof AppProjectsTimeIndexRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/time/approvals': {
      id: '/_app/projects/time/approvals'
      path: '/time/approvals'
      fullPath: '/projects/time/approvals'
      preLoaderRoute: typeof AppProjectsTimeApprovalsRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/purchases/$purchaseId/': {
      id: '/_app/purchases/$purchaseId/'
      path: '/'
      fullPath: '/purchases/$purchaseId/'
      preLoaderRoute: typeof AppPurchasesPurchaseIdIndexRouteImport
      parentRoute: typeof AppPurchasesPurchaseIdRouteRoute
    }
    '/_app/purchases/$purchaseId/edit': {
      id: '/_app/purchases/$purchaseId/edit'
      path: '/edit'
      fullPath: '/purchases/$purchaseId/edit'
      preLoaderRoute: typeof AppPurchasesPurchaseIdEditRouteImport
      parentRoute: typeof AppPurchasesPurchaseIdRouteRoute
    }
    '/_app/purchases/$purchaseId/print': {
      id: '/_app/purchases/$purchaseId/print'
      path: '/print'
      fullPath: '/purchases/$purchaseId/print'
      preLoaderRoute: typeof AppPurchasesPurchaseIdPrintRouteImport
      parentRoute: typeof AppPurchasesPurchaseIdRouteRoute
    }
    '/_app/quotations/$quotationId/': {
      id: '/_app/quotations/$quotationId/'
      path: '/'
      fullPath: '/quotations/$quotationId/'
      preLoaderRoute: typeof AppQuotationsQuotationIdIndexRouteImport
      parentRoute: typeof AppQuotationsQuotationIdRouteRoute
    }
    '/_app/quotations/$quotationId/edit': {
      id: '/_app/quotations/$quotationId/edit'
      path: '/edit'
      fullPath: '/quotations/$quotationId/edit'
      preLoaderRoute: typeof AppQuotationsQuotationIdEditRouteImport
      parentRoute: typeof AppQuotationsQuotationIdRouteRoute
    }
    '/_app/quotations/$quotationId/print': {
      id: '/_app/quotations/$quotationId/print'
      path: '/print'
      fullPath: '/quotations/$quotationId/print'
      preLoaderRoute: typeof AppQuotationsQuotationIdPrintRouteImport
      parentRoute: typeof AppQuotationsQuotationIdRouteRoute
    }
    '/_app/receipts/$receiptId/': {
      id: '/_app/receipts/$receiptId/'
      path: '/'
      fullPath: '/receipts/$receiptId/'
      preLoaderRoute: typeof AppReceiptsReceiptIdIndexRouteImport
      parentRoute: typeof AppReceiptsReceiptIdRouteRoute
    }
    '/_app/receipts/$receiptId/print': {
      id: '/_app/receipts/$receiptId/print'
      path: '/print'
      fullPath: '/receipts/$receiptId/print'
      preLoaderRoute: typeof AppReceiptsReceiptIdPrintRouteImport
      parentRoute: typeof AppReceiptsReceiptIdRouteRoute
    }
    '/_app/refunds/$refundId/': {
      id: '/_app/refunds/$refundId/'
      path: '/'
      fullPath: '/refunds/$refundId/'
      preLoaderRoute: typeof AppRefundsRefundIdIndexRouteImport
      parentRoute: typeof AppRefundsRefundIdRouteRoute
    }
    '/_app/refunds/$refundId/print': {
      id: '/_app/refunds/$refundId/print'
      path: '/print'
      fullPath: '/refunds/$refundId/print'
      preLoaderRoute: typeof AppRefundsRefundIdPrintRouteImport
      parentRoute: typeof AppRefundsRefundIdRouteRoute
    }
    '/_app/service/assets/': {
      id: '/_app/service/assets/'
      path: '/'
      fullPath: '/service/assets/'
      preLoaderRoute: typeof AppServiceAssetsIndexRouteImport
      parentRoute: typeof AppServiceAssetsRouteRoute
    }
    '/_app/service/assets/$assetId': {
      id: '/_app/service/assets/$assetId'
      path: '/$assetId'
      fullPath: '/service/assets/$assetId'
      preLoaderRoute: typeof AppServiceAssetsAssetIdRouteImport
      parentRoute: typeof AppServiceAssetsRouteRoute
    }
    '/_app/service/assets/labels': {
      id: '/_app/service/assets/labels'
      path: '/labels'
      fullPath: '/service/assets/labels'
      preLoaderRoute: typeof AppServiceAssetsLabelsRouteImport
      parentRoute: typeof AppServiceAssetsRouteRoute
    }
    '/_app/service/contracts/': {
      id: '/_app/service/contracts/'
      path: '/'
      fullPath: '/service/contracts/'
      preLoaderRoute: typeof AppServiceContractsIndexRouteImport
      parentRoute: typeof AppServiceContractsRouteRoute
    }
    '/_app/service/contracts/$contractId': {
      id: '/_app/service/contracts/$contractId'
      path: '/$contractId'
      fullPath: '/service/contracts/$contractId'
      preLoaderRoute: typeof AppServiceContractsContractIdRouteRouteImport
      parentRoute: typeof AppServiceContractsRouteRoute
    }
    '/_app/service/contracts/billing': {
      id: '/_app/service/contracts/billing'
      path: '/billing'
      fullPath: '/service/contracts/billing'
      preLoaderRoute: typeof AppServiceContractsBillingRouteImport
      parentRoute: typeof AppServiceContractsRouteRoute
    }
    '/_app/service/contracts/insights': {
      id: '/_app/service/contracts/insights'
      path: '/insights'
      fullPath: '/service/contracts/insights'
      preLoaderRoute: typeof AppServiceContractsInsightsRouteImport
      parentRoute: typeof AppServiceContractsRouteRoute
    }
    '/_app/service/contracts/new': {
      id: '/_app/service/contracts/new'
      path: '/new'
      fullPath: '/service/contracts/new'
      preLoaderRoute: typeof AppServiceContractsNewRouteImport
      parentRoute: typeof AppServiceContractsRouteRoute
    }
    '/_app/service/jobs/': {
      id: '/_app/service/jobs/'
      path: '/'
      fullPath: '/service/jobs/'
      preLoaderRoute: typeof AppServiceJobsIndexRouteImport
      parentRoute: typeof AppServiceJobsRouteRoute
    }
    '/_app/service/jobs/$jobId': {
      id: '/_app/service/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/service/jobs/$jobId'
      preLoaderRoute: typeof AppServiceJobsJobIdRouteRouteImport
      parentRoute: typeof AppServiceJobsRouteRoute
    }
    '/_app/service/sites/': {
      id: '/_app/service/sites/'
      path: '/'
      fullPath: '/service/sites/'
      preLoaderRoute: typeof AppServiceSitesIndexRouteImport
      parentRoute: typeof AppServiceSitesRouteRoute
    }
    '/_app/service/sites/$siteId': {
      id: '/_app/service/sites/$siteId'
      path: '/$siteId'
      fullPath: '/service/sites/$siteId'
      preLoaderRoute: typeof AppServiceSitesSiteIdRouteImport
      parentRoute: typeof AppServiceSitesRouteRoute
    }
    '/_app/service/visits/': {
      id: '/_app/service/visits/'
      path: '/'
      fullPath: '/service/visits/'
      preLoaderRoute: typeof AppServiceVisitsIndexRouteImport
      parentRoute: typeof AppServiceVisitsRouteRoute
    }
    '/_app/service/visits/$visitId': {
      id: '/_app/service/visits/$visitId'
      path: '/$visitId'
      fullPath: '/service/visits/$visitId'
      preLoaderRoute: typeof AppServiceVisitsVisitIdRouteRouteImport
      parentRoute: typeof AppServiceVisitsRouteRoute
    }
    '/_app/settings/ai/': {
      id: '/_app/settings/ai/'
      path: '/ai'
      fullPath: '/settings/ai/'
      preLoaderRoute: typeof AppSettingsAiIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/ai/usage': {
      id: '/_app/settings/ai/usage'
      path: '/ai/usage'
      fullPath: '/settings/ai/usage'
      preLoaderRoute: typeof AppSettingsAiUsageRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/stock-transfers/$transferId/': {
      id: '/_app/stock-transfers/$transferId/'
      path: '/'
      fullPath: '/stock-transfers/$transferId/'
      preLoaderRoute: typeof AppStockTransfersTransferIdIndexRouteImport
      parentRoute: typeof AppStockTransfersTransferIdRouteRoute
    }
    '/_app/stock-transfers/$transferId/edit': {
      id: '/_app/stock-transfers/$transferId/edit'
      path: '/edit'
      fullPath: '/stock-transfers/$transferId/edit'
      preLoaderRoute: typeof AppStockTransfersTransferIdEditRouteImport
      parentRoute: typeof AppStockTransfersTransferIdRouteRoute
    }
    '/_app/stock-transfers/$transferId/print': {
      id: '/_app/stock-transfers/$transferId/print'
      path: '/print'
      fullPath: '/stock-transfers/$transferId/print'
      preLoaderRoute: typeof AppStockTransfersTransferIdPrintRouteImport
      parentRoute: typeof AppStockTransfersTransferIdRouteRoute
    }
    '/_app/supplier-payments/$paymentId/': {
      id: '/_app/supplier-payments/$paymentId/'
      path: '/'
      fullPath: '/supplier-payments/$paymentId/'
      preLoaderRoute: typeof AppSupplierPaymentsPaymentIdIndexRouteImport
      parentRoute: typeof AppSupplierPaymentsPaymentIdRouteRoute
    }
    '/_app/supplier-payments/$paymentId/print': {
      id: '/_app/supplier-payments/$paymentId/print'
      path: '/print'
      fullPath: '/supplier-payments/$paymentId/print'
      preLoaderRoute: typeof AppSupplierPaymentsPaymentIdPrintRouteImport
      parentRoute: typeof AppSupplierPaymentsPaymentIdRouteRoute
    }
    '/_app/supplier-refunds/$refundId/': {
      id: '/_app/supplier-refunds/$refundId/'
      path: '/'
      fullPath: '/supplier-refunds/$refundId/'
      preLoaderRoute: typeof AppSupplierRefundsRefundIdIndexRouteImport
      parentRoute: typeof AppSupplierRefundsRefundIdRouteRoute
    }
    '/_app/supplier-refunds/$refundId/print': {
      id: '/_app/supplier-refunds/$refundId/print'
      path: '/print'
      fullPath: '/supplier-refunds/$refundId/print'
      preLoaderRoute: typeof AppSupplierRefundsRefundIdPrintRouteImport
      parentRoute: typeof AppSupplierRefundsRefundIdRouteRoute
    }
    '/_app/supplier-returns/$returnId/': {
      id: '/_app/supplier-returns/$returnId/'
      path: '/'
      fullPath: '/supplier-returns/$returnId/'
      preLoaderRoute: typeof AppSupplierReturnsReturnIdIndexRouteImport
      parentRoute: typeof AppSupplierReturnsReturnIdRouteRoute
    }
    '/_app/supplier-returns/$returnId/edit': {
      id: '/_app/supplier-returns/$returnId/edit'
      path: '/edit'
      fullPath: '/supplier-returns/$returnId/edit'
      preLoaderRoute: typeof AppSupplierReturnsReturnIdEditRouteImport
      parentRoute: typeof AppSupplierReturnsReturnIdRouteRoute
    }
    '/_app/supplier-returns/$returnId/print': {
      id: '/_app/supplier-returns/$returnId/print'
      path: '/print'
      fullPath: '/supplier-returns/$returnId/print'
      preLoaderRoute: typeof AppSupplierReturnsReturnIdPrintRouteImport
      parentRoute: typeof AppSupplierReturnsReturnIdRouteRoute
    }
    '/_app/suppliers/$supplierId/': {
      id: '/_app/suppliers/$supplierId/'
      path: '/'
      fullPath: '/suppliers/$supplierId/'
      preLoaderRoute: typeof AppSuppliersSupplierIdIndexRouteImport
      parentRoute: typeof AppSuppliersSupplierIdRouteRoute
    }
    '/_app/suppliers/$supplierId/edit': {
      id: '/_app/suppliers/$supplierId/edit'
      path: '/edit'
      fullPath: '/suppliers/$supplierId/edit'
      preLoaderRoute: typeof AppSuppliersSupplierIdEditRouteImport
      parentRoute: typeof AppSuppliersSupplierIdRouteRoute
    }
    '/_app/workflows/runs/': {
      id: '/_app/workflows/runs/'
      path: '/'
      fullPath: '/workflows/runs/'
      preLoaderRoute: typeof AppWorkflowsRunsIndexRouteImport
      parentRoute: typeof AppWorkflowsRunsRouteRoute
    }
    '/_app/workflows/runs/$runId': {
      id: '/_app/workflows/runs/$runId'
      path: '/$runId'
      fullPath: '/workflows/runs/$runId'
      preLoaderRoute: typeof AppWorkflowsRunsRunIdRouteImport
      parentRoute: typeof AppWorkflowsRunsRouteRoute
    }
    '/platform/_console/tenants/': {
      id: '/platform/_console/tenants/'
      path: '/tenants'
      fullPath: '/platform/tenants/'
      preLoaderRoute: typeof PlatformConsoleTenantsIndexRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/platform/_console/tenants/$tenantId': {
      id: '/platform/_console/tenants/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/platform/tenants/$tenantId'
      preLoaderRoute: typeof PlatformConsoleTenantsTenantIdRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/platform/_console/tenants/new': {
      id: '/platform/_console/tenants/new'
      path: '/tenants/new'
      fullPath: '/platform/tenants/new'
      preLoaderRoute: typeof PlatformConsoleTenantsNewRouteImport
      parentRoute: typeof PlatformConsoleRoute
    }
    '/_app/expenses/recurring/$recurringId/': {
      id: '/_app/expenses/recurring/$recurringId/'
      path: '/'
      fullPath: '/expenses/recurring/$recurringId/'
      preLoaderRoute: typeof AppExpensesRecurringRecurringIdIndexRouteImport
      parentRoute: typeof AppExpensesRecurringRecurringIdRouteRoute
    }
    '/_app/expenses/recurring/$recurringId/edit': {
      id: '/_app/expenses/recurring/$recurringId/edit'
      path: '/edit'
      fullPath: '/expenses/recurring/$recurringId/edit'
      preLoaderRoute: typeof AppExpensesRecurringRecurringIdEditRouteImport
      parentRoute: typeof AppExpensesRecurringRecurringIdRouteRoute
    }
    '/_app/hr/employees/$employeeId/': {
      id: '/_app/hr/employees/$employeeId/'
      path: '/'
      fullPath: '/hr/employees/$employeeId/'
      preLoaderRoute: typeof AppHrEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof AppHrEmployeesEmployeeIdRouteRoute
    }
    '/_app/hr/employees/$employeeId/edit': {
      id: '/_app/hr/employees/$employeeId/edit'
      path: '/edit'
      fullPath: '/hr/employees/$employeeId/edit'
      preLoaderRoute: typeof AppHrEmployeesEmployeeIdEditRouteImport
      parentRoute: typeof AppHrEmployeesEmployeeIdRouteRoute
    }
    '/_app/payroll/runs/$runId/': {
      id: '/_app/payroll/runs/$runId/'
      path: '/'
      fullPath: '/payroll/runs/$runId/'
      preLoaderRoute: typeof AppPayrollRunsRunIdIndexRouteImport
      parentRoute: typeof AppPayrollRunsRunIdRouteRoute
    }
    '/_app/projects/$projectId/contract/statement': {
      id: '/_app/projects/$projectId/contract/statement'
      path: '/contract/statement'
      fullPath: '/projects/$projectId/contract/statement'
      preLoaderRoute: typeof AppProjectsProjectIdContractStatementRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/projects/$projectId/reports/': {
      id: '/_app/projects/$projectId/reports/'
      path: '/reports'
      fullPath: '/projects/$projectId/reports/'
      preLoaderRoute: typeof AppProjectsProjectIdReportsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/service/contracts/$contractId/': {
      id: '/_app/service/contracts/$contractId/'
      path: '/'
      fullPath: '/service/contracts/$contractId/'
      preLoaderRoute: typeof AppServiceContractsContractIdIndexRouteImport
      parentRoute: typeof AppServiceContractsContractIdRouteRoute
    }
    '/_app/service/contracts/$contractId/edit': {
      id: '/_app/service/contracts/$contractId/edit'
      path: '/edit'
      fullPath: '/service/contracts/$contractId/edit'
      preLoaderRoute: typeof AppServiceContractsContractIdEditRouteImport
      parentRoute: typeof AppServiceContractsContractIdRouteRoute
    }
    '/_app/service/contracts/$contractId/print': {
      id: '/_app/service/contracts/$contractId/print'
      path: '/print'
      fullPath: '/service/contracts/$contractId/print'
      preLoaderRoute: typeof AppServiceContractsContractIdPrintRouteImport
      parentRoute: typeof AppServiceContractsContractIdRouteRoute
    }
    '/_app/service/jobs/$jobId/': {
      id: '/_app/service/jobs/$jobId/'
      path: '/'
      fullPath: '/service/jobs/$jobId/'
      preLoaderRoute: typeof AppServiceJobsJobIdIndexRouteImport
      parentRoute: typeof AppServiceJobsJobIdRouteRoute
    }
    '/_app/service/jobs/$jobId/estimate': {
      id: '/_app/service/jobs/$jobId/estimate'
      path: '/estimate'
      fullPath: '/service/jobs/$jobId/estimate'
      preLoaderRoute: typeof AppServiceJobsJobIdEstimateRouteImport
      parentRoute: typeof AppServiceJobsJobIdRouteRoute
    }
    '/_app/service/visits/$visitId/': {
      id: '/_app/service/visits/$visitId/'
      path: '/'
      fullPath: '/service/visits/$visitId/'
      preLoaderRoute: typeof AppServiceVisitsVisitIdIndexRouteImport
      parentRoute: typeof AppServiceVisitsVisitIdRouteRoute
    }
    '/_app/service/visits/$visitId/report': {
      id: '/_app/service/visits/$visitId/report'
      path: '/report'
      fullPath: '/service/visits/$visitId/report'
      preLoaderRoute: typeof AppServiceVisitsVisitIdReportRouteImport
      parentRoute: typeof AppServiceVisitsVisitIdRouteRoute
    }
    '/_app/payroll/runs/$runId/payslips/$payslipId': {
      id: '/_app/payroll/runs/$runId/payslips/$payslipId'
      path: '/payslips/$payslipId'
      fullPath: '/payroll/runs/$runId/payslips/$payslipId'
      preLoaderRoute: typeof AppPayrollRunsRunIdPayslipsPayslipIdRouteImport
      parentRoute: typeof AppPayrollRunsRunIdRouteRoute
    }
    '/_app/projects/$projectId/claims/$claimId/': {
      id: '/_app/projects/$projectId/claims/$claimId/'
      path: '/claims/$claimId'
      fullPath: '/projects/$projectId/claims/$claimId/'
      preLoaderRoute: typeof AppProjectsProjectIdClaimsClaimIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/projects/$projectId/claims/$claimId/print': {
      id: '/_app/projects/$projectId/claims/$claimId/print'
      path: '/claims/$claimId/print'
      fullPath: '/projects/$projectId/claims/$claimId/print'
      preLoaderRoute: typeof AppProjectsProjectIdClaimsClaimIdPrintRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/projects/$projectId/reports/$reportId/': {
      id: '/_app/projects/$projectId/reports/$reportId/'
      path: '/reports/$reportId'
      fullPath: '/projects/$projectId/reports/$reportId/'
      preLoaderRoute: typeof AppProjectsProjectIdReportsReportIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/projects/$projectId/reports/$reportId/print': {
      id: '/_app/projects/$projectId/reports/$reportId/print'
      path: '/reports/$reportId/print'
      fullPath: '/projects/$projectId/reports/$reportId/print'
      preLoaderRoute: typeof AppProjectsProjectIdReportsReportIdPrintRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
  }
}

interface AppApprovalsRouteRouteChildren {
  AppApprovalsRunIdRoute: typeof AppApprovalsRunIdRoute
  AppApprovalsIndexRoute: typeof AppApprovalsIndexRoute
}

const AppApprovalsRouteRouteChildren: AppApprovalsRouteRouteChildren = {
  AppApprovalsRunIdRoute: AppApprovalsRunIdRoute,
  AppApprovalsIndexRoute: AppApprovalsIndexRoute,
}

const AppApprovalsRouteRouteWithChildren =
  AppApprovalsRouteRoute._addFileChildren(AppApprovalsRouteRouteChildren)

interface AppBankStatementsRouteRouteChildren {
  AppBankStatementsStatementIdRoute: typeof AppBankStatementsStatementIdRoute
  AppBankStatementsNewRoute: typeof AppBankStatementsNewRoute
  AppBankStatementsIndexRoute: typeof AppBankStatementsIndexRoute
}

const AppBankStatementsRouteRouteChildren: AppBankStatementsRouteRouteChildren =
  {
    AppBankStatementsStatementIdRoute: AppBankStatementsStatementIdRoute,
    AppBankStatementsNewRoute: AppBankStatementsNewRoute,
    AppBankStatementsIndexRoute: AppBankStatementsIndexRoute,
  }

const AppBankStatementsRouteRouteWithChildren =
  AppBankStatementsRouteRoute._addFileChildren(
    AppBankStatementsRouteRouteChildren,
  )

interface AppChequesChequeIdRouteRouteChildren {
  AppChequesChequeIdIndexRoute: typeof AppChequesChequeIdIndexRoute
}

const AppChequesChequeIdRouteRouteChildren: AppChequesChequeIdRouteRouteChildren =
  {
    AppChequesChequeIdIndexRoute: AppChequesChequeIdIndexRoute,
  }

const AppChequesChequeIdRouteRouteWithChildren =
  AppChequesChequeIdRouteRoute._addFileChildren(
    AppChequesChequeIdRouteRouteChildren,
  )

interface AppChequesRouteRouteChildren {
  AppChequesChequeIdRouteRoute: typeof AppChequesChequeIdRouteRouteWithChildren
  AppChequesIndexRoute: typeof AppChequesIndexRoute
}

const AppChequesRouteRouteChildren: AppChequesRouteRouteChildren = {
  AppChequesChequeIdRouteRoute: AppChequesChequeIdRouteRouteWithChildren,
  AppChequesIndexRoute: AppChequesIndexRoute,
}

const AppChequesRouteRouteWithChildren = AppChequesRouteRoute._addFileChildren(
  AppChequesRouteRouteChildren,
)

interface AppCommissionsMineRouteRouteChildren {
  AppCommissionsMineStatementIdRoute: typeof AppCommissionsMineStatementIdRoute
  AppCommissionsMineIndexRoute: typeof AppCommissionsMineIndexRoute
}

const AppCommissionsMineRouteRouteChildren: AppCommissionsMineRouteRouteChildren =
  {
    AppCommissionsMineStatementIdRoute: AppCommissionsMineStatementIdRoute,
    AppCommissionsMineIndexRoute: AppCommissionsMineIndexRoute,
  }

const AppCommissionsMineRouteRouteWithChildren =
  AppCommissionsMineRouteRoute._addFileChildren(
    AppCommissionsMineRouteRouteChildren,
  )

interface AppCommissionsPlansRouteRouteChildren {
  AppCommissionsPlansPlanIdRoute: typeof AppCommissionsPlansPlanIdRoute
  AppCommissionsPlansNewRoute: typeof AppCommissionsPlansNewRoute
  AppCommissionsPlansIndexRoute: typeof AppCommissionsPlansIndexRoute
}

const AppCommissionsPlansRouteRouteChildren: AppCommissionsPlansRouteRouteChildren =
  {
    AppCommissionsPlansPlanIdRoute: AppCommissionsPlansPlanIdRoute,
    AppCommissionsPlansNewRoute: AppCommissionsPlansNewRoute,
    AppCommissionsPlansIndexRoute: AppCommissionsPlansIndexRoute,
  }

const AppCommissionsPlansRouteRouteWithChildren =
  AppCommissionsPlansRouteRoute._addFileChildren(
    AppCommissionsPlansRouteRouteChildren,
  )

interface AppCommissionsRunsRouteRouteChildren {
  AppCommissionsRunsRunIdRoute: typeof AppCommissionsRunsRunIdRoute
  AppCommissionsRunsIndexRoute: typeof AppCommissionsRunsIndexRoute
}

const AppCommissionsRunsRouteRouteChildren: AppCommissionsRunsRouteRouteChildren =
  {
    AppCommissionsRunsRunIdRoute: AppCommissionsRunsRunIdRoute,
    AppCommissionsRunsIndexRoute: AppCommissionsRunsIndexRoute,
  }

const AppCommissionsRunsRouteRouteWithChildren =
  AppCommissionsRunsRouteRoute._addFileChildren(
    AppCommissionsRunsRouteRouteChildren,
  )

interface AppCommissionsStatementsRouteRouteChildren {
  AppCommissionsStatementsStatementIdRoute: typeof AppCommissionsStatementsStatementIdRoute
}

const AppCommissionsStatementsRouteRouteChildren: AppCommissionsStatementsRouteRouteChildren =
  {
    AppCommissionsStatementsStatementIdRoute:
      AppCommissionsStatementsStatementIdRoute,
  }

const AppCommissionsStatementsRouteRouteWithChildren =
  AppCommissionsStatementsRouteRoute._addFileChildren(
    AppCommissionsStatementsRouteRouteChildren,
  )

interface AppCommissionsRouteRouteChildren {
  AppCommissionsMineRouteRoute: typeof AppCommissionsMineRouteRouteWithChildren
  AppCommissionsPlansRouteRoute: typeof AppCommissionsPlansRouteRouteWithChildren
  AppCommissionsRunsRouteRoute: typeof AppCommissionsRunsRouteRouteWithChildren
  AppCommissionsStatementsRouteRoute: typeof AppCommissionsStatementsRouteRouteWithChildren
  AppCommissionsIndexRoute: typeof AppCommissionsIndexRoute
}

const AppCommissionsRouteRouteChildren: AppCommissionsRouteRouteChildren = {
  AppCommissionsMineRouteRoute: AppCommissionsMineRouteRouteWithChildren,
  AppCommissionsPlansRouteRoute: AppCommissionsPlansRouteRouteWithChildren,
  AppCommissionsRunsRouteRoute: AppCommissionsRunsRouteRouteWithChildren,
  AppCommissionsStatementsRouteRoute:
    AppCommissionsStatementsRouteRouteWithChildren,
  AppCommissionsIndexRoute: AppCommissionsIndexRoute,
}

const AppCommissionsRouteRouteWithChildren =
  AppCommissionsRouteRoute._addFileChildren(AppCommissionsRouteRouteChildren)

interface AppCreditNotesCreditNoteIdRouteRouteChildren {
  AppCreditNotesCreditNoteIdEditRoute: typeof AppCreditNotesCreditNoteIdEditRoute
  AppCreditNotesCreditNoteIdPrintRoute: typeof AppCreditNotesCreditNoteIdPrintRoute
  AppCreditNotesCreditNoteIdIndexRoute: typeof AppCreditNotesCreditNoteIdIndexRoute
}

const AppCreditNotesCreditNoteIdRouteRouteChildren: AppCreditNotesCreditNoteIdRouteRouteChildren =
  {
    AppCreditNotesCreditNoteIdEditRoute: AppCreditNotesCreditNoteIdEditRoute,
    AppCreditNotesCreditNoteIdPrintRoute: AppCreditNotesCreditNoteIdPrintRoute,
    AppCreditNotesCreditNoteIdIndexRoute: AppCreditNotesCreditNoteIdIndexRoute,
  }

const AppCreditNotesCreditNoteIdRouteRouteWithChildren =
  AppCreditNotesCreditNoteIdRouteRoute._addFileChildren(
    AppCreditNotesCreditNoteIdRouteRouteChildren,
  )

interface AppCreditNotesRouteRouteChildren {
  AppCreditNotesCreditNoteIdRouteRoute: typeof AppCreditNotesCreditNoteIdRouteRouteWithChildren
  AppCreditNotesNewRoute: typeof AppCreditNotesNewRoute
  AppCreditNotesIndexRoute: typeof AppCreditNotesIndexRoute
}

const AppCreditNotesRouteRouteChildren: AppCreditNotesRouteRouteChildren = {
  AppCreditNotesCreditNoteIdRouteRoute:
    AppCreditNotesCreditNoteIdRouteRouteWithChildren,
  AppCreditNotesNewRoute: AppCreditNotesNewRoute,
  AppCreditNotesIndexRoute: AppCreditNotesIndexRoute,
}

const AppCreditNotesRouteRouteWithChildren =
  AppCreditNotesRouteRoute._addFileChildren(AppCreditNotesRouteRouteChildren)

interface AppCustomersCustomerIdRouteRouteChildren {
  AppCustomersCustomerIdEditRoute: typeof AppCustomersCustomerIdEditRoute
  AppCustomersCustomerIdIndexRoute: typeof AppCustomersCustomerIdIndexRoute
}

const AppCustomersCustomerIdRouteRouteChildren: AppCustomersCustomerIdRouteRouteChildren =
  {
    AppCustomersCustomerIdEditRoute: AppCustomersCustomerIdEditRoute,
    AppCustomersCustomerIdIndexRoute: AppCustomersCustomerIdIndexRoute,
  }

const AppCustomersCustomerIdRouteRouteWithChildren =
  AppCustomersCustomerIdRouteRoute._addFileChildren(
    AppCustomersCustomerIdRouteRouteChildren,
  )

interface AppCustomersRouteRouteChildren {
  AppCustomersCustomerIdRouteRoute: typeof AppCustomersCustomerIdRouteRouteWithChildren
  AppCustomersNewRoute: typeof AppCustomersNewRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
}

const AppCustomersRouteRouteChildren: AppCustomersRouteRouteChildren = {
  AppCustomersCustomerIdRouteRoute:
    AppCustomersCustomerIdRouteRouteWithChildren,
  AppCustomersNewRoute: AppCustomersNewRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
}

const AppCustomersRouteRouteWithChildren =
  AppCustomersRouteRoute._addFileChildren(AppCustomersRouteRouteChildren)

interface AppExpensesExpenseIdRouteRouteChildren {
  AppExpensesExpenseIdEditRoute: typeof AppExpensesExpenseIdEditRoute
  AppExpensesExpenseIdIndexRoute: typeof AppExpensesExpenseIdIndexRoute
}

const AppExpensesExpenseIdRouteRouteChildren: AppExpensesExpenseIdRouteRouteChildren =
  {
    AppExpensesExpenseIdEditRoute: AppExpensesExpenseIdEditRoute,
    AppExpensesExpenseIdIndexRoute: AppExpensesExpenseIdIndexRoute,
  }

const AppExpensesExpenseIdRouteRouteWithChildren =
  AppExpensesExpenseIdRouteRoute._addFileChildren(
    AppExpensesExpenseIdRouteRouteChildren,
  )

interface AppExpensesRecurringRecurringIdRouteRouteChildren {
  AppExpensesRecurringRecurringIdEditRoute: typeof AppExpensesRecurringRecurringIdEditRoute
  AppExpensesRecurringRecurringIdIndexRoute: typeof AppExpensesRecurringRecurringIdIndexRoute
}

const AppExpensesRecurringRecurringIdRouteRouteChildren: AppExpensesRecurringRecurringIdRouteRouteChildren =
  {
    AppExpensesRecurringRecurringIdEditRoute:
      AppExpensesRecurringRecurringIdEditRoute,
    AppExpensesRecurringRecurringIdIndexRoute:
      AppExpensesRecurringRecurringIdIndexRoute,
  }

const AppExpensesRecurringRecurringIdRouteRouteWithChildren =
  AppExpensesRecurringRecurringIdRouteRoute._addFileChildren(
    AppExpensesRecurringRecurringIdRouteRouteChildren,
  )

interface AppExpensesRecurringRouteRouteChildren {
  AppExpensesRecurringRecurringIdRouteRoute: typeof AppExpensesRecurringRecurringIdRouteRouteWithChildren
  AppExpensesRecurringNewRoute: typeof AppExpensesRecurringNewRoute
  AppExpensesRecurringIndexRoute: typeof AppExpensesRecurringIndexRoute
}

const AppExpensesRecurringRouteRouteChildren: AppExpensesRecurringRouteRouteChildren =
  {
    AppExpensesRecurringRecurringIdRouteRoute:
      AppExpensesRecurringRecurringIdRouteRouteWithChildren,
    AppExpensesRecurringNewRoute: AppExpensesRecurringNewRoute,
    AppExpensesRecurringIndexRoute: AppExpensesRecurringIndexRoute,
  }

const AppExpensesRecurringRouteRouteWithChildren =
  AppExpensesRecurringRouteRoute._addFileChildren(
    AppExpensesRecurringRouteRouteChildren,
  )

interface AppExpensesRouteRouteChildren {
  AppExpensesExpenseIdRouteRoute: typeof AppExpensesExpenseIdRouteRouteWithChildren
  AppExpensesRecurringRouteRoute: typeof AppExpensesRecurringRouteRouteWithChildren
  AppExpensesNewRoute: typeof AppExpensesNewRoute
  AppExpensesIndexRoute: typeof AppExpensesIndexRoute
}

const AppExpensesRouteRouteChildren: AppExpensesRouteRouteChildren = {
  AppExpensesExpenseIdRouteRoute: AppExpensesExpenseIdRouteRouteWithChildren,
  AppExpensesRecurringRouteRoute: AppExpensesRecurringRouteRouteWithChildren,
  AppExpensesNewRoute: AppExpensesNewRoute,
  AppExpensesIndexRoute: AppExpensesIndexRoute,
}

const AppExpensesRouteRouteWithChildren =
  AppExpensesRouteRoute._addFileChildren(AppExpensesRouteRouteChildren)

interface AppHrEmployeesEmployeeIdRouteRouteChildren {
  AppHrEmployeesEmployeeIdEditRoute: typeof AppHrEmployeesEmployeeIdEditRoute
  AppHrEmployeesEmployeeIdIndexRoute: typeof AppHrEmployeesEmployeeIdIndexRoute
}

const AppHrEmployeesEmployeeIdRouteRouteChildren: AppHrEmployeesEmployeeIdRouteRouteChildren =
  {
    AppHrEmployeesEmployeeIdEditRoute: AppHrEmployeesEmployeeIdEditRoute,
    AppHrEmployeesEmployeeIdIndexRoute: AppHrEmployeesEmployeeIdIndexRoute,
  }

const AppHrEmployeesEmployeeIdRouteRouteWithChildren =
  AppHrEmployeesEmployeeIdRouteRoute._addFileChildren(
    AppHrEmployeesEmployeeIdRouteRouteChildren,
  )

interface AppHrEmployeesRouteRouteChildren {
  AppHrEmployeesEmployeeIdRouteRoute: typeof AppHrEmployeesEmployeeIdRouteRouteWithChildren
  AppHrEmployeesNewRoute: typeof AppHrEmployeesNewRoute
  AppHrEmployeesIndexRoute: typeof AppHrEmployeesIndexRoute
}

const AppHrEmployeesRouteRouteChildren: AppHrEmployeesRouteRouteChildren = {
  AppHrEmployeesEmployeeIdRouteRoute:
    AppHrEmployeesEmployeeIdRouteRouteWithChildren,
  AppHrEmployeesNewRoute: AppHrEmployeesNewRoute,
  AppHrEmployeesIndexRoute: AppHrEmployeesIndexRoute,
}

const AppHrEmployeesRouteRouteWithChildren =
  AppHrEmployeesRouteRoute._addFileChildren(AppHrEmployeesRouteRouteChildren)

interface AppHrRouteRouteChildren {
  AppHrEmployeesRouteRoute: typeof AppHrEmployeesRouteRouteWithChildren
  AppHrDocumentsRoute: typeof AppHrDocumentsRoute
  AppHrPayComponentsRoute: typeof AppHrPayComponentsRoute
  AppHrIndexRoute: typeof AppHrIndexRoute
}

const AppHrRouteRouteChildren: AppHrRouteRouteChildren = {
  AppHrEmployeesRouteRoute: AppHrEmployeesRouteRouteWithChildren,
  AppHrDocumentsRoute: AppHrDocumentsRoute,
  AppHrPayComponentsRoute: AppHrPayComponentsRoute,
  AppHrIndexRoute: AppHrIndexRoute,
}

const AppHrRouteRouteWithChildren = AppHrRouteRoute._addFileChildren(
  AppHrRouteRouteChildren,
)

interface AppInvoicesInvoiceIdRouteRouteChildren {
  AppInvoicesInvoiceIdEditRoute: typeof AppInvoicesInvoiceIdEditRoute
  AppInvoicesInvoiceIdPrintRoute: typeof AppInvoicesInvoiceIdPrintRoute
  AppInvoicesInvoiceIdIndexRoute: typeof AppInvoicesInvoiceIdIndexRoute
}

const AppInvoicesInvoiceIdRouteRouteChildren: AppInvoicesInvoiceIdRouteRouteChildren =
  {
    AppInvoicesInvoiceIdEditRoute: AppInvoicesInvoiceIdEditRoute,
    AppInvoicesInvoiceIdPrintRoute: AppInvoicesInvoiceIdPrintRoute,
    AppInvoicesInvoiceIdIndexRoute: AppInvoicesInvoiceIdIndexRoute,
  }

const AppInvoicesInvoiceIdRouteRouteWithChildren =
  AppInvoicesInvoiceIdRouteRoute._addFileChildren(
    AppInvoicesInvoiceIdRouteRouteChildren,
  )

interface AppInvoicesRouteRouteChildren {
  AppInvoicesInvoiceIdRouteRoute: typeof AppInvoicesInvoiceIdRouteRouteWithChildren
  AppInvoicesNewRoute: typeof AppInvoicesNewRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
}

const AppInvoicesRouteRouteChildren: AppInvoicesRouteRouteChildren = {
  AppInvoicesInvoiceIdRouteRoute: AppInvoicesInvoiceIdRouteRouteWithChildren,
  AppInvoicesNewRoute: AppInvoicesNewRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
}

const AppInvoicesRouteRouteWithChildren =
  AppInvoicesRouteRoute._addFileChildren(AppInvoicesRouteRouteChildren)

interface AppJournalEntriesRouteRouteChildren {
  AppJournalEntriesEntryIdRoute: typeof AppJournalEntriesEntryIdRoute
  AppJournalEntriesNewRoute: typeof AppJournalEntriesNewRoute
  AppJournalEntriesIndexRoute: typeof AppJournalEntriesIndexRoute
}

const AppJournalEntriesRouteRouteChildren: AppJournalEntriesRouteRouteChildren =
  {
    AppJournalEntriesEntryIdRoute: AppJournalEntriesEntryIdRoute,
    AppJournalEntriesNewRoute: AppJournalEntriesNewRoute,
    AppJournalEntriesIndexRoute: AppJournalEntriesIndexRoute,
  }

const AppJournalEntriesRouteRouteWithChildren =
  AppJournalEntriesRouteRoute._addFileChildren(
    AppJournalEntriesRouteRouteChildren,
  )

interface AppLoyaltyMembersRouteRouteChildren {
  AppLoyaltyMembersMemberIdRoute: typeof AppLoyaltyMembersMemberIdRoute
  AppLoyaltyMembersIndexRoute: typeof AppLoyaltyMembersIndexRoute
}

const AppLoyaltyMembersRouteRouteChildren: AppLoyaltyMembersRouteRouteChildren =
  {
    AppLoyaltyMembersMemberIdRoute: AppLoyaltyMembersMemberIdRoute,
    AppLoyaltyMembersIndexRoute: AppLoyaltyMembersIndexRoute,
  }

const AppLoyaltyMembersRouteRouteWithChildren =
  AppLoyaltyMembersRouteRoute._addFileChildren(
    AppLoyaltyMembersRouteRouteChildren,
  )

interface AppLoyaltyRouteRouteChildren {
  AppLoyaltyMembersRouteRoute: typeof AppLoyaltyMembersRouteRouteWithChildren
  AppLoyaltyProgramRoute: typeof AppLoyaltyProgramRoute
  AppLoyaltyTransactionsRoute: typeof AppLoyaltyTransactionsRoute
  AppLoyaltyIndexRoute: typeof AppLoyaltyIndexRoute
}

const AppLoyaltyRouteRouteChildren: AppLoyaltyRouteRouteChildren = {
  AppLoyaltyMembersRouteRoute: AppLoyaltyMembersRouteRouteWithChildren,
  AppLoyaltyProgramRoute: AppLoyaltyProgramRoute,
  AppLoyaltyTransactionsRoute: AppLoyaltyTransactionsRoute,
  AppLoyaltyIndexRoute: AppLoyaltyIndexRoute,
}

const AppLoyaltyRouteRouteWithChildren = AppLoyaltyRouteRoute._addFileChildren(
  AppLoyaltyRouteRouteChildren,
)

interface AppPayrollRunsRunIdRouteRouteChildren {
  AppPayrollRunsRunIdIndexRoute: typeof AppPayrollRunsRunIdIndexRoute
  AppPayrollRunsRunIdPayslipsPayslipIdRoute: typeof AppPayrollRunsRunIdPayslipsPayslipIdRoute
}

const AppPayrollRunsRunIdRouteRouteChildren: AppPayrollRunsRunIdRouteRouteChildren =
  {
    AppPayrollRunsRunIdIndexRoute: AppPayrollRunsRunIdIndexRoute,
    AppPayrollRunsRunIdPayslipsPayslipIdRoute:
      AppPayrollRunsRunIdPayslipsPayslipIdRoute,
  }

const AppPayrollRunsRunIdRouteRouteWithChildren =
  AppPayrollRunsRunIdRouteRoute._addFileChildren(
    AppPayrollRunsRunIdRouteRouteChildren,
  )

interface AppPayrollRunsRouteRouteChildren {
  AppPayrollRunsRunIdRouteRoute: typeof AppPayrollRunsRunIdRouteRouteWithChildren
  AppPayrollRunsIndexRoute: typeof AppPayrollRunsIndexRoute
}

const AppPayrollRunsRouteRouteChildren: AppPayrollRunsRouteRouteChildren = {
  AppPayrollRunsRunIdRouteRoute: AppPayrollRunsRunIdRouteRouteWithChildren,
  AppPayrollRunsIndexRoute: AppPayrollRunsIndexRoute,
}

const AppPayrollRunsRouteRouteWithChildren =
  AppPayrollRunsRouteRoute._addFileChildren(AppPayrollRunsRouteRouteChildren)

interface AppPayrollRouteRouteChildren {
  AppPayrollRunsRouteRoute: typeof AppPayrollRunsRouteRouteWithChildren
  AppPayrollContributionsRoute: typeof AppPayrollContributionsRoute
  AppPayrollSettingsRoute: typeof AppPayrollSettingsRoute
  AppPayrollIndexRoute: typeof AppPayrollIndexRoute
}

const AppPayrollRouteRouteChildren: AppPayrollRouteRouteChildren = {
  AppPayrollRunsRouteRoute: AppPayrollRunsRouteRouteWithChildren,
  AppPayrollContributionsRoute: AppPayrollContributionsRoute,
  AppPayrollSettingsRoute: AppPayrollSettingsRoute,
  AppPayrollIndexRoute: AppPayrollIndexRoute,
}

const AppPayrollRouteRouteWithChildren = AppPayrollRouteRoute._addFileChildren(
  AppPayrollRouteRouteChildren,
)

interface AppPrivacyRequestsRouteRouteChildren {
  AppPrivacyRequestsRequestIdRoute: typeof AppPrivacyRequestsRequestIdRoute
  AppPrivacyRequestsIndexRoute: typeof AppPrivacyRequestsIndexRoute
}

const AppPrivacyRequestsRouteRouteChildren: AppPrivacyRequestsRouteRouteChildren =
  {
    AppPrivacyRequestsRequestIdRoute: AppPrivacyRequestsRequestIdRoute,
    AppPrivacyRequestsIndexRoute: AppPrivacyRequestsIndexRoute,
  }

const AppPrivacyRequestsRouteRouteWithChildren =
  AppPrivacyRequestsRouteRoute._addFileChildren(
    AppPrivacyRequestsRouteRouteChildren,
  )

interface AppProductsProductIdRouteRouteChildren {
  AppProductsProductIdEditRoute: typeof AppProductsProductIdEditRoute
  AppProductsProductIdLabelsRoute: typeof AppProductsProductIdLabelsRoute
  AppProductsProductIdIndexRoute: typeof AppProductsProductIdIndexRoute
}

const AppProductsProductIdRouteRouteChildren: AppProductsProductIdRouteRouteChildren =
  {
    AppProductsProductIdEditRoute: AppProductsProductIdEditRoute,
    AppProductsProductIdLabelsRoute: AppProductsProductIdLabelsRoute,
    AppProductsProductIdIndexRoute: AppProductsProductIdIndexRoute,
  }

const AppProductsProductIdRouteRouteWithChildren =
  AppProductsProductIdRouteRoute._addFileChildren(
    AppProductsProductIdRouteRouteChildren,
  )

interface AppProductsRouteRouteChildren {
  AppProductsProductIdRouteRoute: typeof AppProductsProductIdRouteRouteWithChildren
  AppProductsNewRoute: typeof AppProductsNewRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
}

const AppProductsRouteRouteChildren: AppProductsRouteRouteChildren = {
  AppProductsProductIdRouteRoute: AppProductsProductIdRouteRouteWithChildren,
  AppProductsNewRoute: AppProductsNewRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
}

const AppProductsRouteRouteWithChildren =
  AppProductsRouteRoute._addFileChildren(AppProductsRouteRouteChildren)

interface AppProjectsProjectIdRouteRouteChildren {
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
  AppProjectsProjectIdContractStatementRoute: typeof AppProjectsProjectIdContractStatementRoute
  AppProjectsProjectIdReportsIndexRoute: typeof AppProjectsProjectIdReportsIndexRoute
  AppProjectsProjectIdClaimsClaimIdPrintRoute: typeof AppProjectsProjectIdClaimsClaimIdPrintRoute
  AppProjectsProjectIdReportsReportIdPrintRoute: typeof AppProjectsProjectIdReportsReportIdPrintRoute
  AppProjectsProjectIdClaimsClaimIdIndexRoute: typeof AppProjectsProjectIdClaimsClaimIdIndexRoute
  AppProjectsProjectIdReportsReportIdIndexRoute: typeof AppProjectsProjectIdReportsReportIdIndexRoute
}

const AppProjectsProjectIdRouteRouteChildren: AppProjectsProjectIdRouteRouteChildren =
  {
    AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
    AppProjectsProjectIdContractStatementRoute:
      AppProjectsProjectIdContractStatementRoute,
    AppProjectsProjectIdReportsIndexRoute:
      AppProjectsProjectIdReportsIndexRoute,
    AppProjectsProjectIdClaimsClaimIdPrintRoute:
      AppProjectsProjectIdClaimsClaimIdPrintRoute,
    AppProjectsProjectIdReportsReportIdPrintRoute:
      AppProjectsProjectIdReportsReportIdPrintRoute,
    AppProjectsProjectIdClaimsClaimIdIndexRoute:
      AppProjectsProjectIdClaimsClaimIdIndexRoute,
    AppProjectsProjectIdReportsReportIdIndexRoute:
      AppProjectsProjectIdReportsReportIdIndexRoute,
  }

const AppProjectsProjectIdRouteRouteWithChildren =
  AppProjectsProjectIdRouteRoute._addFileChildren(
    AppProjectsProjectIdRouteRouteChildren,
  )

interface AppProjectsCostEntriesRouteRouteChildren {
  AppProjectsCostEntriesEntryIdRoute: typeof AppProjectsCostEntriesEntryIdRoute
  AppProjectsCostEntriesIndexRoute: typeof AppProjectsCostEntriesIndexRoute
}

const AppProjectsCostEntriesRouteRouteChildren: AppProjectsCostEntriesRouteRouteChildren =
  {
    AppProjectsCostEntriesEntryIdRoute: AppProjectsCostEntriesEntryIdRoute,
    AppProjectsCostEntriesIndexRoute: AppProjectsCostEntriesIndexRoute,
  }

const AppProjectsCostEntriesRouteRouteWithChildren =
  AppProjectsCostEntriesRouteRoute._addFileChildren(
    AppProjectsCostEntriesRouteRouteChildren,
  )

interface AppProjectsMaterialIssuesRouteRouteChildren {
  AppProjectsMaterialIssuesIssueIdRoute: typeof AppProjectsMaterialIssuesIssueIdRoute
  AppProjectsMaterialIssuesIndexRoute: typeof AppProjectsMaterialIssuesIndexRoute
}

const AppProjectsMaterialIssuesRouteRouteChildren: AppProjectsMaterialIssuesRouteRouteChildren =
  {
    AppProjectsMaterialIssuesIssueIdRoute:
      AppProjectsMaterialIssuesIssueIdRoute,
    AppProjectsMaterialIssuesIndexRoute: AppProjectsMaterialIssuesIndexRoute,
  }

const AppProjectsMaterialIssuesRouteRouteWithChildren =
  AppProjectsMaterialIssuesRouteRoute._addFileChildren(
    AppProjectsMaterialIssuesRouteRouteChildren,
  )

interface AppProjectsRouteRouteChildren {
  AppProjectsProjectIdRouteRoute: typeof AppProjectsProjectIdRouteRouteWithChildren
  AppProjectsCostEntriesRouteRoute: typeof AppProjectsCostEntriesRouteRouteWithChildren
  AppProjectsMaterialIssuesRouteRoute: typeof AppProjectsMaterialIssuesRouteRouteWithChildren
  AppProjectsGuaranteesRoute: typeof AppProjectsGuaranteesRoute
  AppProjectsRatesRoute: typeof AppProjectsRatesRoute
  AppProjectsReconciliationRoute: typeof AppProjectsReconciliationRoute
  AppProjectsStatusReportsRoute: typeof AppProjectsStatusReportsRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppProjectsTimeApprovalsRoute: typeof AppProjectsTimeApprovalsRoute
  AppProjectsTimeIndexRoute: typeof AppProjectsTimeIndexRoute
}

const AppProjectsRouteRouteChildren: AppProjectsRouteRouteChildren = {
  AppProjectsProjectIdRouteRoute: AppProjectsProjectIdRouteRouteWithChildren,
  AppProjectsCostEntriesRouteRoute:
    AppProjectsCostEntriesRouteRouteWithChildren,
  AppProjectsMaterialIssuesRouteRoute:
    AppProjectsMaterialIssuesRouteRouteWithChildren,
  AppProjectsGuaranteesRoute: AppProjectsGuaranteesRoute,
  AppProjectsRatesRoute: AppProjectsRatesRoute,
  AppProjectsReconciliationRoute: AppProjectsReconciliationRoute,
  AppProjectsStatusReportsRoute: AppProjectsStatusReportsRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppProjectsTimeApprovalsRoute: AppProjectsTimeApprovalsRoute,
  AppProjectsTimeIndexRoute: AppProjectsTimeIndexRoute,
}

const AppProjectsRouteRouteWithChildren =
  AppProjectsRouteRoute._addFileChildren(AppProjectsRouteRouteChildren)

interface AppPurchasesPurchaseIdRouteRouteChildren {
  AppPurchasesPurchaseIdEditRoute: typeof AppPurchasesPurchaseIdEditRoute
  AppPurchasesPurchaseIdPrintRoute: typeof AppPurchasesPurchaseIdPrintRoute
  AppPurchasesPurchaseIdIndexRoute: typeof AppPurchasesPurchaseIdIndexRoute
}

const AppPurchasesPurchaseIdRouteRouteChildren: AppPurchasesPurchaseIdRouteRouteChildren =
  {
    AppPurchasesPurchaseIdEditRoute: AppPurchasesPurchaseIdEditRoute,
    AppPurchasesPurchaseIdPrintRoute: AppPurchasesPurchaseIdPrintRoute,
    AppPurchasesPurchaseIdIndexRoute: AppPurchasesPurchaseIdIndexRoute,
  }

const AppPurchasesPurchaseIdRouteRouteWithChildren =
  AppPurchasesPurchaseIdRouteRoute._addFileChildren(
    AppPurchasesPurchaseIdRouteRouteChildren,
  )

interface AppPurchasesRouteRouteChildren {
  AppPurchasesPurchaseIdRouteRoute: typeof AppPurchasesPurchaseIdRouteRouteWithChildren
  AppPurchasesNewRoute: typeof AppPurchasesNewRoute
  AppPurchasesIndexRoute: typeof AppPurchasesIndexRoute
}

const AppPurchasesRouteRouteChildren: AppPurchasesRouteRouteChildren = {
  AppPurchasesPurchaseIdRouteRoute:
    AppPurchasesPurchaseIdRouteRouteWithChildren,
  AppPurchasesNewRoute: AppPurchasesNewRoute,
  AppPurchasesIndexRoute: AppPurchasesIndexRoute,
}

const AppPurchasesRouteRouteWithChildren =
  AppPurchasesRouteRoute._addFileChildren(AppPurchasesRouteRouteChildren)

interface AppQuotationsQuotationIdRouteRouteChildren {
  AppQuotationsQuotationIdEditRoute: typeof AppQuotationsQuotationIdEditRoute
  AppQuotationsQuotationIdPrintRoute: typeof AppQuotationsQuotationIdPrintRoute
  AppQuotationsQuotationIdIndexRoute: typeof AppQuotationsQuotationIdIndexRoute
}

const AppQuotationsQuotationIdRouteRouteChildren: AppQuotationsQuotationIdRouteRouteChildren =
  {
    AppQuotationsQuotationIdEditRoute: AppQuotationsQuotationIdEditRoute,
    AppQuotationsQuotationIdPrintRoute: AppQuotationsQuotationIdPrintRoute,
    AppQuotationsQuotationIdIndexRoute: AppQuotationsQuotationIdIndexRoute,
  }

const AppQuotationsQuotationIdRouteRouteWithChildren =
  AppQuotationsQuotationIdRouteRoute._addFileChildren(
    AppQuotationsQuotationIdRouteRouteChildren,
  )

interface AppQuotationsRouteRouteChildren {
  AppQuotationsQuotationIdRouteRoute: typeof AppQuotationsQuotationIdRouteRouteWithChildren
  AppQuotationsNewRoute: typeof AppQuotationsNewRoute
  AppQuotationsIndexRoute: typeof AppQuotationsIndexRoute
}

const AppQuotationsRouteRouteChildren: AppQuotationsRouteRouteChildren = {
  AppQuotationsQuotationIdRouteRoute:
    AppQuotationsQuotationIdRouteRouteWithChildren,
  AppQuotationsNewRoute: AppQuotationsNewRoute,
  AppQuotationsIndexRoute: AppQuotationsIndexRoute,
}

const AppQuotationsRouteRouteWithChildren =
  AppQuotationsRouteRoute._addFileChildren(AppQuotationsRouteRouteChildren)

interface AppReceiptsReceiptIdRouteRouteChildren {
  AppReceiptsReceiptIdPrintRoute: typeof AppReceiptsReceiptIdPrintRoute
  AppReceiptsReceiptIdIndexRoute: typeof AppReceiptsReceiptIdIndexRoute
}

const AppReceiptsReceiptIdRouteRouteChildren: AppReceiptsReceiptIdRouteRouteChildren =
  {
    AppReceiptsReceiptIdPrintRoute: AppReceiptsReceiptIdPrintRoute,
    AppReceiptsReceiptIdIndexRoute: AppReceiptsReceiptIdIndexRoute,
  }

const AppReceiptsReceiptIdRouteRouteWithChildren =
  AppReceiptsReceiptIdRouteRoute._addFileChildren(
    AppReceiptsReceiptIdRouteRouteChildren,
  )

interface AppReceiptsRouteRouteChildren {
  AppReceiptsReceiptIdRouteRoute: typeof AppReceiptsReceiptIdRouteRouteWithChildren
  AppReceiptsNewRoute: typeof AppReceiptsNewRoute
  AppReceiptsIndexRoute: typeof AppReceiptsIndexRoute
}

const AppReceiptsRouteRouteChildren: AppReceiptsRouteRouteChildren = {
  AppReceiptsReceiptIdRouteRoute: AppReceiptsReceiptIdRouteRouteWithChildren,
  AppReceiptsNewRoute: AppReceiptsNewRoute,
  AppReceiptsIndexRoute: AppReceiptsIndexRoute,
}

const AppReceiptsRouteRouteWithChildren =
  AppReceiptsRouteRoute._addFileChildren(AppReceiptsRouteRouteChildren)

interface AppRefundsRefundIdRouteRouteChildren {
  AppRefundsRefundIdPrintRoute: typeof AppRefundsRefundIdPrintRoute
  AppRefundsRefundIdIndexRoute: typeof AppRefundsRefundIdIndexRoute
}

const AppRefundsRefundIdRouteRouteChildren: AppRefundsRefundIdRouteRouteChildren =
  {
    AppRefundsRefundIdPrintRoute: AppRefundsRefundIdPrintRoute,
    AppRefundsRefundIdIndexRoute: AppRefundsRefundIdIndexRoute,
  }

const AppRefundsRefundIdRouteRouteWithChildren =
  AppRefundsRefundIdRouteRoute._addFileChildren(
    AppRefundsRefundIdRouteRouteChildren,
  )

interface AppRefundsRouteRouteChildren {
  AppRefundsRefundIdRouteRoute: typeof AppRefundsRefundIdRouteRouteWithChildren
  AppRefundsNewRoute: typeof AppRefundsNewRoute
  AppRefundsIndexRoute: typeof AppRefundsIndexRoute
}

const AppRefundsRouteRouteChildren: AppRefundsRouteRouteChildren = {
  AppRefundsRefundIdRouteRoute: AppRefundsRefundIdRouteRouteWithChildren,
  AppRefundsNewRoute: AppRefundsNewRoute,
  AppRefundsIndexRoute: AppRefundsIndexRoute,
}

const AppRefundsRouteRouteWithChildren = AppRefundsRouteRoute._addFileChildren(
  AppRefundsRouteRouteChildren,
)

interface AppRolesRouteRouteChildren {
  AppRolesRoleIdRoute: typeof AppRolesRoleIdRoute
  AppRolesNewRoute: typeof AppRolesNewRoute
  AppRolesIndexRoute: typeof AppRolesIndexRoute
}

const AppRolesRouteRouteChildren: AppRolesRouteRouteChildren = {
  AppRolesRoleIdRoute: AppRolesRoleIdRoute,
  AppRolesNewRoute: AppRolesNewRoute,
  AppRolesIndexRoute: AppRolesIndexRoute,
}

const AppRolesRouteRouteWithChildren = AppRolesRouteRoute._addFileChildren(
  AppRolesRouteRouteChildren,
)

interface AppSerialsRouteRouteChildren {
  AppSerialsSerialIdRoute: typeof AppSerialsSerialIdRoute
  AppSerialsIndexRoute: typeof AppSerialsIndexRoute
}

const AppSerialsRouteRouteChildren: AppSerialsRouteRouteChildren = {
  AppSerialsSerialIdRoute: AppSerialsSerialIdRoute,
  AppSerialsIndexRoute: AppSerialsIndexRoute,
}

const AppSerialsRouteRouteWithChildren = AppSerialsRouteRoute._addFileChildren(
  AppSerialsRouteRouteChildren,
)

interface AppServiceAssetsRouteRouteChildren {
  AppServiceAssetsAssetIdRoute: typeof AppServiceAssetsAssetIdRoute
  AppServiceAssetsLabelsRoute: typeof AppServiceAssetsLabelsRoute
  AppServiceAssetsIndexRoute: typeof AppServiceAssetsIndexRoute
}

const AppServiceAssetsRouteRouteChildren: AppServiceAssetsRouteRouteChildren = {
  AppServiceAssetsAssetIdRoute: AppServiceAssetsAssetIdRoute,
  AppServiceAssetsLabelsRoute: AppServiceAssetsLabelsRoute,
  AppServiceAssetsIndexRoute: AppServiceAssetsIndexRoute,
}

const AppServiceAssetsRouteRouteWithChildren =
  AppServiceAssetsRouteRoute._addFileChildren(
    AppServiceAssetsRouteRouteChildren,
  )

interface AppServiceContractsContractIdRouteRouteChildren {
  AppServiceContractsContractIdEditRoute: typeof AppServiceContractsContractIdEditRoute
  AppServiceContractsContractIdPrintRoute: typeof AppServiceContractsContractIdPrintRoute
  AppServiceContractsContractIdIndexRoute: typeof AppServiceContractsContractIdIndexRoute
}

const AppServiceContractsContractIdRouteRouteChildren: AppServiceContractsContractIdRouteRouteChildren =
  {
    AppServiceContractsContractIdEditRoute:
      AppServiceContractsContractIdEditRoute,
    AppServiceContractsContractIdPrintRoute:
      AppServiceContractsContractIdPrintRoute,
    AppServiceContractsContractIdIndexRoute:
      AppServiceContractsContractIdIndexRoute,
  }

const AppServiceContractsContractIdRouteRouteWithChildren =
  AppServiceContractsContractIdRouteRoute._addFileChildren(
    AppServiceContractsContractIdRouteRouteChildren,
  )

interface AppServiceContractsRouteRouteChildren {
  AppServiceContractsContractIdRouteRoute: typeof AppServiceContractsContractIdRouteRouteWithChildren
  AppServiceContractsBillingRoute: typeof AppServiceContractsBillingRoute
  AppServiceContractsInsightsRoute: typeof AppServiceContractsInsightsRoute
  AppServiceContractsNewRoute: typeof AppServiceContractsNewRoute
  AppServiceContractsIndexRoute: typeof AppServiceContractsIndexRoute
}

const AppServiceContractsRouteRouteChildren: AppServiceContractsRouteRouteChildren =
  {
    AppServiceContractsContractIdRouteRoute:
      AppServiceContractsContractIdRouteRouteWithChildren,
    AppServiceContractsBillingRoute: AppServiceContractsBillingRoute,
    AppServiceContractsInsightsRoute: AppServiceContractsInsightsRoute,
    AppServiceContractsNewRoute: AppServiceContractsNewRoute,
    AppServiceContractsIndexRoute: AppServiceContractsIndexRoute,
  }

const AppServiceContractsRouteRouteWithChildren =
  AppServiceContractsRouteRoute._addFileChildren(
    AppServiceContractsRouteRouteChildren,
  )

interface AppServiceJobsJobIdRouteRouteChildren {
  AppServiceJobsJobIdEstimateRoute: typeof AppServiceJobsJobIdEstimateRoute
  AppServiceJobsJobIdIndexRoute: typeof AppServiceJobsJobIdIndexRoute
}

const AppServiceJobsJobIdRouteRouteChildren: AppServiceJobsJobIdRouteRouteChildren =
  {
    AppServiceJobsJobIdEstimateRoute: AppServiceJobsJobIdEstimateRoute,
    AppServiceJobsJobIdIndexRoute: AppServiceJobsJobIdIndexRoute,
  }

const AppServiceJobsJobIdRouteRouteWithChildren =
  AppServiceJobsJobIdRouteRoute._addFileChildren(
    AppServiceJobsJobIdRouteRouteChildren,
  )

interface AppServiceJobsRouteRouteChildren {
  AppServiceJobsJobIdRouteRoute: typeof AppServiceJobsJobIdRouteRouteWithChildren
  AppServiceJobsIndexRoute: typeof AppServiceJobsIndexRoute
}

const AppServiceJobsRouteRouteChildren: AppServiceJobsRouteRouteChildren = {
  AppServiceJobsJobIdRouteRoute: AppServiceJobsJobIdRouteRouteWithChildren,
  AppServiceJobsIndexRoute: AppServiceJobsIndexRoute,
}

const AppServiceJobsRouteRouteWithChildren =
  AppServiceJobsRouteRoute._addFileChildren(AppServiceJobsRouteRouteChildren)

interface AppServiceSitesRouteRouteChildren {
  AppServiceSitesSiteIdRoute: typeof AppServiceSitesSiteIdRoute
  AppServiceSitesIndexRoute: typeof AppServiceSitesIndexRoute
}

const AppServiceSitesRouteRouteChildren: AppServiceSitesRouteRouteChildren = {
  AppServiceSitesSiteIdRoute: AppServiceSitesSiteIdRoute,
  AppServiceSitesIndexRoute: AppServiceSitesIndexRoute,
}

const AppServiceSitesRouteRouteWithChildren =
  AppServiceSitesRouteRoute._addFileChildren(AppServiceSitesRouteRouteChildren)

interface AppServiceVisitsVisitIdRouteRouteChildren {
  AppServiceVisitsVisitIdReportRoute: typeof AppServiceVisitsVisitIdReportRoute
  AppServiceVisitsVisitIdIndexRoute: typeof AppServiceVisitsVisitIdIndexRoute
}

const AppServiceVisitsVisitIdRouteRouteChildren: AppServiceVisitsVisitIdRouteRouteChildren =
  {
    AppServiceVisitsVisitIdReportRoute: AppServiceVisitsVisitIdReportRoute,
    AppServiceVisitsVisitIdIndexRoute: AppServiceVisitsVisitIdIndexRoute,
  }

const AppServiceVisitsVisitIdRouteRouteWithChildren =
  AppServiceVisitsVisitIdRouteRoute._addFileChildren(
    AppServiceVisitsVisitIdRouteRouteChildren,
  )

interface AppServiceVisitsRouteRouteChildren {
  AppServiceVisitsVisitIdRouteRoute: typeof AppServiceVisitsVisitIdRouteRouteWithChildren
  AppServiceVisitsIndexRoute: typeof AppServiceVisitsIndexRoute
}

const AppServiceVisitsRouteRouteChildren: AppServiceVisitsRouteRouteChildren = {
  AppServiceVisitsVisitIdRouteRoute:
    AppServiceVisitsVisitIdRouteRouteWithChildren,
  AppServiceVisitsIndexRoute: AppServiceVisitsIndexRoute,
}

const AppServiceVisitsRouteRouteWithChildren =
  AppServiceVisitsRouteRoute._addFileChildren(
    AppServiceVisitsRouteRouteChildren,
  )

interface AppServiceRouteRouteChildren {
  AppServiceAssetsRouteRoute: typeof AppServiceAssetsRouteRouteWithChildren
  AppServiceContractsRouteRoute: typeof AppServiceContractsRouteRouteWithChildren
  AppServiceJobsRouteRoute: typeof AppServiceJobsRouteRouteWithChildren
  AppServiceSitesRouteRoute: typeof AppServiceSitesRouteRouteWithChildren
  AppServiceVisitsRouteRoute: typeof AppServiceVisitsRouteRouteWithChildren
  AppServiceCollectionsRoute: typeof AppServiceCollectionsRoute
  AppServiceFollowUpsRoute: typeof AppServiceFollowUpsRoute
  AppServiceMyVisitsRoute: typeof AppServiceMyVisitsRoute
  AppServiceScheduleRoute: typeof AppServiceScheduleRoute
  AppServiceIndexRoute: typeof AppServiceIndexRoute
}

const AppServiceRouteRouteChildren: AppServiceRouteRouteChildren = {
  AppServiceAssetsRouteRoute: AppServiceAssetsRouteRouteWithChildren,
  AppServiceContractsRouteRoute: AppServiceContractsRouteRouteWithChildren,
  AppServiceJobsRouteRoute: AppServiceJobsRouteRouteWithChildren,
  AppServiceSitesRouteRoute: AppServiceSitesRouteRouteWithChildren,
  AppServiceVisitsRouteRoute: AppServiceVisitsRouteRouteWithChildren,
  AppServiceCollectionsRoute: AppServiceCollectionsRoute,
  AppServiceFollowUpsRoute: AppServiceFollowUpsRoute,
  AppServiceMyVisitsRoute: AppServiceMyVisitsRoute,
  AppServiceScheduleRoute: AppServiceScheduleRoute,
  AppServiceIndexRoute: AppServiceIndexRoute,
}

const AppServiceRouteRouteWithChildren = AppServiceRouteRoute._addFileChildren(
  AppServiceRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsAccountMappingRoute: typeof AppSettingsAccountMappingRoute
  AppSettingsAccountingChecksRoute: typeof AppSettingsAccountingChecksRoute
  AppSettingsAppearanceRoute: typeof AppSettingsAppearanceRoute
  AppSettingsCalendarRoute: typeof AppSettingsCalendarRoute
  AppSettingsCommissionsRoute: typeof AppSettingsCommissionsRoute
  AppSettingsCompanyRoute: typeof AppSettingsCompanyRoute
  AppSettingsContractsRoute: typeof AppSettingsContractsRoute
  AppSettingsDefaultsRoute: typeof AppSettingsDefaultsRoute
  AppSettingsLegalHoldsRoute: typeof AppSettingsLegalHoldsRoute
  AppSettingsLockDateRoute: typeof AppSettingsLockDateRoute
  AppSettingsMessageOutboxRoute: typeof AppSettingsMessageOutboxRoute
  AppSettingsMessageTemplatesRoute: typeof AppSettingsMessageTemplatesRoute
  AppSettingsModulesRoute: typeof AppSettingsModulesRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsNumberingRoute: typeof AppSettingsNumberingRoute
  AppSettingsOrganizationRoute: typeof AppSettingsOrganizationRoute
  AppSettingsPaymentMethodsRoute: typeof AppSettingsPaymentMethodsRoute
  AppSettingsPrintingRoute: typeof AppSettingsPrintingRoute
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute
  AppSettingsProjectContractingRoute: typeof AppSettingsProjectContractingRoute
  AppSettingsProjectCostCategoriesRoute: typeof AppSettingsProjectCostCategoriesRoute
  AppSettingsProjectInsightsRoute: typeof AppSettingsProjectInsightsRoute
  AppSettingsProjectRateRolesRoute: typeof AppSettingsProjectRateRolesRoute
  AppSettingsProjectTypesRoute: typeof AppSettingsProjectTypesRoute
  AppSettingsProjectsRoute: typeof AppSettingsProjectsRoute
  AppSettingsRegionalRoute: typeof AppSettingsRegionalRoute
  AppSettingsServiceRoute: typeof AppSettingsServiceRoute
  AppSettingsServiceAssetTypesRoute: typeof AppSettingsServiceAssetTypesRoute
  AppSettingsServiceSiteTemplatesRoute: typeof AppSettingsServiceSiteTemplatesRoute
  AppSettingsStockPolicyRoute: typeof AppSettingsStockPolicyRoute
  AppSettingsSystemRoute: typeof AppSettingsSystemRoute
  AppSettingsTasksRoute: typeof AppSettingsTasksRoute
  AppSettingsTaxRatesRoute: typeof AppSettingsTaxRatesRoute
  AppSettingsTeamsRoute: typeof AppSettingsTeamsRoute
  AppSettingsTypographyRoute: typeof AppSettingsTypographyRoute
  AppSettingsWorkLocationsRoute: typeof AppSettingsWorkLocationsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsAiUsageRoute: typeof AppSettingsAiUsageRoute
  AppSettingsAiIndexRoute: typeof AppSettingsAiIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAccountMappingRoute: AppSettingsAccountMappingRoute,
  AppSettingsAccountingChecksRoute: AppSettingsAccountingChecksRoute,
  AppSettingsAppearanceRoute: AppSettingsAppearanceRoute,
  AppSettingsCalendarRoute: AppSettingsCalendarRoute,
  AppSettingsCommissionsRoute: AppSettingsCommissionsRoute,
  AppSettingsCompanyRoute: AppSettingsCompanyRoute,
  AppSettingsContractsRoute: AppSettingsContractsRoute,
  AppSettingsDefaultsRoute: AppSettingsDefaultsRoute,
  AppSettingsLegalHoldsRoute: AppSettingsLegalHoldsRoute,
  AppSettingsLockDateRoute: AppSettingsLockDateRoute,
  AppSettingsMessageOutboxRoute: AppSettingsMessageOutboxRoute,
  AppSettingsMessageTemplatesRoute: AppSettingsMessageTemplatesRoute,
  AppSettingsModulesRoute: AppSettingsModulesRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsNumberingRoute: AppSettingsNumberingRoute,
  AppSettingsOrganizationRoute: AppSettingsOrganizationRoute,
  AppSettingsPaymentMethodsRoute: AppSettingsPaymentMethodsRoute,
  AppSettingsPrintingRoute: AppSettingsPrintingRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsProjectContractingRoute: AppSettingsProjectContractingRoute,
  AppSettingsProjectCostCategoriesRoute: AppSettingsProjectCostCategoriesRoute,
  AppSettingsProjectInsightsRoute: AppSettingsProjectInsightsRoute,
  AppSettingsProjectRateRolesRoute: AppSettingsProjectRateRolesRoute,
  AppSettingsProjectTypesRoute: AppSettingsProjectTypesRoute,
  AppSettingsProjectsRoute: AppSettingsProjectsRoute,
  AppSettingsRegionalRoute: AppSettingsRegionalRoute,
  AppSettingsServiceRoute: AppSettingsServiceRoute,
  AppSettingsServiceAssetTypesRoute: AppSettingsServiceAssetTypesRoute,
  AppSettingsServiceSiteTemplatesRoute: AppSettingsServiceSiteTemplatesRoute,
  AppSettingsStockPolicyRoute: AppSettingsStockPolicyRoute,
  AppSettingsSystemRoute: AppSettingsSystemRoute,
  AppSettingsTasksRoute: AppSettingsTasksRoute,
  AppSettingsTaxRatesRoute: AppSettingsTaxRatesRoute,
  AppSettingsTeamsRoute: AppSettingsTeamsRoute,
  AppSettingsTypographyRoute: AppSettingsTypographyRoute,
  AppSettingsWorkLocationsRoute: AppSettingsWorkLocationsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsAiUsageRoute: AppSettingsAiUsageRoute,
  AppSettingsAiIndexRoute: AppSettingsAiIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppStockAdjustmentsRouteRouteChildren {
  AppStockAdjustmentsAdjustmentIdRoute: typeof AppStockAdjustmentsAdjustmentIdRoute
  AppStockAdjustmentsNewRoute: typeof AppStockAdjustmentsNewRoute
  AppStockAdjustmentsIndexRoute: typeof AppStockAdjustmentsIndexRoute
}

const AppStockAdjustmentsRouteRouteChildren: AppStockAdjustmentsRouteRouteChildren =
  {
    AppStockAdjustmentsAdjustmentIdRoute: AppStockAdjustmentsAdjustmentIdRoute,
    AppStockAdjustmentsNewRoute: AppStockAdjustmentsNewRoute,
    AppStockAdjustmentsIndexRoute: AppStockAdjustmentsIndexRoute,
  }

const AppStockAdjustmentsRouteRouteWithChildren =
  AppStockAdjustmentsRouteRoute._addFileChildren(
    AppStockAdjustmentsRouteRouteChildren,
  )

interface AppStockTransfersTransferIdRouteRouteChildren {
  AppStockTransfersTransferIdEditRoute: typeof AppStockTransfersTransferIdEditRoute
  AppStockTransfersTransferIdPrintRoute: typeof AppStockTransfersTransferIdPrintRoute
  AppStockTransfersTransferIdIndexRoute: typeof AppStockTransfersTransferIdIndexRoute
}

const AppStockTransfersTransferIdRouteRouteChildren: AppStockTransfersTransferIdRouteRouteChildren =
  {
    AppStockTransfersTransferIdEditRoute: AppStockTransfersTransferIdEditRoute,
    AppStockTransfersTransferIdPrintRoute:
      AppStockTransfersTransferIdPrintRoute,
    AppStockTransfersTransferIdIndexRoute:
      AppStockTransfersTransferIdIndexRoute,
  }

const AppStockTransfersTransferIdRouteRouteWithChildren =
  AppStockTransfersTransferIdRouteRoute._addFileChildren(
    AppStockTransfersTransferIdRouteRouteChildren,
  )

interface AppStockTransfersRouteRouteChildren {
  AppStockTransfersTransferIdRouteRoute: typeof AppStockTransfersTransferIdRouteRouteWithChildren
  AppStockTransfersNewRoute: typeof AppStockTransfersNewRoute
  AppStockTransfersIndexRoute: typeof AppStockTransfersIndexRoute
}

const AppStockTransfersRouteRouteChildren: AppStockTransfersRouteRouteChildren =
  {
    AppStockTransfersTransferIdRouteRoute:
      AppStockTransfersTransferIdRouteRouteWithChildren,
    AppStockTransfersNewRoute: AppStockTransfersNewRoute,
    AppStockTransfersIndexRoute: AppStockTransfersIndexRoute,
  }

const AppStockTransfersRouteRouteWithChildren =
  AppStockTransfersRouteRoute._addFileChildren(
    AppStockTransfersRouteRouteChildren,
  )

interface AppSupplierPaymentsPaymentIdRouteRouteChildren {
  AppSupplierPaymentsPaymentIdPrintRoute: typeof AppSupplierPaymentsPaymentIdPrintRoute
  AppSupplierPaymentsPaymentIdIndexRoute: typeof AppSupplierPaymentsPaymentIdIndexRoute
}

const AppSupplierPaymentsPaymentIdRouteRouteChildren: AppSupplierPaymentsPaymentIdRouteRouteChildren =
  {
    AppSupplierPaymentsPaymentIdPrintRoute:
      AppSupplierPaymentsPaymentIdPrintRoute,
    AppSupplierPaymentsPaymentIdIndexRoute:
      AppSupplierPaymentsPaymentIdIndexRoute,
  }

const AppSupplierPaymentsPaymentIdRouteRouteWithChildren =
  AppSupplierPaymentsPaymentIdRouteRoute._addFileChildren(
    AppSupplierPaymentsPaymentIdRouteRouteChildren,
  )

interface AppSupplierPaymentsRouteRouteChildren {
  AppSupplierPaymentsPaymentIdRouteRoute: typeof AppSupplierPaymentsPaymentIdRouteRouteWithChildren
  AppSupplierPaymentsNewRoute: typeof AppSupplierPaymentsNewRoute
  AppSupplierPaymentsIndexRoute: typeof AppSupplierPaymentsIndexRoute
}

const AppSupplierPaymentsRouteRouteChildren: AppSupplierPaymentsRouteRouteChildren =
  {
    AppSupplierPaymentsPaymentIdRouteRoute:
      AppSupplierPaymentsPaymentIdRouteRouteWithChildren,
    AppSupplierPaymentsNewRoute: AppSupplierPaymentsNewRoute,
    AppSupplierPaymentsIndexRoute: AppSupplierPaymentsIndexRoute,
  }

const AppSupplierPaymentsRouteRouteWithChildren =
  AppSupplierPaymentsRouteRoute._addFileChildren(
    AppSupplierPaymentsRouteRouteChildren,
  )

interface AppSupplierRefundsRefundIdRouteRouteChildren {
  AppSupplierRefundsRefundIdPrintRoute: typeof AppSupplierRefundsRefundIdPrintRoute
  AppSupplierRefundsRefundIdIndexRoute: typeof AppSupplierRefundsRefundIdIndexRoute
}

const AppSupplierRefundsRefundIdRouteRouteChildren: AppSupplierRefundsRefundIdRouteRouteChildren =
  {
    AppSupplierRefundsRefundIdPrintRoute: AppSupplierRefundsRefundIdPrintRoute,
    AppSupplierRefundsRefundIdIndexRoute: AppSupplierRefundsRefundIdIndexRoute,
  }

const AppSupplierRefundsRefundIdRouteRouteWithChildren =
  AppSupplierRefundsRefundIdRouteRoute._addFileChildren(
    AppSupplierRefundsRefundIdRouteRouteChildren,
  )

interface AppSupplierRefundsRouteRouteChildren {
  AppSupplierRefundsRefundIdRouteRoute: typeof AppSupplierRefundsRefundIdRouteRouteWithChildren
  AppSupplierRefundsNewRoute: typeof AppSupplierRefundsNewRoute
  AppSupplierRefundsIndexRoute: typeof AppSupplierRefundsIndexRoute
}

const AppSupplierRefundsRouteRouteChildren: AppSupplierRefundsRouteRouteChildren =
  {
    AppSupplierRefundsRefundIdRouteRoute:
      AppSupplierRefundsRefundIdRouteRouteWithChildren,
    AppSupplierRefundsNewRoute: AppSupplierRefundsNewRoute,
    AppSupplierRefundsIndexRoute: AppSupplierRefundsIndexRoute,
  }

const AppSupplierRefundsRouteRouteWithChildren =
  AppSupplierRefundsRouteRoute._addFileChildren(
    AppSupplierRefundsRouteRouteChildren,
  )

interface AppSupplierReturnsReturnIdRouteRouteChildren {
  AppSupplierReturnsReturnIdEditRoute: typeof AppSupplierReturnsReturnIdEditRoute
  AppSupplierReturnsReturnIdPrintRoute: typeof AppSupplierReturnsReturnIdPrintRoute
  AppSupplierReturnsReturnIdIndexRoute: typeof AppSupplierReturnsReturnIdIndexRoute
}

const AppSupplierReturnsReturnIdRouteRouteChildren: AppSupplierReturnsReturnIdRouteRouteChildren =
  {
    AppSupplierReturnsReturnIdEditRoute: AppSupplierReturnsReturnIdEditRoute,
    AppSupplierReturnsReturnIdPrintRoute: AppSupplierReturnsReturnIdPrintRoute,
    AppSupplierReturnsReturnIdIndexRoute: AppSupplierReturnsReturnIdIndexRoute,
  }

const AppSupplierReturnsReturnIdRouteRouteWithChildren =
  AppSupplierReturnsReturnIdRouteRoute._addFileChildren(
    AppSupplierReturnsReturnIdRouteRouteChildren,
  )

interface AppSupplierReturnsRouteRouteChildren {
  AppSupplierReturnsReturnIdRouteRoute: typeof AppSupplierReturnsReturnIdRouteRouteWithChildren
  AppSupplierReturnsNewRoute: typeof AppSupplierReturnsNewRoute
  AppSupplierReturnsIndexRoute: typeof AppSupplierReturnsIndexRoute
}

const AppSupplierReturnsRouteRouteChildren: AppSupplierReturnsRouteRouteChildren =
  {
    AppSupplierReturnsReturnIdRouteRoute:
      AppSupplierReturnsReturnIdRouteRouteWithChildren,
    AppSupplierReturnsNewRoute: AppSupplierReturnsNewRoute,
    AppSupplierReturnsIndexRoute: AppSupplierReturnsIndexRoute,
  }

const AppSupplierReturnsRouteRouteWithChildren =
  AppSupplierReturnsRouteRoute._addFileChildren(
    AppSupplierReturnsRouteRouteChildren,
  )

interface AppSuppliersSupplierIdRouteRouteChildren {
  AppSuppliersSupplierIdEditRoute: typeof AppSuppliersSupplierIdEditRoute
  AppSuppliersSupplierIdIndexRoute: typeof AppSuppliersSupplierIdIndexRoute
}

const AppSuppliersSupplierIdRouteRouteChildren: AppSuppliersSupplierIdRouteRouteChildren =
  {
    AppSuppliersSupplierIdEditRoute: AppSuppliersSupplierIdEditRoute,
    AppSuppliersSupplierIdIndexRoute: AppSuppliersSupplierIdIndexRoute,
  }

const AppSuppliersSupplierIdRouteRouteWithChildren =
  AppSuppliersSupplierIdRouteRoute._addFileChildren(
    AppSuppliersSupplierIdRouteRouteChildren,
  )

interface AppSuppliersRouteRouteChildren {
  AppSuppliersSupplierIdRouteRoute: typeof AppSuppliersSupplierIdRouteRouteWithChildren
  AppSuppliersNewRoute: typeof AppSuppliersNewRoute
  AppSuppliersIndexRoute: typeof AppSuppliersIndexRoute
}

const AppSuppliersRouteRouteChildren: AppSuppliersRouteRouteChildren = {
  AppSuppliersSupplierIdRouteRoute:
    AppSuppliersSupplierIdRouteRouteWithChildren,
  AppSuppliersNewRoute: AppSuppliersNewRoute,
  AppSuppliersIndexRoute: AppSuppliersIndexRoute,
}

const AppSuppliersRouteRouteWithChildren =
  AppSuppliersRouteRoute._addFileChildren(AppSuppliersRouteRouteChildren)

interface AppTasksRouteRouteChildren {
  AppTasksTaskIdRoute: typeof AppTasksTaskIdRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
}

const AppTasksRouteRouteChildren: AppTasksRouteRouteChildren = {
  AppTasksTaskIdRoute: AppTasksTaskIdRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
}

const AppTasksRouteRouteWithChildren = AppTasksRouteRoute._addFileChildren(
  AppTasksRouteRouteChildren,
)

interface AppTeamsRouteRouteChildren {
  AppTeamsTeamIdRoute: typeof AppTeamsTeamIdRoute
  AppTeamsIndexRoute: typeof AppTeamsIndexRoute
}

const AppTeamsRouteRouteChildren: AppTeamsRouteRouteChildren = {
  AppTeamsTeamIdRoute: AppTeamsTeamIdRoute,
  AppTeamsIndexRoute: AppTeamsIndexRoute,
}

const AppTeamsRouteRouteWithChildren = AppTeamsRouteRoute._addFileChildren(
  AppTeamsRouteRouteChildren,
)

interface AppUsersRouteRouteChildren {
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppUsersNewRoute: typeof AppUsersNewRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppUsersRouteRouteChildren: AppUsersRouteRouteChildren = {
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppUsersNewRoute: AppUsersNewRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppUsersRouteRouteWithChildren = AppUsersRouteRoute._addFileChildren(
  AppUsersRouteRouteChildren,
)

interface AppWorkflowsRunsRouteRouteChildren {
  AppWorkflowsRunsRunIdRoute: typeof AppWorkflowsRunsRunIdRoute
  AppWorkflowsRunsIndexRoute: typeof AppWorkflowsRunsIndexRoute
}

const AppWorkflowsRunsRouteRouteChildren: AppWorkflowsRunsRouteRouteChildren = {
  AppWorkflowsRunsRunIdRoute: AppWorkflowsRunsRunIdRoute,
  AppWorkflowsRunsIndexRoute: AppWorkflowsRunsIndexRoute,
}

const AppWorkflowsRunsRouteRouteWithChildren =
  AppWorkflowsRunsRouteRoute._addFileChildren(
    AppWorkflowsRunsRouteRouteChildren,
  )

interface AppWorkflowsRouteRouteChildren {
  AppWorkflowsRunsRouteRoute: typeof AppWorkflowsRunsRouteRouteWithChildren
  AppWorkflowsWorkflowIdRoute: typeof AppWorkflowsWorkflowIdRoute
  AppWorkflowsDelegationsRoute: typeof AppWorkflowsDelegationsRoute
  AppWorkflowsIndexRoute: typeof AppWorkflowsIndexRoute
}

const AppWorkflowsRouteRouteChildren: AppWorkflowsRouteRouteChildren = {
  AppWorkflowsRunsRouteRoute: AppWorkflowsRunsRouteRouteWithChildren,
  AppWorkflowsWorkflowIdRoute: AppWorkflowsWorkflowIdRoute,
  AppWorkflowsDelegationsRoute: AppWorkflowsDelegationsRoute,
  AppWorkflowsIndexRoute: AppWorkflowsIndexRoute,
}

const AppWorkflowsRouteRouteWithChildren =
  AppWorkflowsRouteRoute._addFileChildren(AppWorkflowsRouteRouteChildren)

interface AppPosShiftsRouteRouteChildren {
  AppPosShiftsShiftIdRoute: typeof AppPosShiftsShiftIdRoute
  AppPosShiftsIndexRoute: typeof AppPosShiftsIndexRoute
}

const AppPosShiftsRouteRouteChildren: AppPosShiftsRouteRouteChildren = {
  AppPosShiftsShiftIdRoute: AppPosShiftsShiftIdRoute,
  AppPosShiftsIndexRoute: AppPosShiftsIndexRoute,
}

const AppPosShiftsRouteRouteWithChildren =
  AppPosShiftsRouteRoute._addFileChildren(AppPosShiftsRouteRouteChildren)

interface AppRouteChildren {
  AppApprovalsRouteRoute: typeof AppApprovalsRouteRouteWithChildren
  AppBankStatementsRouteRoute: typeof AppBankStatementsRouteRouteWithChildren
  AppChequesRouteRoute: typeof AppChequesRouteRouteWithChildren
  AppCommissionsRouteRoute: typeof AppCommissionsRouteRouteWithChildren
  AppCreditNotesRouteRoute: typeof AppCreditNotesRouteRouteWithChildren
  AppCustomersRouteRoute: typeof AppCustomersRouteRouteWithChildren
  AppExpensesRouteRoute: typeof AppExpensesRouteRouteWithChildren
  AppHrRouteRoute: typeof AppHrRouteRouteWithChildren
  AppInvoicesRouteRoute: typeof AppInvoicesRouteRouteWithChildren
  AppJournalEntriesRouteRoute: typeof AppJournalEntriesRouteRouteWithChildren
  AppLoyaltyRouteRoute: typeof AppLoyaltyRouteRouteWithChildren
  AppPayrollRouteRoute: typeof AppPayrollRouteRouteWithChildren
  AppPrivacyRequestsRouteRoute: typeof AppPrivacyRequestsRouteRouteWithChildren
  AppProductsRouteRoute: typeof AppProductsRouteRouteWithChildren
  AppProjectsRouteRoute: typeof AppProjectsRouteRouteWithChildren
  AppPurchasesRouteRoute: typeof AppPurchasesRouteRouteWithChildren
  AppQuotationsRouteRoute: typeof AppQuotationsRouteRouteWithChildren
  AppReceiptsRouteRoute: typeof AppReceiptsRouteRouteWithChildren
  AppRefundsRouteRoute: typeof AppRefundsRouteRouteWithChildren
  AppRolesRouteRoute: typeof AppRolesRouteRouteWithChildren
  AppSerialsRouteRoute: typeof AppSerialsRouteRouteWithChildren
  AppServiceRouteRoute: typeof AppServiceRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppStockAdjustmentsRouteRoute: typeof AppStockAdjustmentsRouteRouteWithChildren
  AppStockTransfersRouteRoute: typeof AppStockTransfersRouteRouteWithChildren
  AppSupplierPaymentsRouteRoute: typeof AppSupplierPaymentsRouteRouteWithChildren
  AppSupplierRefundsRouteRoute: typeof AppSupplierRefundsRouteRouteWithChildren
  AppSupplierReturnsRouteRoute: typeof AppSupplierReturnsRouteRouteWithChildren
  AppSuppliersRouteRoute: typeof AppSuppliersRouteRouteWithChildren
  AppTasksRouteRoute: typeof AppTasksRouteRouteWithChildren
  AppTeamsRouteRoute: typeof AppTeamsRouteRouteWithChildren
  AppUsersRouteRoute: typeof AppUsersRouteRouteWithChildren
  AppWorkflowsRouteRoute: typeof AppWorkflowsRouteRouteWithChildren
  AppAccountMappingRoute: typeof AppAccountMappingRoute
  AppAccountsRoute: typeof AppAccountsRoute
  AppAuditLogRoute: typeof AppAuditLogRoute
  AppBalanceSheetRoute: typeof AppBalanceSheetRoute
  AppBooksHealthRoute: typeof AppBooksHealthRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppCashBankRoute: typeof AppCashBankRoute
  AppCashFlowRoute: typeof AppCashFlowRoute
  AppChangePasswordRoute: typeof AppChangePasswordRoute
  AppCustomerGroupsRoute: typeof AppCustomerGroupsRoute
  AppExpenseCategoriesRoute: typeof AppExpenseCategoriesRoute
  AppFiscalYearsRoute: typeof AppFiscalYearsRoute
  AppGeneralLedgerRoute: typeof AppGeneralLedgerRoute
  AppLowStockRoute: typeof AppLowStockRoute
  AppMyWorkRoute: typeof AppMyWorkRoute
  AppPayablesAgingRoute: typeof AppPayablesAgingRoute
  AppPosSummaryRoute: typeof AppPosSummaryRoute
  AppProductAttributesRoute: typeof AppProductAttributesRoute
  AppProductCategoriesRoute: typeof AppProductCategoriesRoute
  AppProfitAndLossRoute: typeof AppProfitAndLossRoute
  AppProjectBudgetVsActualRoute: typeof AppProjectBudgetVsActualRoute
  AppProjectProfitabilityRoute: typeof AppProjectProfitabilityRoute
  AppProjectUnbilledWorkRoute: typeof AppProjectUnbilledWorkRoute
  AppProjectUtilisationRoute: typeof AppProjectUtilisationRoute
  AppPurchasesByProductRoute: typeof AppPurchasesByProductRoute
  AppPurchasesBySupplierRoute: typeof AppPurchasesBySupplierRoute
  AppReceivablesAgingRoute: typeof AppReceivablesAgingRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSalesByCustomerRoute: typeof AppSalesByCustomerRoute
  AppSalesByPeriodRoute: typeof AppSalesByPeriodRoute
  AppSalesByProductRoute: typeof AppSalesByProductRoute
  AppSalesBySalespersonRoute: typeof AppSalesBySalespersonRoute
  AppSalesByUserRoute: typeof AppSalesByUserRoute
  AppStockRoute: typeof AppStockRoute
  AppStockMovementsRoute: typeof AppStockMovementsRoute
  AppStockValuationRoute: typeof AppStockValuationRoute
  AppSupplierGroupsRoute: typeof AppSupplierGroupsRoute
  AppTaskReportRoute: typeof AppTaskReportRoute
  AppTaxRatesRoute: typeof AppTaxRatesRoute
  AppTransfersRoute: typeof AppTransfersRoute
  AppTrialBalanceRoute: typeof AppTrialBalanceRoute
  AppUnitsRoute: typeof AppUnitsRoute
  AppVatReturnRoute: typeof AppVatReturnRoute
  AppWarehousesRoute: typeof AppWarehousesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPosShiftsRouteRoute: typeof AppPosShiftsRouteRouteWithChildren
  AppPosTillsRoute: typeof AppPosTillsRoute
  AppPosIndexRoute: typeof AppPosIndexRoute
  AppPosReturnsReturnIdRoute: typeof AppPosReturnsReturnIdRoute
  AppPosSalesSaleIdRoute: typeof AppPosSalesSaleIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppApprovalsRouteRoute: AppApprovalsRouteRouteWithChildren,
  AppBankStatementsRouteRoute: AppBankStatementsRouteRouteWithChildren,
  AppChequesRouteRoute: AppChequesRouteRouteWithChildren,
  AppCommissionsRouteRoute: AppCommissionsRouteRouteWithChildren,
  AppCreditNotesRouteRoute: AppCreditNotesRouteRouteWithChildren,
  AppCustomersRouteRoute: AppCustomersRouteRouteWithChildren,
  AppExpensesRouteRoute: AppExpensesRouteRouteWithChildren,
  AppHrRouteRoute: AppHrRouteRouteWithChildren,
  AppInvoicesRouteRoute: AppInvoicesRouteRouteWithChildren,
  AppJournalEntriesRouteRoute: AppJournalEntriesRouteRouteWithChildren,
  AppLoyaltyRouteRoute: AppLoyaltyRouteRouteWithChildren,
  AppPayrollRouteRoute: AppPayrollRouteRouteWithChildren,
  AppPrivacyRequestsRouteRoute: AppPrivacyRequestsRouteRouteWithChildren,
  AppProductsRouteRoute: AppProductsRouteRouteWithChildren,
  AppProjectsRouteRoute: AppProjectsRouteRouteWithChildren,
  AppPurchasesRouteRoute: AppPurchasesRouteRouteWithChildren,
  AppQuotationsRouteRoute: AppQuotationsRouteRouteWithChildren,
  AppReceiptsRouteRoute: AppReceiptsRouteRouteWithChildren,
  AppRefundsRouteRoute: AppRefundsRouteRouteWithChildren,
  AppRolesRouteRoute: AppRolesRouteRouteWithChildren,
  AppSerialsRouteRoute: AppSerialsRouteRouteWithChildren,
  AppServiceRouteRoute: AppServiceRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppStockAdjustmentsRouteRoute: AppStockAdjustmentsRouteRouteWithChildren,
  AppStockTransfersRouteRoute: AppStockTransfersRouteRouteWithChildren,
  AppSupplierPaymentsRouteRoute: AppSupplierPaymentsRouteRouteWithChildren,
  AppSupplierRefundsRouteRoute: AppSupplierRefundsRouteRouteWithChildren,
  AppSupplierReturnsRouteRoute: AppSupplierReturnsRouteRouteWithChildren,
  AppSuppliersRouteRoute: AppSuppliersRouteRouteWithChildren,
  AppTasksRouteRoute: AppTasksRouteRouteWithChildren,
  AppTeamsRouteRoute: AppTeamsRouteRouteWithChildren,
  AppUsersRouteRoute: AppUsersRouteRouteWithChildren,
  AppWorkflowsRouteRoute: AppWorkflowsRouteRouteWithChildren,
  AppAccountMappingRoute: AppAccountMappingRoute,
  AppAccountsRoute: AppAccountsRoute,
  AppAuditLogRoute: AppAuditLogRoute,
  AppBalanceSheetRoute: AppBalanceSheetRoute,
  AppBooksHealthRoute: AppBooksHealthRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppCashBankRoute: AppCashBankRoute,
  AppCashFlowRoute: AppCashFlowRoute,
  AppChangePasswordRoute: AppChangePasswordRoute,
  AppCustomerGroupsRoute: AppCustomerGroupsRoute,
  AppExpenseCategoriesRoute: AppExpenseCategoriesRoute,
  AppFiscalYearsRoute: AppFiscalYearsRoute,
  AppGeneralLedgerRoute: AppGeneralLedgerRoute,
  AppLowStockRoute: AppLowStockRoute,
  AppMyWorkRoute: AppMyWorkRoute,
  AppPayablesAgingRoute: AppPayablesAgingRoute,
  AppPosSummaryRoute: AppPosSummaryRoute,
  AppProductAttributesRoute: AppProductAttributesRoute,
  AppProductCategoriesRoute: AppProductCategoriesRoute,
  AppProfitAndLossRoute: AppProfitAndLossRoute,
  AppProjectBudgetVsActualRoute: AppProjectBudgetVsActualRoute,
  AppProjectProfitabilityRoute: AppProjectProfitabilityRoute,
  AppProjectUnbilledWorkRoute: AppProjectUnbilledWorkRoute,
  AppProjectUtilisationRoute: AppProjectUtilisationRoute,
  AppPurchasesByProductRoute: AppPurchasesByProductRoute,
  AppPurchasesBySupplierRoute: AppPurchasesBySupplierRoute,
  AppReceivablesAgingRoute: AppReceivablesAgingRoute,
  AppReportsRoute: AppReportsRoute,
  AppSalesByCustomerRoute: AppSalesByCustomerRoute,
  AppSalesByPeriodRoute: AppSalesByPeriodRoute,
  AppSalesByProductRoute: AppSalesByProductRoute,
  AppSalesBySalespersonRoute: AppSalesBySalespersonRoute,
  AppSalesByUserRoute: AppSalesByUserRoute,
  AppStockRoute: AppStockRoute,
  AppStockMovementsRoute: AppStockMovementsRoute,
  AppStockValuationRoute: AppStockValuationRoute,
  AppSupplierGroupsRoute: AppSupplierGroupsRoute,
  AppTaskReportRoute: AppTaskReportRoute,
  AppTaxRatesRoute: AppTaxRatesRoute,
  AppTransfersRoute: AppTransfersRoute,
  AppTrialBalanceRoute: AppTrialBalanceRoute,
  AppUnitsRoute: AppUnitsRoute,
  AppVatReturnRoute: AppVatReturnRoute,
  AppWarehousesRoute: AppWarehousesRoute,
  AppIndexRoute: AppIndexRoute,
  AppPosShiftsRouteRoute: AppPosShiftsRouteRouteWithChildren,
  AppPosTillsRoute: AppPosTillsRoute,
  AppPosIndexRoute: AppPosIndexRoute,
  AppPosReturnsReturnIdRoute: AppPosReturnsReturnIdRoute,
  AppPosSalesSaleIdRoute: AppPosSalesSaleIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PlatformConsoleRouteChildren {
  PlatformConsoleDashboardRoute: typeof PlatformConsoleDashboardRoute
  PlatformConsoleFeedbackRoute: typeof PlatformConsoleFeedbackRoute
  PlatformConsoleProfileRoute: typeof PlatformConsoleProfileRoute
  PlatformConsoleSubscriptionsRoute: typeof PlatformConsoleSubscriptionsRoute
  PlatformConsoleIndexRoute: typeof PlatformConsoleIndexRoute
  PlatformConsoleTenantsTenantIdRoute: typeof PlatformConsoleTenantsTenantIdRoute
  PlatformConsoleTenantsNewRoute: typeof PlatformConsoleTenantsNewRoute
  PlatformConsoleTenantsIndexRoute: typeof PlatformConsoleTenantsIndexRoute
}

const PlatformConsoleRouteChildren: PlatformConsoleRouteChildren = {
  PlatformConsoleDashboardRoute: PlatformConsoleDashboardRoute,
  PlatformConsoleFeedbackRoute: PlatformConsoleFeedbackRoute,
  PlatformConsoleProfileRoute: PlatformConsoleProfileRoute,
  PlatformConsoleSubscriptionsRoute: PlatformConsoleSubscriptionsRoute,
  PlatformConsoleIndexRoute: PlatformConsoleIndexRoute,
  PlatformConsoleTenantsTenantIdRoute: PlatformConsoleTenantsTenantIdRoute,
  PlatformConsoleTenantsNewRoute: PlatformConsoleTenantsNewRoute,
  PlatformConsoleTenantsIndexRoute: PlatformConsoleTenantsIndexRoute,
}

const PlatformConsoleRouteWithChildren = PlatformConsoleRoute._addFileChildren(
  PlatformConsoleRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PTokenRoute: PTokenRoute,
  PlatformConsoleRoute: PlatformConsoleRouteWithChildren,
  PlatformLoginRoute: PlatformLoginRoute,
  SetPasswordTokenRoute: SetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
